import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /**
   * The `Upload` special type represents a file to be uploaded in the same HTTP request as specified by
   *  [graphql-multipart-request-spec](https://github.com/jaydenseric/graphql-multipart-request-spec).
   */
  Upload: any;
  object: any;
};

export type Activity = {
  __typename?: 'Activity';
  /** Добавлено */
  added?: Maybe<Scalars['String']>;
  /** Администратор */
  adminUser?: Maybe<User>;
  /** Текстовое описание события */
  description?: Maybe<Scalars['String']>;
  /** Ключ типа евента */
  event?: Maybe<Scalars['String']>;
  /** Название типа евента */
  eventName?: Maybe<Scalars['String']>;
  /** Пользователь */
  user?: Maybe<User>;
};


export type ActivityAddedArgs = {
  format?: InputMaybe<Scalars['String']>;
  relative?: InputMaybe<Scalars['Boolean']>;
  timezone?: InputMaybe<Scalars['String']>;
};

export type AddendumExcludeInput = {
  date?: InputMaybe<Scalars['String']>;
  risks?: InputMaybe<Array<Scalars['String']>>;
};

/** Причины аддендума */
export enum AddendumReasonEnum {
  /** Дострахование рисков */
  Add = 'ADD',
  /** Исключение рисков */
  Exclude = 'EXCLUDE',
  /** Перерасчет */
  Recalc = 'RECALC'
}

export type AddendumRecalcInput = {
  annuitet_sum?: InputMaybe<Scalars['Float']>;
  date?: InputMaybe<Scalars['String']>;
  date_end?: InputMaybe<Scalars['String']>;
  months?: InputMaybe<Scalars['Int']>;
  rate?: InputMaybe<Scalars['Int']>;
  sum?: InputMaybe<Scalars['Float']>;
};

/** Адрес */
export type AddressForm = {
  __typename?: 'AddressForm';
  data?: Maybe<Scalars['object']>;
  unrestricted_value?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** Адрес */
export type AddressInput = {
  data?: InputMaybe<Scalars['object']>;
  invalidity?: InputMaybe<Scalars['Boolean']>;
  unrestricted_value?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

export type AgrRole = {
  __typename?: 'AgrRole';
  /** Начало */
  date_beg: Scalars['String'];
  /** Окончание */
  date_end: Scalars['String'];
  /** Контрагент */
  participant: Scalars['String'];
  /** Роль */
  role: Scalars['String'];
};

export type Agreement = {
  __typename?: 'Agreement';
  agent_kv_sum?: Maybe<Scalars['Float']>;
  /** Участники договора */
  agr_role?: Maybe<Array<Maybe<AgrRole>>>;
  agreement_no?: Maybe<Scalars['String']>;
  bank_isn?: Maybe<Scalars['Int']>;
  credit_agreement_date?: Maybe<Scalars['String']>;
  credit_agreement_number?: Maybe<Scalars['String']>;
  credit_annuitet_sum?: Maybe<Scalars['Float']>;
  credit_bank_isn?: Maybe<Scalars['Int']>;
  credit_bank_text?: Maybe<Scalars['String']>;
  credit_months?: Maybe<Scalars['Int']>;
  credit_rate?: Maybe<Scalars['Float']>;
  credit_sum?: Maybe<Scalars['Float']>;
  currency?: Maybe<Scalars['String']>;
  date_begin?: Maybe<Scalars['String']>;
  date_end?: Maybe<Scalars['String']>;
  date_sign?: Maybe<Scalars['String']>;
  /** КВ */
  discount_kv?: Maybe<Scalars['Float']>;
  has_cross_sale: Scalars['Boolean'];
  ins_previous?: Maybe<LabelValueForm>;
  ins_purpose?: Maybe<LabelValueForm>;
  is_declaration: Scalars['Boolean'];
  /** Счет оплачен */
  is_payed?: Maybe<Scalars['Boolean']>;
  /** Риски Жизнь */
  life_risks?: Maybe<Array<Maybe<CalculationRisk>>>;
  policyholder?: Maybe<ContragentForm>;
  /** Итого */
  premium_sum?: Maybe<Scalars['Float']>;
  /** Со скидкой КВ */
  premium_sum_with_kv?: Maybe<Scalars['Float']>;
  /** Риски Имущество */
  property_risks?: Maybe<Array<Maybe<CalculationRisk>>>;
  sale_channel?: Maybe<LabelValueForm>;
  /** Скидка за счет КВ */
  seller_discount_due_kv?: Maybe<Scalars['Float']>;
  /** Риски Титул */
  titul_risks?: Maybe<Array<Maybe<CalculationRisk>>>;
};

export enum AgreementFileContextEnum {
  /** Аттач документов к договору */
  Agreement = 'AGREEMENT',
  /** Аттач документа на этапе анкеты */
  Anketa = 'ANKETA'
}

export type Anketa = {
  __typename?: 'Anketa';
  parts?: Maybe<Array<Maybe<AnketaPart>>>;
};

export type AnketaInfo = {
  __typename?: 'AnketaInfo';
  date: Scalars['String'];
  id: Scalars['String'];
  isn: Scalars['Int'];
  remark?: Maybe<Scalars['String']>;
  result?: Maybe<Scalars['String']>;
};

export type AnketaPart = {
  __typename?: 'AnketaPart';
  key?: Maybe<Scalars['String']>;
  questions?: Maybe<Array<Maybe<AnketaQuestion>>>;
  text?: Maybe<Scalars['String']>;
};

export type AnketaQuestion = {
  __typename?: 'AnketaQuestion';
  dicti?: Maybe<Array<Maybe<IsnNamePair>>>;
  isn?: Maybe<Scalars['Int']>;
  remark?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type AnketaQuestionInput = {
  isn?: InputMaybe<Scalars['Int']>;
  remark?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Банк */
export type Bank = {
  __typename?: 'Bank';
  icon?: Maybe<Scalars['String']>;
  isn: Scalars['String'];
  name: Scalars['String'];
};

/** Форма расчета */
export type CalcForm = {
  __typename?: 'CalcForm';
  /** Шаг 1. Общие сведения о застрахованном лице */
  borrower?: Maybe<ContragentForm>;
  /** Шаг 3. Созаемщики */
  coBorrowers?: Maybe<Array<Maybe<ContragentForm>>>;
  /** Шаг 3. Основные положения кредитного договора */
  credit?: Maybe<CreditForm>;
  /** ID кросс-продажи */
  crossId?: Maybe<Scalars['Int']>;
  /** Скидка по КВ, % */
  discountKv?: Maybe<Scalars['Float']>;
  /** Скидка СК, % */
  discountSk?: Maybe<Scalars['Float']>;
  /** Режим быстрого расчета через декларацию */
  expressMode?: Maybe<Scalars['Boolean']>;
  /** Квартира с тарификацией */
  flat?: Maybe<FlatFormForm>;
  /** Тип страхования */
  insuranceType?: Maybe<Scalars['Int']>;
  /** Готовое жилье */
  isHouseFinished?: Maybe<Scalars['Boolean']>;
  /** Шаг 1. Общие сведения о страхователе */
  policyholder?: Maybe<ContragentForm>;
  /** Шаг 1. Страхователь является заемщиком */
  policyholderIsBorrower?: Maybe<Scalars['Boolean']>;
  precalcResult?: Maybe<Scalars['object']>;
  /** Промокод */
  promocode?: Maybe<Scalars['String']>;
  /** Шаг 4. Страхование имущества от гибели, утраты, повреждения */
  propertyObjects?: Maybe<Array<Maybe<PropertyObjectForm>>>;
  /** Считать риск Жизнь */
  riskLife?: Maybe<Scalars['Boolean']>;
  /** Считать риск Имущество */
  riskProperty?: Maybe<Scalars['Boolean']>;
  /** Считать риск Титул */
  riskTitle?: Maybe<Scalars['Boolean']>;
  /** Текущий этап оформления */
  stage?: Maybe<Scalars['String']>;
  /** Шаг 5. Страхование потери имущества в результате прекращения, ограничения (обременения) права собственности */
  titleObjects?: Maybe<Array<Maybe<TitleObjectForm>>>;
};

/** Форма расчета */
export type CalcFormInput = {
  /** Шаг 1. Общие сведения о застрахованном лице */
  borrower?: InputMaybe<ContragentInput>;
  /** Шаг 3. Созаемщики */
  coBorrowers?: InputMaybe<Array<InputMaybe<ContragentInput>>>;
  /** Шаг 3. Основные положения кредитного договора */
  credit?: InputMaybe<CreditInput>;
  /** ID кросс-продажи */
  crossId?: InputMaybe<Scalars['Int']>;
  /** Скидка по КВ, % */
  discountKv?: InputMaybe<Scalars['Float']>;
  /** Скидка СК, % */
  discountSk?: InputMaybe<Scalars['Float']>;
  /** Режим быстрого расчета через декларацию */
  expressMode?: InputMaybe<Scalars['Boolean']>;
  /** Квартира с тарификацией */
  flat?: InputMaybe<FlatFormInput>;
  /** Тип страхования */
  insuranceType?: InputMaybe<Scalars['Int']>;
  /** Готовое жилье */
  isHouseFinished?: InputMaybe<Scalars['Boolean']>;
  /** Шаг 1. Общие сведения о страхователе */
  policyholder?: InputMaybe<ContragentInput>;
  /** Шаг 1. Страхователь является заемщиком */
  policyholderIsBorrower?: InputMaybe<Scalars['Boolean']>;
  precalcResult?: InputMaybe<Scalars['object']>;
  /** Промокод */
  promocode?: InputMaybe<Scalars['String']>;
  /** Шаг 4. Страхование имущества от гибели, утраты, повреждения */
  propertyObjects?: InputMaybe<Array<InputMaybe<PropertyObjectInput>>>;
  /** Считать риск Жизнь */
  riskLife?: InputMaybe<Scalars['Boolean']>;
  /** Считать риск Имущество */
  riskProperty?: InputMaybe<Scalars['Boolean']>;
  /** Считать риск Титул */
  riskTitle?: InputMaybe<Scalars['Boolean']>;
  /** Текущий этап оформления */
  stage?: InputMaybe<Scalars['String']>;
  /** Шаг 5. Страхование потери имущества в результате прекращения, ограничения (обременения) права собственности */
  titleObjects?: InputMaybe<Array<InputMaybe<TitleObjectInput>>>;
};

export type CalcRisk = {
  __typename?: 'CalcRisk';
  name: Scalars['String'];
  objects?: Maybe<Array<Maybe<CalcRiskObject>>>;
};

export type CalcRiskObject = {
  __typename?: 'CalcRiskObject';
  base_premium_sum?: Maybe<Scalars['Float']>;
  discount?: Maybe<Scalars['Float']>;
  high_tariff_height?: Maybe<Scalars['Float']>;
  high_tariff_press?: Maybe<Scalars['Float']>;
  limit_sum?: Maybe<Scalars['Float']>;
  name: Scalars['String'];
  premium_sum?: Maybe<Scalars['Float']>;
  raising_factor?: Maybe<Scalars['Float']>;
  share?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['String']>;
  tariff?: Maybe<Scalars['Float']>;
};

/** Данные котировки */
export type Calculation = {
  __typename?: 'Calculation';
  agent?: Maybe<Scalars['String']>;
  bank_kv?: Maybe<Scalars['String']>;
  /** Выгодоприобретатель */
  beneficiary?: Maybe<Scalars['String']>;
  /** Срок кредитования, месяцы */
  credit_terms?: Maybe<Scalars['Int']>;
  /** Кросс-риски */
  cross_risks?: Maybe<Array<Maybe<CalculationRisk>>>;
  /** Скидка КВ */
  discount_kv?: Maybe<Scalars['Float']>;
  /** Скидка КВ в рублях */
  discount_kv_sum?: Maybe<Scalars['Float']>;
  /** Редактируемый тариф */
  is_editable_tariff?: Maybe<Scalars['Boolean']>;
  /** Риски Жизнь */
  life_risks?: Maybe<Array<Maybe<CalculationRisk>>>;
  /** Дата рождения */
  policyholder_birthday?: Maybe<Scalars['String']>;
  /** Email */
  policyholder_email?: Maybe<Scalars['String']>;
  /** ФИО Заемщика */
  policyholder_fio?: Maybe<Scalars['String']>;
  /** Итого */
  premium_sum?: Maybe<Scalars['Float']>;
  /** Со скидкой КВ */
  premium_sum_with_kv?: Maybe<Scalars['Float']>;
  /** Программа */
  program?: Maybe<LabelValueForm>;
  /** Риски Имущество */
  property_risks?: Maybe<Array<Maybe<CalculationRisk>>>;
  /** Скидка за счет КВ */
  seller_discount_due_kv?: Maybe<Scalars['Float']>;
  /** Тарифная группа */
  tariff_group?: Maybe<LabelValueForm>;
  /** Риски Титул */
  titul_risks?: Maybe<Array<Maybe<CalculationRisk>>>;
};

/** Риск */
export type CalculationRisk = {
  __typename?: 'CalculationRisk';
  /** Адресс */
  address?: Maybe<Scalars['String']>;
  /** Автоскоринг */
  autoscoring?: Maybe<Scalars['Boolean']>;
  /** Базовая премия */
  base_premium_sum?: Maybe<Scalars['Float']>;
  /** Базовый тариф */
  base_tariff?: Maybe<Scalars['Float']>;
  /** Дата рождения */
  birthday?: Maybe<Scalars['String']>;
  /** Дата окончания титула */
  date_end?: Maybe<Scalars['String']>;
  /** Скидка */
  discount?: Maybe<Scalars['Float']>;
  /** ФИО */
  fio?: Maybe<Scalars['String']>;
  /** Повышающий коэф (рост/вес) */
  high_tariff_height?: Maybe<Scalars['Float']>;
  /** Повышающий коэф давление */
  high_tariff_press?: Maybe<Scalars['Float']>;
  /** ISN риска */
  isn?: Maybe<Scalars['Int']>;
  /** Страховая сумма */
  limit_sum?: Maybe<Scalars['Float']>;
  /** Единовременная оплата */
  one_time_pay?: Maybe<Scalars['Boolean']>;
  /** Постоянная страховая сумма */
  permanent_sum?: Maybe<Scalars['Boolean']>;
  /** Итоговая премия */
  premium_sum?: Maybe<Scalars['Float']>;
  /** Стоимость имущества */
  property_cost?: Maybe<Scalars['Float']>;
  /** Повышающий коэф */
  raising_factor?: Maybe<Scalars['Float']>;
  /** Результат проверки */
  remark?: Maybe<Scalars['String']>;
  /** Доля */
  share?: Maybe<Scalars['Float']>;
  /** Статус */
  status?: Maybe<RiskStatusEnum>;
  /** Тариф */
  tariff?: Maybe<Scalars['Float']>;
  /** Тип */
  type?: Maybe<Scalars['String']>;
  /** Андеррайтинг разрешен */
  underwriting_allowed?: Maybe<Scalars['Boolean']>;
  /** Деревянные конструкции */
  wood_in_construction?: Maybe<Scalars['Boolean']>;
};

export type ChangeAgreementInput = {
  annuitet_sum?: InputMaybe<Scalars['Float']>;
  /** Дата кредитного договора */
  credit_agreement_date?: InputMaybe<Scalars['String']>;
  credit_agreement_number?: InputMaybe<Scalars['String']>;
  credit_months?: InputMaybe<Scalars['Int']>;
  credit_rate?: InputMaybe<Scalars['Float']>;
  credit_sum?: InputMaybe<Scalars['Float']>;
  date_begin?: InputMaybe<Scalars['String']>;
  date_end?: InputMaybe<Scalars['String']>;
  date_sign?: InputMaybe<Scalars['String']>;
  exact_date_end?: InputMaybe<Scalars['String']>;
  ins_previous?: InputMaybe<LabelValueInput>;
  ins_purpose?: InputMaybe<LabelValueInput>;
  lifeRisks?: InputMaybe<Array<InputMaybe<ChangeAgreementRiskInput>>>;
  policyholder?: InputMaybe<ContragentInput>;
  propertyRisks?: InputMaybe<Array<InputMaybe<ChangeAgreementRiskInput>>>;
  sale_channel?: InputMaybe<LabelValueInput>;
  titulRisks?: InputMaybe<Array<InputMaybe<ChangeAgreementRiskInput>>>;
};

export type ChangeAgreementRiskInput = {
  /** Базовый тариф */
  base_tariff?: InputMaybe<Scalars['Float']>;
  /** Скидка */
  discount?: InputMaybe<Scalars['Float']>;
  /** Повышающий коэф (рост/вес) */
  high_tariff_height?: InputMaybe<Scalars['Float']>;
  /** Повышающий коэф давление */
  high_tariff_press?: InputMaybe<Scalars['Float']>;
  /** ISN риска */
  isn?: InputMaybe<Scalars['Int']>;
  /** Единовременная оплата */
  one_time_pay?: InputMaybe<Scalars['Boolean']>;
  /** Постоянная страховая сумма */
  permanent_sum?: InputMaybe<Scalars['Boolean']>;
  /** Повышающий коэф */
  raising_factor?: InputMaybe<Scalars['Float']>;
  /** Игоговый тариф */
  tariff?: InputMaybe<Scalars['Float']>;
  /** Дата окончания титула */
  titul_date_end?: InputMaybe<Scalars['String']>;
};

export type ChangeCalculationInput = {
  /** Программа */
  program?: InputMaybe<LabelValueInput>;
  risks?: InputMaybe<Array<InputMaybe<ChangeCalculationRiskInput>>>;
  /** Тарифная группа */
  tariff_group?: InputMaybe<LabelValueInput>;
};

export type ChangeCalculationRiskInput = {
  /** Базовый тариф */
  base_tariff?: InputMaybe<Scalars['Float']>;
  /** Скидка */
  discount?: InputMaybe<Scalars['Float']>;
  /** Повышающий коэф (рост/вес) */
  high_tariff_height?: InputMaybe<Scalars['Float']>;
  /** Повышающий коэф давление */
  high_tariff_press?: InputMaybe<Scalars['Float']>;
  /** ISN риска */
  isn?: InputMaybe<Scalars['Int']>;
  /** Повышающий коэф */
  raising_factor?: InputMaybe<Scalars['Float']>;
  /** Статус */
  status?: InputMaybe<RiskStatusEnum>;
  /** Итоговый тариф */
  tariff?: InputMaybe<Scalars['Float']>;
};

/** Событие изменения сущности */
export type ChangeEventType = {
  __typename?: 'ChangeEventType';
  /** Комментарий к изменению */
  comment?: Maybe<Scalars['String']>;
  /** Время изменения */
  createdAt?: Maybe<Scalars['String']>;
  /** Измененные поля */
  fields?: Maybe<Array<Maybe<ChangeFieldType>>>;
  /** Пользователь, совершивший изменение */
  user?: Maybe<User>;
};

export type ChangeFieldType = {
  __typename?: 'ChangeFieldType';
  /** Ключ поля */
  field?: Maybe<Scalars['String']>;
  /** Название поля */
  label?: Maybe<Scalars['String']>;
  /** Новое значение */
  newValue?: Maybe<Scalars['String']>;
  /** Старое значение */
  oldValue?: Maybe<Scalars['String']>;
};

/** An example enum */
export enum ChangeLogTableEnum {
  /** Группа */
  Group = 'GROUP',
  /** Ограничения группы */
  RestrictionsForGroup = 'RESTRICTIONS_FOR_GROUP',
  /** Ограничения пользователя */
  RestrictionsForUser = 'RESTRICTIONS_FOR_USER',
  /** Пользователь */
  User = 'USER'
}

/** Комментарий к документу */
export type Comment = {
  __typename?: 'Comment';
  /** Дата */
  date?: Maybe<Scalars['String']>;
  /** ID */
  id: Scalars['Int'];
  /** Новый? */
  isNew?: Maybe<Scalars['Boolean']>;
  /** текст */
  text?: Maybe<Scalars['String']>;
  /** Автор */
  user?: Maybe<User>;
};


/** Комментарий к документу */
export type CommentDateArgs = {
  format?: InputMaybe<Scalars['String']>;
  relative?: InputMaybe<Scalars['Boolean']>;
  timezone?: InputMaybe<Scalars['String']>;
};

/** Типы заполнения контрагента */
export enum ContragentFillingTypeEnum {
  Declaration = 'DECLARATION',
  Online = 'ONLINE',
  Send = 'SEND',
  Upload = 'UPLOAD'
}

/** Форма контрагента */
export type ContragentForm = {
  __typename?: 'ContragentForm';
  /** Фактический адрес */
  actualAddress?: Maybe<AddressForm>;
  /** ID файлов анкеты */
  anketaFileId?: Maybe<Array<Scalars['String']>>;
  /** ISN анкеты */
  anketaIsn?: Maybe<Scalars['Int']>;
  /** Анекта подписана */
  anketaSigned?: Maybe<Scalars['Boolean']>;
  anketas?: Maybe<Array<Maybe<AnketaInfo>>>;
  /** День рождения */
  birthday?: Maybe<Scalars['String']>;
  /** Email */
  email?: Maybe<Scalars['String']>;
  /** Сведения о занятости контрагента */
  employment?: Maybe<EmploymentForm>;
  /** Типы заполнения контрагента */
  fillingType?: Maybe<ContragentFillingTypeEnum>;
  /** ФИО */
  fio?: Maybe<Scalars['String']>;
  /** ISN контрагента */
  isn?: Maybe<Scalars['Int']>;
  /** Гражданство */
  passportCountry?: Maybe<LabelValueForm>;
  /** Код подразделения, где выдан паспорт */
  passportDevisionCode?: Maybe<Scalars['String']>;
  /** Когда выдан пасспорт */
  passportIssueDate?: Maybe<Scalars['String']>;
  /** Кем выдан паспорт */
  passportIssuedBy?: Maybe<Scalars['String']>;
  /** Номер паспорта */
  passportNumber?: Maybe<Scalars['String']>;
  /** Серия паспорта */
  passportSeries?: Maybe<Scalars['String']>;
  /** Телефон */
  phone?: Maybe<Scalars['String']>;
  /** Телефон для создания клиентского кабинета */
  phoneForLk?: Maybe<Scalars['String']>;
  /** Адрес регистрации */
  registrationAddress?: Maybe<AddressForm>;
  /** Адрес регистрации совпадает с фактическим */
  registrationAddressIsActual?: Maybe<Scalars['Boolean']>;
  /** Пол (М/F) */
  sex?: Maybe<Scalars['String']>;
  /** Доля в общем доходе (для созаемщика) */
  share?: Maybe<Scalars['Float']>;
};

/** Контрагент */
export type ContragentInput = {
  /** Фактический адрес */
  actualAddress?: InputMaybe<AddressInput>;
  /** ID файлов анкеты */
  anketaFileId?: InputMaybe<Array<Scalars['String']>>;
  /** ISN анкеты */
  anketaIsn?: InputMaybe<Scalars['Int']>;
  /** Анекта подписана */
  anketaSigned?: InputMaybe<Scalars['Boolean']>;
  /** День рождения */
  birthday?: InputMaybe<Scalars['String']>;
  /** Email */
  email?: InputMaybe<Scalars['String']>;
  /** Сведения о занятости контрагента */
  employment?: InputMaybe<EmploymentInput>;
  /** Типы заполнения контрагента */
  fillingType?: InputMaybe<ContragentFillingTypeEnum>;
  /** ФИО */
  fio?: InputMaybe<Scalars['String']>;
  /** ISN контрагента */
  isn?: InputMaybe<Scalars['Int']>;
  /** Гражданство */
  passportCountry?: InputMaybe<LabelValueInput>;
  /** Код подразделения, где выдан паспорт */
  passportDevisionCode?: InputMaybe<Scalars['String']>;
  /** Когда выдан пасспорт */
  passportIssueDate?: InputMaybe<Scalars['String']>;
  /** Кем выдан паспорт */
  passportIssuedBy?: InputMaybe<Scalars['String']>;
  /** Номер паспорта */
  passportNumber?: InputMaybe<Scalars['String']>;
  /** Серия паспорта */
  passportSeries?: InputMaybe<Scalars['String']>;
  /** Телефон */
  phone?: InputMaybe<Scalars['String']>;
  /** Телефон для создания клиентского кабинета */
  phoneForLk?: InputMaybe<Scalars['String']>;
  /** Адрес регистрации */
  registrationAddress?: InputMaybe<AddressInput>;
  /** Адрес регистрации совпадает с фактическим */
  registrationAddressIsActual?: InputMaybe<Scalars['Boolean']>;
  /** Пол (М/F) */
  sex?: InputMaybe<Scalars['String']>;
  /** Доля в общем доходе (для созаемщика) */
  share?: InputMaybe<Scalars['Float']>;
};

export type CreditForm = {
  __typename?: 'CreditForm';
  /** Добавить агента */
  agent?: Maybe<LabelValueForm>;
  /** Наименование кредитной организации */
  bank?: Maybe<LabelValueForm>;
  birthDateMethod?: Maybe<LabelValueForm>;
  /** Доля заемщика */
  borrowerShare?: Maybe<Scalars['Float']>;
  /** Населенный пункт сделки */
  city?: Maybe<AddressForm>;
  /** Номер кредитного договора */
  creditAgreementNumber?: Maybe<Scalars['String']>;
  /** Дата выдачи кредита */
  creditIssueDate?: Maybe<Scalars['String']>;
  /** Годовая процентная ставка по кредиту */
  creditRate?: Maybe<Scalars['Float']>;
  /** Размер кредита */
  creditSum?: Maybe<Scalars['Float']>;
  /** Срок кредитования (месяцы) */
  creditTerms?: Maybe<Scalars['Int']>;
  /** Начало действия полиса */
  dateBegin?: Maybe<Scalars['String']>;
  /** Точная дата окончания */
  dateExactEnd?: Maybe<Scalars['String']>;
  /** Дата первого платежа */
  firstPayDate?: Maybe<Scalars['String']>;
  /** Тип страхования */
  insuranceType?: Maybe<Scalars['Int']>;
  marketing?: Maybe<LabelValueForm>;
  periodTypeChoose?: Maybe<Scalars['String']>;
  /** Предыдущая страховая компания */
  prevSk?: Maybe<LabelValueForm>;
  renewReason?: Maybe<LabelValueForm>;
  renewReasonOther?: Maybe<Scalars['String']>;
  /** Канал продаж */
  salesChannel?: Maybe<LabelValueForm>;
};

export type CreditInput = {
  /** Добавить агента */
  agent?: InputMaybe<LabelValueInput>;
  /** Наименование кредитной организации */
  bank?: InputMaybe<LabelValueInput>;
  birthDateMethod?: InputMaybe<LabelValueInput>;
  /** Доля заемщика */
  borrowerShare?: InputMaybe<Scalars['Float']>;
  /** Населенный пункт сделки */
  city?: InputMaybe<AddressInput>;
  /** Номер кредитного договора */
  creditAgreementNumber?: InputMaybe<Scalars['String']>;
  /** Дата выдачи кредита */
  creditIssueDate?: InputMaybe<Scalars['String']>;
  /** Годовая процентная ставка по кредиту */
  creditRate?: InputMaybe<Scalars['Float']>;
  /** Размер кредита */
  creditSum?: InputMaybe<Scalars['Float']>;
  /** Срок кредитования (месяцы) */
  creditTerms?: InputMaybe<Scalars['Int']>;
  /** Начало действия полиса */
  dateBegin?: InputMaybe<Scalars['String']>;
  /** Точная дата окончания */
  dateExactEnd?: InputMaybe<Scalars['String']>;
  /** Дата первого платежа */
  firstPayDate?: InputMaybe<Scalars['String']>;
  /** Тип страхования */
  insuranceType?: InputMaybe<Scalars['Int']>;
  marketing?: InputMaybe<LabelValueInput>;
  periodTypeChoose?: InputMaybe<Scalars['String']>;
  /** Предыдущая страховая компания */
  prevSk?: InputMaybe<LabelValueInput>;
  renewReason?: InputMaybe<LabelValueInput>;
  renewReasonOther?: InputMaybe<Scalars['String']>;
  /** Канал продаж */
  salesChannel?: InputMaybe<LabelValueInput>;
};

export type CrossDetails = {
  __typename?: 'CrossDetails';
  /** Адрес */
  address?: Maybe<Scalars['String']>;
  /** Внутренняя отделка */
  interior?: Maybe<Scalars['Float']>;
  /** Движимое имущество */
  property?: Maybe<Scalars['Float']>;
  /** Гражданская ответственность */
  responsibility?: Maybe<Scalars['Float']>;
  /** Страховая сумма */
  sum?: Maybe<Scalars['Float']>;
};

export type CrossSale = {
  __typename?: 'CrossSale';
  /** Дата начала */
  begin?: Maybe<Scalars['String']>;
  /** Дата окончания */
  end?: Maybe<Scalars['String']>;
  /** Номер */
  number?: Maybe<Scalars['String']>;
  premium_sum?: Maybe<Scalars['Float']>;
  /** Подписано */
  sign?: Maybe<Scalars['String']>;
};

/** Дашбоард */
export type DashboardSection = {
  __typename?: 'DashboardSection';
  /** agreements */
  agreements?: Maybe<Array<Maybe<DashboardType>>>;
  /** requests */
  contracts?: Maybe<Array<Maybe<DashboardType>>>;
};

/** Данные по статусу */
export type DashboardType = {
  __typename?: 'DashboardType';
  /** Количество */
  count: Scalars['Int'];
  status: Scalars['String'];
};

/** Ключ справочника */
export enum DictKeyEnum {
  /** Список агентов */
  Agentlist = 'AGENTLIST',
  /** Справочник видов договора */
  AgreementTypes = 'AGREEMENT_TYPES',
  /** Справочник сигнализаций */
  Alarms = 'ALARMS',
  /** Справочник стран */
  Countries = 'COUNTRIES',
  /** Справочник банков-партнеров */
  CreditBank = 'CREDIT_BANK',
  /** Справочник программ банков-партнеров */
  CreditBankProgram = 'CREDIT_BANK_PROGRAM',
  CrossaleInterior = 'CROSSALE_INTERIOR',
  CrossaleResponsibility = 'CROSSALE_RESPONSIBILITY',
  CrosssaleProperty = 'CROSSSALE_PROPERTY',
  /** Справочник валют */
  Currency = 'CURRENCY',
  /** Справочник застройщиков */
  Developers = 'DEVELOPERS',
  /** Справочник источников открытого огня */
  FireSources = 'FIRE_SOURCES',
  /** Справочник материалов перекрытий */
  FloorMaterial = 'FLOOR_MATERIAL',
  /** Cправочник тарифных групп */
  Group = 'GROUP',
  /** Справочник отраслей */
  Industries = 'INDUSTRIES',
  /** Справочник типов работы */
  JobPlace = 'JOB_PLACE',
  Marketing = 'MARKETING',
  /** Справочник запрещенных паролей */
  Passwords = 'PASSWORDS',
  /** Справочник страховых компаний при переходе из иной СК */
  PrevSk = 'PREV_SK',
  /** Профессии */
  Profession = 'PROFESSION',
  /** Cправочник программ по ипотеке */
  Program = 'PROGRAM',
  /** Справочник типов имущества (предмета залога) */
  PropertyType = 'PROPERTY_TYPE',
  /** Справочник назначений */
  Purpose = 'PURPOSE',
  /** Справочник причин возобновления */
  RenewReasons = 'RENEW_REASONS',
  /** Справочник факторов риска */
  RiskFactors = 'RISK_FACTORS',
  /** Группы риска */
  RiskGroup = 'RISK_GROUP',
  /** Справочник каналов продаж */
  SaleChannel = 'SALE_CHANNEL',
  /** Справочник материалов стен */
  WallMaterial = 'WALL_MATERIAL'
}

/** КИАС документ в B2B */
export type Doc = {
  __typename?: 'Doc';
  /** Лог активности */
  activity_log?: Maybe<Array<Maybe<Activity>>>;
  /** Добавлен */
  added?: Maybe<Scalars['String']>;
  /** Данные договора */
  agreement?: Maybe<Agreement>;
  agreementAnketaEdit?: Maybe<Scalars['Boolean']>;
  agreementAnketaIsn?: Maybe<Scalars['Int']>;
  agreementDeclarationDone?: Maybe<Scalars['Boolean']>;
  /** Просмотр анкеты */
  anketa?: Maybe<Array<Maybe<ViewAnketaPart>>>;
  /** Название банка */
  bankName?: Maybe<Scalars['String']>;
  /** Форма расчета */
  calcForm?: Maybe<CalcForm>;
  /** Данные котировки */
  calculation?: Maybe<Calculation>;
  /** Коментарии */
  comments?: Maybe<Array<Maybe<Comment>>>;
  createAgreementAvailable?: Maybe<Scalars['Boolean']>;
  /** Сумма кредита */
  creditSumm?: Maybe<Scalars['Float']>;
  crossDetails?: Maybe<CrossDetails>;
  crossSale?: Maybe<CrossSale>;
  declarationAvailable?: Maybe<Scalars['Boolean']>;
  /** Подзаголовок для черновика */
  draftSubtitle?: Maybe<Scalars['String']>;
  /** Изменен */
  edited?: Maybe<Scalars['String']>;
  /** Редактировал */
  editor?: Maybe<User>;
  /** Файлы, прикрепленные к заявке */
  files?: Maybe<Array<Maybe<File>>>;
  fillingType?: Maybe<Scalars['String']>;
  fillingTypeText?: Maybe<Scalars['String']>;
  /** Объект по полису */
  flatObject?: Maybe<Scalars['String']>;
  /** Сумма по полису */
  flatPremiumSum?: Maybe<Scalars['Float']>;
  /** Риски по полису */
  flatRisks?: Maybe<Scalars['String']>;
  /** Группа пользователя со всеми родительскими группами */
  groupPath?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** ID */
  id: Scalars['Int'];
  /** Заемщик */
  insurerName?: Maybe<Scalars['String']>;
  invoices: Array<Invoice>;
  isAddendumMode?: Maybe<Scalars['Boolean']>;
  /** Текущий период оплачен */
  isCurrentPeriodPayed?: Maybe<Scalars['Boolean']>;
  isExpressMode?: Maybe<Scalars['Boolean']>;
  /** Документ создан через пролонгацию */
  isProlongation?: Maybe<Scalars['Boolean']>;
  /** ISN в КИАС */
  isn?: Maybe<Scalars['String']>;
  /** isnInvoice */
  isnInvoice?: Maybe<Scalars['String']>;
  /** Требуется ли пролонгация */
  needProlongation?: Maybe<Scalars['Boolean']>;
  /** INS следующего договора (при пролонгации) */
  nextAgreementIsn?: Maybe<Scalars['String']>;
  /** Разрешено получение следующего счета */
  nextInvoiceAllowed?: Maybe<Scalars['Boolean']>;
  /** Сумма для оплаты следующего периода */
  nextInvoiceSum?: Maybe<Scalars['Float']>;
  /** Номер */
  number?: Maybe<Scalars['String']>;
  prevAgreementAnketaIsn?: Maybe<Scalars['Int']>;
  /** ID предыдущего договора (при пролонгации) */
  prevAgreementId?: Maybe<Scalars['Int']>;
  /** INS предыдущего договора (при пролонгации) */
  prevAgreementIsn?: Maybe<Scalars['String']>;
  /** Тип продукта */
  product?: Maybe<Scalars['Int']>;
  readyToSign?: Maybe<Scalars['Boolean']>;
  /** Для котировки возвращает id связанного с ней договора */
  relatedAgreementId?: Maybe<Scalars['Int']>;
  /** Для договора возвращает id связанной с ним котировки */
  relatedCalculationId?: Maybe<Scalars['Int']>;
  resultDocuments: Array<ResultDocument>;
  /** Риски документа */
  risks?: Maybe<Array<Maybe<CalcRisk>>>;
  showFields?: Maybe<Array<Scalars['String']>>;
  /** Статус */
  status?: Maybe<Status>;
  steps?: Maybe<Array<Scalars['String']>>;
  subAgreements?: Maybe<Array<Maybe<SubAgreement>>>;
  /** Тип */
  type?: Maybe<DocTypeEnum>;
  underwriters?: Maybe<Array<Maybe<User>>>;
  /** Автор */
  user?: Maybe<User>;
};


/** КИАС документ в B2B */
export type DocAddedArgs = {
  format?: InputMaybe<Scalars['String']>;
  relative?: InputMaybe<Scalars['Boolean']>;
  timezone?: InputMaybe<Scalars['String']>;
};


/** КИАС документ в B2B */
export type DocEditedArgs = {
  format?: InputMaybe<Scalars['String']>;
  relative?: InputMaybe<Scalars['Boolean']>;
  timezone?: InputMaybe<Scalars['String']>;
};

export type DocFilterInput = {
  /** Отбор по isn банков */
  banks?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Отбор по типам заполнения */
  fillingTypes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Отбор по группам */
  groups?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Период */
  period?: InputMaybe<PeriodInput>;
  /** Отбор по ISN статуса */
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Текстовый поиск */
  text?: InputMaybe<Scalars['String']>;
};

export type DocPagination = {
  __typename?: 'DocPagination';
  /** Current page of the cursor */
  current_page: Scalars['Int'];
  /** List of items on the current page */
  data?: Maybe<Array<Maybe<Doc>>>;
  /** Number of the first item returned */
  from?: Maybe<Scalars['Int']>;
  /** Determines if cursor has more pages after the current page */
  has_more_pages: Scalars['Boolean'];
  /** The last page (number of pages) */
  last_page: Scalars['Int'];
  /** Number of items returned per page */
  per_page: Scalars['Int'];
  /** Number of the last item returned */
  to?: Maybe<Scalars['Int']>;
  /** Number of total items selected by the query */
  total: Scalars['Int'];
};

/** Типы заявок */
export enum DocTypeEnum {
  /** Договор */
  Agreement = 'AGREEMENT',
  /** Назначенные мне */
  AssignedToMe = 'ASSIGNED_TO_ME',
  /** Заявка */
  Calculation = 'CALCULATION',
  /** Пролонгация */
  Prolongation = 'PROLONGATION',
  /** Андеррайтинг */
  Underwriting = 'UNDERWRITING'
}

/** Сведения о занятости страхователя */
export type EmploymentForm = {
  __typename?: 'EmploymentForm';
  /** Офисный сотрудник? */
  isOfficeWorker?: Maybe<Scalars['Boolean']>;
  /** Является военнослужащим(ей) */
  isSoldier?: Maybe<Scalars['Boolean']>;
  /** Адрес регистрации организации */
  jobAddress?: Maybe<AddressForm>;
  /** Место работы */
  jobPlace?: Maybe<LabelValueForm>;
  /** Сфера деятельности организации */
  organizationActivity?: Maybe<LabelValueForm>;
  /** Наименование организации */
  organizationName?: Maybe<AddressForm>;
  /** Должность */
  position?: Maybe<Scalars['String']>;
  profession?: Maybe<LabelValueForm>;
  riskGroup?: Maybe<LabelValueForm>;
  /** Причина отсутствия работы */
  whyNoJob?: Maybe<Scalars['String']>;
};

/** Сведения о занятости страхователя */
export type EmploymentInput = {
  /** Офисный сотрудник? */
  isOfficeWorker?: InputMaybe<Scalars['Boolean']>;
  /** Является военнослужащим(ей) */
  isSoldier?: InputMaybe<Scalars['Boolean']>;
  /** Адрес регистрации организации */
  jobAddress?: InputMaybe<AddressInput>;
  /** Место работы */
  jobPlace?: InputMaybe<LabelValueInput>;
  /** Сфера деятельности организации */
  organizationActivity?: InputMaybe<LabelValueInput>;
  /** Наименование организации */
  organizationName?: InputMaybe<AddressInput>;
  /** Должность */
  position?: InputMaybe<Scalars['String']>;
  profession?: InputMaybe<LabelValueInput>;
  riskGroup?: InputMaybe<LabelValueInput>;
  /** Причина отсутствия работы */
  whyNoJob?: InputMaybe<Scalars['String']>;
};

/** Файл для скачивания */
export type File = {
  __typename?: 'File';
  filename: Scalars['String'];
  id: Scalars['String'];
  url: Scalars['String'];
};

export type FlatCalcResultDetailType = {
  __typename?: 'FlatCalcResultDetailType';
  limit_sum?: Maybe<Scalars['Float']>;
  name?: Maybe<Scalars['String']>;
  premium_sum?: Maybe<Scalars['Float']>;
};

/** Результат расчета квартиры */
export type FlatCalcResultType = {
  __typename?: 'FlatCalcResultType';
  /** Детали расчета */
  details?: Maybe<Array<Maybe<FlatCalcResultDetailType>>>;
  isn?: Maybe<Scalars['String']>;
  limit_sum?: Maybe<Scalars['Float']>;
  number?: Maybe<Scalars['String']>;
  /** Старая сумма премии */
  old_premium_sum?: Maybe<Scalars['Float']>;
  premium_sum?: Maybe<Scalars['Float']>;
};

export type FlatFormForm = {
  __typename?: 'FlatFormForm';
  /** Адрес */
  address?: Maybe<AddressForm>;
  /** Совпадает ли адрес с адресом страхователя */
  address_match?: Maybe<Scalars['Boolean']>;
  /** Пожарная сигнализация */
  alarm_fire?: Maybe<Scalars['Boolean']>;
  /** Охранная сигнализация */
  alarm_security?: Maybe<Scalars['Boolean']>;
  /** Площадь квартиры */
  area?: Maybe<Scalars['Float']>;
  /** Год постройки */
  build_year?: Maybe<Scalars['Int']>;
  /** Гражданская ответственность */
  civil_responsibility?: Maybe<Scalars['Float']>;
  /** Дата начала действия полиса */
  date_begin?: Maybe<Scalars['String']>;
  /** Отделка */
  finishing?: Maybe<Scalars['Float']>;
  /** Сигнализация о протечках */
  leakage_protection?: Maybe<Scalars['Boolean']>;
  /** Аренда */
  lease?: Maybe<Scalars['Boolean']>;
  /** Движимое имущество */
  movable_property?: Maybe<Scalars['Float']>;
  /** Старая сумма премии */
  old_premium_sum?: Maybe<Scalars['Float']>;
  /** Страхователь */
  policy_holder?: Maybe<ContragentForm>;
  precalcResult?: Maybe<Scalars['object']>;
  /** Сумма премии */
  premium_sum?: Maybe<Scalars['Float']>;
  /** Промокод */
  promo_code?: Maybe<Scalars['String']>;
  /** Регистрировать договор */
  register?: Maybe<Scalars['Boolean']>;
  /** Ремонт */
  renovation?: Maybe<Scalars['Boolean']>;
  /** Количество комнат */
  rooms_count?: Maybe<Scalars['Int']>;
  /** Скидка за счёт КВ, % */
  seller_discount_due_kv?: Maybe<Scalars['Float']>;
  /** Несущие конструкции */
  structural_elements?: Maybe<Scalars['Float']>;
};

/** Форма квартиры */
export type FlatFormInput = {
  /** Адрес */
  address?: InputMaybe<AddressInput>;
  /** Совпадает ли адрес с адресом страхователя */
  address_match?: InputMaybe<Scalars['Boolean']>;
  /** Пожарная сигнализация */
  alarm_fire?: InputMaybe<Scalars['Boolean']>;
  /** Охранная сигнализация */
  alarm_security?: InputMaybe<Scalars['Boolean']>;
  /** Площадь квартиры */
  area?: InputMaybe<Scalars['Float']>;
  /** Год постройки */
  build_year?: InputMaybe<Scalars['Int']>;
  /** Гражданская ответственность */
  civil_responsibility?: InputMaybe<Scalars['Float']>;
  /** Дата начала действия полиса */
  date_begin?: InputMaybe<Scalars['String']>;
  /** Отделка */
  finishing?: InputMaybe<Scalars['Float']>;
  /** Сигнализация о протечках */
  leakage_protection?: InputMaybe<Scalars['Boolean']>;
  /** Аренда */
  lease?: InputMaybe<Scalars['Boolean']>;
  /** Движимое имущество */
  movable_property?: InputMaybe<Scalars['Float']>;
  /** Старая сумма премии */
  old_premium_sum?: InputMaybe<Scalars['Float']>;
  /** Страхователь */
  policy_holder?: InputMaybe<ContragentInput>;
  precalcResult?: InputMaybe<Scalars['object']>;
  /** Сумма премии */
  premium_sum?: InputMaybe<Scalars['Float']>;
  /** Промокод */
  promo_code?: InputMaybe<Scalars['String']>;
  /** Регистрировать договор */
  register?: InputMaybe<Scalars['Boolean']>;
  /** Ремонт */
  renovation?: InputMaybe<Scalars['Boolean']>;
  /** Количество комнат */
  rooms_count?: InputMaybe<Scalars['Int']>;
  /** Скидка за счёт КВ, % */
  seller_discount_due_kv?: InputMaybe<Scalars['Float']>;
  /** Несущие конструкции */
  structural_elements?: InputMaybe<Scalars['Float']>;
};

export type Group = {
  __typename?: 'Group';
  curator?: Maybe<User>;
  email?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  is_filial?: Maybe<Scalars['Boolean']>;
  leader?: Maybe<User>;
  /** Название группы */
  name: Scalars['String'];
  /** Родительская группа */
  parent?: Maybe<Group>;
  /** ID родительской группы */
  parent_id?: Maybe<Scalars['Int']>;
  restrictions?: Maybe<Array<Maybe<Restriction>>>;
};

/** Форма группы */
export type GroupInput = {
  curator_id?: InputMaybe<Scalars['Int']>;
  email?: InputMaybe<Scalars['String']>;
  leader_id?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
  parent_id?: InputMaybe<Scalars['Int']>;
};

/** Счет */
export type Invoice = {
  __typename?: 'Invoice';
  agreementIsn?: Maybe<Scalars['Int']>;
  agreementNo?: Maybe<Scalars['String']>;
  invoiceCaption?: Maybe<Scalars['String']>;
  invoiceIsn?: Maybe<Scalars['Int']>;
  invoiceNo?: Maybe<Scalars['String']>;
  invoiceSum?: Maybe<Scalars['Float']>;
  isAlreadyPayed?: Maybe<Scalars['Boolean']>;
  summName?: Maybe<Scalars['String']>;
  types: Array<IsnNamePair>;
};

/** Строка справочника (isn, name) */
export type IsnNamePair = {
  __typename?: 'IsnNamePair';
  extra?: Maybe<Scalars['object']>;
  isn: Scalars['String'];
  name: Scalars['String'];
};

/** Значение селекта */
export type LabelValueForm = {
  __typename?: 'LabelValueForm';
  label: Scalars['String'];
  value: Scalars['String'];
};

export type LabelValueInput = {
  extra?: InputMaybe<Scalars['object']>;
  label?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

export type MeInfoType = {
  __typename?: 'MeInfoType';
  /** Администратор */
  adminUser?: Maybe<User>;
  /** Пользователь */
  user?: Maybe<User>;
};

export type Message = {
  __typename?: 'Message';
  id: Scalars['Int'];
  /** Текст сообщения */
  text: Scalars['String'];
};

export type Mutation = {
  __typename?: 'Mutation';
  /** Добавление файлов к заявке */
  addAgreementFiles?: Maybe<Array<File>>;
  addendum?: Maybe<Scalars['Boolean']>;
  /** Черновик из договора */
  agreementToDraft?: Maybe<Scalars['Int']>;
  /** Аннулировать заявку */
  annulAgreement?: Maybe<Scalars['Boolean']>;
  applyKv?: Maybe<Scalars['Boolean']>;
  assignAgreement?: Maybe<Scalars['Boolean']>;
  calculateAgreement?: Maybe<Scalars['Int']>;
  calculateAgreementFinish?: Maybe<Scalars['Int']>;
  changeAgreement?: Maybe<Scalars['Boolean']>;
  changeCalculation?: Maybe<Scalars['Boolean']>;
  /** Добавляет комментарий к документу */
  comment?: Maybe<Comment>;
  /** Создать котировку из анкеты */
  continueWithAnketa?: Maybe<Scalars['Int']>;
  /** Копировать анкету для пролонгации */
  copyAnketaForAgreement?: Maybe<Scalars['Int']>;
  /** Создание заявки из precalcIsn, возвращает id заявки */
  createAgreement?: Maybe<Scalars['String']>;
  /** Подготовить отчет */
  createReport?: Maybe<File>;
  /** Кросс-продажа защиты ипотеки */
  cross?: Maybe<Scalars['Int']>;
  /** Удаление заявки */
  deleteAgreement?: Maybe<Scalars['Boolean']>;
  /** Удаление группы */
  deleteGroup?: Maybe<Scalars['Boolean']>;
  /** Удаление роли */
  deleteRole?: Maybe<Scalars['Boolean']>;
  /** Удаление пользователя */
  deleteUser?: Maybe<Scalars['Boolean']>;
  /** A mutation */
  disapprove?: Maybe<Scalars['Boolean']>;
  /** Скачать все документы */
  downloadAll?: Maybe<File>;
  /** Включить режим допсоглашения */
  enterAddendumMode?: Maybe<Scalars['Int']>;
  /** Создать/изменить группу */
  group?: Maybe<Group>;
  logout?: Maybe<Scalars['Boolean']>;
  /** A mutation */
  markMessage?: Maybe<Scalars['Boolean']>;
  mock?: Maybe<Scalars['Int']>;
  password?: Maybe<User>;
  /** Предварительный расчет */
  precalc?: Maybe<Array<Maybe<PrecalcResult>>>;
  /** Выставить счет */
  prepareInvoice?: Maybe<Scalars['Boolean']>;
  /** Подготовить печать документа/договора/котировки */
  print?: Maybe<File>;
  /** Подготовить файл данных экспресс-котировки */
  printExpressCalculation?: Maybe<File>;
  /** Подготовить печать счета */
  printInvoice?: Maybe<File>;
  /** Пролонгировать договор */
  prolong?: Maybe<Scalars['Int']>;
  /** Регистрирует договор и возвращает id заявки */
  registerAgreement?: Maybe<Scalars['Int']>;
  /** Забыть риски кросс-продажи */
  removeCross?: Maybe<Scalars['Int']>;
  /** Устанавливает ограничения для пользователя */
  restrictions?: Maybe<Array<Maybe<Scalars['object']>>>;
  /** Создать/изменить роль */
  role?: Maybe<Role>;
  /** Сохранение заявки, возвращает id заявки */
  saveAgreement?: Maybe<Scalars['String']>;
  saveAnketa?: Maybe<ContragentForm>;
  /** Сохранение квартиры, возвращает id квартиры */
  saveFlat?: Maybe<FlatCalcResultType>;
  searchAgreement?: Maybe<Scalars['object']>;
  sendAnketaSms?: Maybe<Scalars['String']>;
  /** Отправк текстового заявления */
  sendDeclarationText?: Maybe<Scalars['Boolean']>;
  /** Отправка ссылки для оплаты */
  sendPaymentLink?: Maybe<Scalars['String']>;
  sendToSb?: Maybe<Scalars['Boolean']>;
  /** A mutation */
  signAgreement?: Maybe<Scalars['Boolean']>;
  signAnketa?: Maybe<Scalars['String']>;
  signIn?: Maybe<User>;
  signInAs?: Maybe<User>;
  /** A mutation */
  unsignAgreement?: Maybe<Scalars['Boolean']>;
  updateContragentFilling?: Maybe<Scalars['Boolean']>;
  uploadFiles?: Maybe<Scalars['Boolean']>;
  /** Создать/измененить пользователя */
  user?: Maybe<Scalars['String']>;
  /** Помечает комментарии прочитаными текущим пользователем */
  viewComment?: Maybe<Scalars['Boolean']>;
};


export type MutationAddAgreementFilesArgs = {
  agreement_id: Scalars['Int'];
  context: AgreementFileContextEnum;
  files?: InputMaybe<Array<InputMaybe<Scalars['Upload']>>>;
};


export type MutationAddendumArgs = {
  exclude?: InputMaybe<AddendumExcludeInput>;
  id: Scalars['Int'];
  reason: AddendumReasonEnum;
  recalc?: InputMaybe<AddendumRecalcInput>;
};


export type MutationAgreementToDraftArgs = {
  cancelCurrent?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['Int'];
};


export type MutationAnnulAgreementArgs = {
  id: Scalars['Int'];
};


export type MutationApplyKvArgs = {
  id: Scalars['Int'];
  kv: Scalars['Float'];
};


export type MutationAssignAgreementArgs = {
  id: Scalars['Int'];
};


export type MutationCalculateAgreementArgs = {
  id: Scalars['Int'];
};


export type MutationCalculateAgreementFinishArgs = {
  id: Scalars['Int'];
};


export type MutationChangeAgreementArgs = {
  id?: InputMaybe<Scalars['Int']>;
  input?: InputMaybe<ChangeAgreementInput>;
};


export type MutationChangeCalculationArgs = {
  id?: InputMaybe<Scalars['Int']>;
  input?: InputMaybe<ChangeCalculationInput>;
};


export type MutationCommentArgs = {
  id: Scalars['Int'];
  text: Scalars['String'];
};


export type MutationContinueWithAnketaArgs = {
  anketaIsn: Scalars['Int'];
  id: Scalars['Int'];
};


export type MutationCopyAnketaForAgreementArgs = {
  anketaIsn: Scalars['Int'];
  forEdit?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['Int'];
};


export type MutationCreateAgreementArgs = {
  precalcIsn: Scalars['String'];
};


export type MutationCreateReportArgs = {
  dateBeg?: InputMaybe<Scalars['String']>;
  dateEnd?: InputMaybe<Scalars['String']>;
  frontNodeIsn?: InputMaybe<Scalars['Int']>;
  reportType?: InputMaybe<Scalars['String']>;
};


export type MutationCrossArgs = {
  date_sign?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  interior?: InputMaybe<Scalars['Float']>;
  isn?: InputMaybe<Scalars['Int']>;
  property?: InputMaybe<Scalars['Float']>;
  register?: InputMaybe<Scalars['Boolean']>;
  responsibility?: InputMaybe<Scalars['Float']>;
};


export type MutationDeleteAgreementArgs = {
  id: Scalars['Int'];
};


export type MutationDeleteGroupArgs = {
  id: Scalars['Int'];
};


export type MutationDeleteRoleArgs = {
  id: Scalars['Int'];
};


export type MutationDeleteUserArgs = {
  id: Scalars['Int'];
};


export type MutationDisapproveArgs = {
  id?: InputMaybe<Scalars['Int']>;
  risk_isns?: InputMaybe<Array<Scalars['Int']>>;
};


export type MutationDownloadAllArgs = {
  id?: InputMaybe<Scalars['Int']>;
};


export type MutationEnterAddendumModeArgs = {
  id: Scalars['Int'];
  life?: InputMaybe<Scalars['Boolean']>;
  property?: InputMaybe<Scalars['Boolean']>;
  titul?: InputMaybe<Scalars['Boolean']>;
};


export type MutationGroupArgs = {
  id?: InputMaybe<Scalars['Int']>;
  input?: InputMaybe<GroupInput>;
};


export type MutationMarkMessageArgs = {
  id: Scalars['Int'];
};


export type MutationMockArgs = {
  key: Scalars['String'];
};


export type MutationPasswordArgs = {
  new_password: Scalars['String'];
  old_password: Scalars['String'];
};


export type MutationPrecalcArgs = {
  precalcForm?: InputMaybe<PreCalcFormInput>;
};


export type MutationPrepareInvoiceArgs = {
  id: Scalars['Int'];
  isn?: InputMaybe<Scalars['Int']>;
};


export type MutationPrintArgs = {
  contragentIsn?: InputMaybe<Scalars['Int']>;
  email?: InputMaybe<Scalars['String']>;
  isn: Scalars['Int'];
  subject?: InputMaybe<Scalars['String']>;
  template?: InputMaybe<PrintTemplateEnum>;
  templateIsn?: InputMaybe<Scalars['Int']>;
  type: PrintTypeEnum;
};


export type MutationPrintExpressCalculationArgs = {
  isn?: InputMaybe<Array<Scalars['String']>>;
};


export type MutationPrintInvoiceArgs = {
  id: Scalars['Int'];
  invoiceIsn?: InputMaybe<Scalars['Int']>;
  templateIsn: Scalars['Int'];
};


export type MutationProlongArgs = {
  agent?: InputMaybe<LabelValueInput>;
  date_sign?: InputMaybe<Scalars['String']>;
  isn: Scalars['String'];
  sum?: InputMaybe<Scalars['Float']>;
};


export type MutationRegisterAgreementArgs = {
  id: Scalars['Int'];
};


export type MutationRemoveCrossArgs = {
  id: Scalars['Int'];
};


export type MutationRestrictionsArgs = {
  comment?: InputMaybe<Scalars['String']>;
  group_id?: InputMaybe<Scalars['String']>;
  restrictions?: InputMaybe<Array<InputMaybe<RestrictionInput>>>;
  user_id?: InputMaybe<Scalars['String']>;
};


export type MutationRoleArgs = {
  id?: InputMaybe<Scalars['Int']>;
  input?: InputMaybe<RoleInput>;
};


export type MutationSaveAgreementArgs = {
  calcForm?: InputMaybe<CalcFormInput>;
  fromPrecalc?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  product?: InputMaybe<Scalars['Int']>;
};


export type MutationSaveAnketaArgs = {
  contragentIsn: Scalars['Int'];
  id: Scalars['Int'];
  questions?: InputMaybe<Scalars['object']>;
};


export type MutationSaveFlatArgs = {
  calcForm?: InputMaybe<FlatFormInput>;
  doCalc?: InputMaybe<Scalars['Boolean']>;
  doRegister?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
};


export type MutationSearchAgreementArgs = {
  number: Scalars['String'];
};


export type MutationSendAnketaSmsArgs = {
  contragentIsn: Scalars['Int'];
  id: Scalars['Int'];
  isDeclaration?: InputMaybe<Scalars['Boolean']>;
};


export type MutationSendDeclarationTextArgs = {
  email?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};


export type MutationSendPaymentLinkArgs = {
  agreementIsn: Scalars['Int'];
  agreementNo?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  isSendFinish?: InputMaybe<Scalars['Boolean']>;
  phone?: InputMaybe<Scalars['String']>;
  premiumSum?: InputMaybe<Scalars['Float']>;
};


export type MutationSendToSbArgs = {
  id: Scalars['Int'];
  input?: InputMaybe<SendToSbInput>;
};


export type MutationSignAgreementArgs = {
  id?: InputMaybe<Scalars['Int']>;
};


export type MutationSignAnketaArgs = {
  code: Scalars['String'];
  contragentIsn: Scalars['Int'];
  id: Scalars['Int'];
  isDeclaration?: InputMaybe<Scalars['Boolean']>;
};


export type MutationSignInArgs = {
  isClient?: InputMaybe<Scalars['Boolean']>;
  password: Scalars['String'];
  username: Scalars['String'];
};


export type MutationSignInAsArgs = {
  id: Scalars['Int'];
};


export type MutationUnsignAgreementArgs = {
  id?: InputMaybe<Scalars['Int']>;
};


export type MutationUpdateContragentFillingArgs = {
  contragentIsn: Scalars['Int'];
  fillingType?: InputMaybe<ContragentFillingTypeEnum>;
  id: Scalars['Int'];
};


export type MutationUploadFilesArgs = {
  id: Scalars['Int'];
};


export type MutationUserArgs = {
  id?: InputMaybe<Scalars['Int']>;
  input?: InputMaybe<UserInput>;
};


export type MutationViewCommentArgs = {
  id?: InputMaybe<Array<Scalars['Int']>>;
};

/** Период времени */
export type PeriodInput = {
  /** Дата до */
  end?: InputMaybe<Scalars['String']>;
  /** Дата от */
  start?: InputMaybe<Scalars['String']>;
};

export type Permission = {
  __typename?: 'Permission';
  id: Scalars['Int'];
  name: Scalars['String'];
  tag: Scalars['String'];
};

export type PreCalcFormInput = {
  agent?: InputMaybe<LabelValueInput>;
  /** Кредитные организации для предрасчета */
  banks?: InputMaybe<Array<InputMaybe<PrecalcBankInput>>>;
  /** Список заемщиков */
  borrowers?: InputMaybe<Array<InputMaybe<PrecalcBorrowerInput>>>;
  /** Дата выдачи кредита */
  creditIssueDate?: InputMaybe<Scalars['String']>;
  /** Размер кредита */
  creditSum?: InputMaybe<Scalars['Float']>;
  /** Кросс-интерьер */
  crossInterior?: InputMaybe<Scalars['Float']>;
  /** Кросс-имущество */
  crossProperty?: InputMaybe<Scalars['Float']>;
  /** Кросс-ответственность */
  crossResponsibility?: InputMaybe<Scalars['Float']>;
  dealCountry?: InputMaybe<AddressInput>;
  /** Скидка по КВ */
  discountKv?: InputMaybe<Scalars['Float']>;
  /** Скидка СК */
  discountSk?: InputMaybe<Scalars['Float']>;
  insuranceType?: InputMaybe<LabelValueInput>;
  /** Промокод */
  promocode?: InputMaybe<Scalars['String']>;
  /** Список объектов недвижимости */
  properties?: InputMaybe<Array<InputMaybe<PreCalcPropertyInput>>>;
  /** Считать риск Жизнь */
  riskLife?: InputMaybe<Scalars['Boolean']>;
  /** Считать риск Имущество */
  riskProperty?: InputMaybe<Scalars['Boolean']>;
  /** Считать риск Титул */
  riskTitle?: InputMaybe<Scalars['Boolean']>;
};

export type PreCalcPropertyInput = {
  /** Примерный год постройки / год приобретения */
  buildYear?: InputMaybe<Scalars['Int']>;
  /** Материал пола */
  floorMaterial?: InputMaybe<LabelValueInput>;
  /** Тип объекта недвижимости */
  objectType?: InputMaybe<LabelValueInput>;
  /** Сколько лет собственники владеют объектом? */
  ownershipYears?: InputMaybe<Scalars['Int']>;
  /** Доля в залоге */
  pledgeShare?: InputMaybe<Scalars['Float']>;
  /** Стоимость объекта */
  subjectCost?: InputMaybe<Scalars['Float']>;
  /** Материал стен */
  wallMaterial?: InputMaybe<LabelValueInput>;
  /** Дерево в конструкции */
  woodInConstruction?: InputMaybe<Scalars['Boolean']>;
};

/** Данные банка */
export type PrecalcBankInput = {
  isn?: InputMaybe<Scalars['String']>;
  rate?: InputMaybe<Scalars['Float']>;
};

/** Созаемщик */
export type PrecalcBorrower = {
  __typename?: 'PrecalcBorrower';
  name: Scalars['String'];
  need_medical_checkup?: Maybe<Scalars['Boolean']>;
  premium_sum: Scalars['Float'];
  tariff: Scalars['Float'];
};

/** Заемщик */
export type PrecalcBorrowerInput = {
  /** Дата рождения заемщика */
  birthday?: InputMaybe<Scalars['String']>;
  /** Способ определения даты рождения заемщика */
  birthdayMethod?: InputMaybe<LabelValueInput>;
  /** Наличие хронических заболеваний */
  hasChronicDiseases?: InputMaybe<Scalars['Boolean']>;
  /** Риск */
  hasRisk?: InputMaybe<Scalars['Boolean']>;
  profession?: InputMaybe<LabelValueInput>;
  riskGroup?: InputMaybe<LabelValueInput>;
  /** M/F */
  sex?: InputMaybe<Scalars['String']>;
  /** Доля заемщика в общем доходе */
  share?: InputMaybe<Scalars['Float']>;
};

/** Результат предрасчета */
export type PrecalcResult = {
  __typename?: 'PrecalcResult';
  allowDiscount?: Maybe<Scalars['Boolean']>;
  bank?: Maybe<Bank>;
  /** ID кросс-продажи */
  crossId?: Maybe<Scalars['Int']>;
  insuranceType?: Maybe<Scalars['Int']>;
  /** Доступно ли упрощенное оформление по декларации */
  isExpressDeclarationAvailable?: Maybe<Scalars['Boolean']>;
  isn?: Maybe<Scalars['String']>;
  /** Причина недоступности упрощенного оформления по декларации */
  noExpressDeclarationReason?: Maybe<Scalars['String']>;
  /** Старая премия (без скидки) */
  oldPremium?: Maybe<Scalars['Float']>;
  result_discount?: Maybe<Scalars['Float']>;
  risks?: Maybe<Array<Maybe<PrecalcRisk>>>;
  /** Страховая сумма */
  sum?: Maybe<Scalars['Float']>;
  /** Страховая премия, итог */
  total?: Maybe<Scalars['Float']>;
  /** Предупреждение */
  warning?: Maybe<Scalars['String']>;
};

/** A type */
export type PrecalcRisk = {
  __typename?: 'PrecalcRisk';
  borrowers?: Maybe<Array<Maybe<PrecalcBorrower>>>;
  name: Scalars['String'];
  /** Сумма кредита */
  sum: Scalars['Float'];
};

/** Шаблон печати */
export enum PrintTemplateEnum {
  /** Анкета */
  Anketa = 'ANKETA',
  /** Декларация */
  Declaration = 'DECLARATION'
}

/** Типы печати */
export enum PrintTypeEnum {
  /** Договор */
  Agreement = 'AGREEMENT',
  /** Запись b2b */
  B2B = 'B2B',
  /** Котировка */
  Calculation = 'CALCULATION',
  /** Документ */
  Document = 'DOCUMENT',
  /** Аттач */
  File = 'FILE',
  /** График платежей */
  Schedule = 'SCHEDULE'
}

/** Данные объекта страхования */
export type PropertyObjectForm = {
  __typename?: 'PropertyObjectForm';
  /** Наличие дополнительных факторов риска */
  additionalRisks?: Maybe<LabelValueForm>;
  /** Наличие дополнительных факторов риска, подробности */
  additionalRisksInfo?: Maybe<Scalars['String']>;
  /** Агентство недвижимости, которое готовит сделку купли-продажи, ФИО и телефон агента */
  agency?: Maybe<Scalars['String']>;
  /** Сигнализация */
  alarm?: Maybe<LabelValueForm>;
  /** Сигнализация, подробности */
  alarmInfo?: Maybe<Scalars['String']>;
  /** Общая площадь, м2 */
  area?: Maybe<Scalars['Float']>;
  /** Подвальное или чердачное помещение? */
  basementOrAttic?: Maybe<Scalars['Boolean']>;
  /** Год постройки / год приобретения */
  buildYear?: Maybe<Scalars['Int']>;
  /** Известны ли Вам физические повреждения объекта залога за последние 2 года, сумма ущерба которых превышала 200 000 ₽? */
  damage?: Maybe<Scalars['Boolean']>;
  /** Хранение горючих, легковоспламеняющихся материалов */
  flammable?: Maybe<Scalars['String']>;
  /** Этаж */
  floor?: Maybe<Scalars['Int']>;
  /** Этажность строения */
  floorCount?: Maybe<Scalars['Int']>;
  /** Материал межэтажных перекрытий */
  floorMaterial?: Maybe<LabelValueForm>;
  /** Внутрення отделка и инженерное оборудование */
  interiorDecoration?: Maybe<Scalars['Boolean']>;
  /** Наименование назависимого оценщика */
  nameOfAppraiser?: Maybe<Scalars['String']>;
  /** Рыночная стоимость объекта залога (согласно отчету об оценке) */
  objectCost?: Maybe<Scalars['Float']>;
  /** Стоимость объекта залога по договору купли-продажи */
  objectCostByContract?: Maybe<Scalars['Float']>;
  /** Объект незавершенного строительства */
  objectOfUnfinishedConstruction?: Maybe<Scalars['Boolean']>;
  /** Наличие источников открытого огня */
  openFire?: Maybe<LabelValueForm>;
  /** Наличие источников открытого огня, подробности */
  openFireInfo?: Maybe<Scalars['String']>;
  /** Ввод адреса из ЕГРН */
  pledgeAddressEgrn?: Maybe<Scalars['String']>;
  /** Кадастровый номер */
  pledgeCadastralNumber?: Maybe<Scalars['String']>;
  /** Доля приобретаемого / закладываемого объекта залога */
  pledgeShare?: Maybe<Scalars['Float']>;
  /** Совпадает ли адрес объекта залога с адресом в договоре купли-продажи */
  propertyAddressMatch?: Maybe<Scalars['Boolean']>;
  /** Предмет залога */
  propertyPledge?: Maybe<LabelValueForm>;
  /** Адрес приобретаемого / закладываемого объекта залога */
  propertyPledgeAddress?: Maybe<AddressForm>;
  /** Страховая сумма */
  propertySumInsured?: Maybe<Scalars['Float']>;
  /** Назначение помещения */
  purpose?: Maybe<LabelValueForm>;
  /** Будет ли недвижимое имущество сдаваться в аренду третьим лицам? */
  rent?: Maybe<Scalars['Boolean']>;
  /** Сроки ремонта, от */
  repairIntervalFrom?: Maybe<Scalars['String']>;
  /** Сроки ремонта, до */
  repairIntervalTo?: Maybe<Scalars['String']>;
  /** Планируете ли Вы проведение ремонтных работ, связанных с изменениями в конструктивных элементах недвижимого имущества */
  repairPlanning?: Maybe<Scalars['Boolean']>;
  /** Сроки перепланировки / переоборудования, от */
  replanIntervalFrom?: Maybe<Scalars['String']>;
  /** Сроки перепланировки / переоборудования, до */
  replanIntervalTo?: Maybe<Scalars['String']>;
  /** Вы планируете или проводите перепланировку / переоборудование? */
  replanPlanning?: Maybe<Scalars['Boolean']>;
  /** Коэффициент за повышенный риск объекта страхования */
  riskCoefficient?: Maybe<Scalars['Float']>;
  /** Количество комнат */
  roomsCount?: Maybe<Scalars['Int']>;
  /** Материал стен */
  wallMaterial?: Maybe<LabelValueForm>;
  woodInConstruction?: Maybe<Scalars['Boolean']>;
  /** Год капитального ремонта */
  yearOfCapitalRepair?: Maybe<Scalars['Int']>;
};

/** Данные объекта страхования */
export type PropertyObjectInput = {
  /** Наличие дополнительных факторов риска */
  additionalRisks?: InputMaybe<LabelValueInput>;
  /** Наличие дополнительных факторов риска, подробности */
  additionalRisksInfo?: InputMaybe<Scalars['String']>;
  /** Агентство недвижимости, которое готовит сделку купли-продажи, ФИО и телефон агента */
  agency?: InputMaybe<Scalars['String']>;
  /** Сигнализация */
  alarm?: InputMaybe<LabelValueInput>;
  /** Сигнализация, подробности */
  alarmInfo?: InputMaybe<Scalars['String']>;
  /** Общая площадь, м2 */
  area?: InputMaybe<Scalars['Float']>;
  /** Подвальное или чердачное помещение? */
  basementOrAttic?: InputMaybe<Scalars['Boolean']>;
  /** Год постройки / год приобретения */
  buildYear?: InputMaybe<Scalars['Int']>;
  /** Известны ли Вам физические повреждения объекта залога за последние 2 года, сумма ущерба которых превышала 200 000 ₽? */
  damage?: InputMaybe<Scalars['Boolean']>;
  /** Хранение горючих, легковоспламеняющихся материалов */
  flammable?: InputMaybe<Scalars['String']>;
  /** Этаж */
  floor?: InputMaybe<Scalars['Int']>;
  /** Этажность строения */
  floorCount?: InputMaybe<Scalars['Int']>;
  /** Материал межэтажных перекрытий */
  floorMaterial?: InputMaybe<LabelValueInput>;
  /** Внутрення отделка и инженерное оборудование */
  interiorDecoration?: InputMaybe<Scalars['Boolean']>;
  /** Наименование назависимого оценщика */
  nameOfAppraiser?: InputMaybe<Scalars['String']>;
  /** Рыночная стоимость объекта залога (согласно отчету об оценке) */
  objectCost?: InputMaybe<Scalars['Float']>;
  /** Стоимость объекта залога по договору купли-продажи */
  objectCostByContract?: InputMaybe<Scalars['Float']>;
  /** Объект незавершенного строительства */
  objectOfUnfinishedConstruction?: InputMaybe<Scalars['Boolean']>;
  /** Наличие источников открытого огня */
  openFire?: InputMaybe<LabelValueInput>;
  /** Наличие источников открытого огня, подробности */
  openFireInfo?: InputMaybe<Scalars['String']>;
  /** Ввод адреса из ЕГРН */
  pledgeAddressEgrn?: InputMaybe<Scalars['String']>;
  /** Кадастровый номер */
  pledgeCadastralNumber?: InputMaybe<Scalars['String']>;
  /** Доля приобретаемого / закладываемого объекта залога */
  pledgeShare?: InputMaybe<Scalars['Float']>;
  /** Совпадает ли адрес объекта залога с адресом в договоре купли-продажи */
  propertyAddressMatch?: InputMaybe<Scalars['Boolean']>;
  /** Предмет залога */
  propertyPledge?: InputMaybe<LabelValueInput>;
  /** Адрес приобретаемого / закладываемого объекта залога */
  propertyPledgeAddress?: InputMaybe<AddressInput>;
  /** Страховая сумма */
  propertySumInsured?: InputMaybe<Scalars['Float']>;
  /** Назначение помещения */
  purpose?: InputMaybe<LabelValueInput>;
  /** Будет ли недвижимое имущество сдаваться в аренду третьим лицам? */
  rent?: InputMaybe<Scalars['Boolean']>;
  /** Сроки ремонта, от */
  repairIntervalFrom?: InputMaybe<Scalars['String']>;
  /** Сроки ремонта, до */
  repairIntervalTo?: InputMaybe<Scalars['String']>;
  /** Планируете ли Вы проведение ремонтных работ, связанных с изменениями в конструктивных элементах недвижимого имущества */
  repairPlanning?: InputMaybe<Scalars['Boolean']>;
  /** Сроки перепланировки / переоборудования, от */
  replanIntervalFrom?: InputMaybe<Scalars['String']>;
  /** Сроки перепланировки / переоборудования, до */
  replanIntervalTo?: InputMaybe<Scalars['String']>;
  /** Вы планируете или проводите перепланировку / переоборудование? */
  replanPlanning?: InputMaybe<Scalars['Boolean']>;
  /** Коэффициент за повышенный риск объекта страхования */
  riskCoefficient?: InputMaybe<Scalars['Float']>;
  /** Количество комнат */
  roomsCount?: InputMaybe<Scalars['Int']>;
  /** Материал стен */
  wallMaterial?: InputMaybe<LabelValueInput>;
  woodInConstruction?: InputMaybe<Scalars['Boolean']>;
  /** Год капитального ремонта */
  yearOfCapitalRepair?: InputMaybe<Scalars['Int']>;
};

export type Query = {
  __typename?: 'Query';
  /** A query */
  adminMessage?: Maybe<Scalars['String']>;
  anketa?: Maybe<Array<Maybe<AnketaPart>>>;
  /** Получение изменений сущности */
  changeLog?: Maybe<Array<Maybe<ChangeEventType>>>;
  /** Дашборд */
  dashboard?: Maybe<DashboardSection>;
  /** Получить справочник из KIAS по ключу */
  dict?: Maybe<Array<Maybe<IsnNamePair>>>;
  /** Документы */
  docs?: Maybe<DocPagination>;
  /** Список групп */
  groups?: Maybe<Array<Maybe<Group>>>;
  /** Получение заявки */
  loadAgreement?: Maybe<Doc>;
  /** Текущий пользователь */
  me?: Maybe<MeInfoType>;
  /** Получить список сообщений пользователя */
  messages?: Maybe<Array<Message>>;
  /** Список разрешений */
  permissions?: Maybe<Array<Maybe<Permission>>>;
  /** Список ролей */
  roles?: Maybe<Array<Maybe<Role>>>;
  /** Поиск контрагента */
  searchContragent?: Maybe<ContragentForm>;
  /** Статусы */
  statuses?: Maybe<Array<Maybe<Status>>>;
  /** Список пользователей */
  users?: Maybe<Array<Maybe<User>>>;
};


export type QueryAnketaArgs = {
  contragentIsn: Scalars['Int'];
  id: Scalars['Int'];
};


export type QueryChangeLogArgs = {
  id: Scalars['Int'];
  model?: InputMaybe<ChangeLogTableEnum>;
};


export type QueryDictArgs = {
  key: DictKeyEnum;
};


export type QueryDocsArgs = {
  filter?: InputMaybe<DocFilterInput>;
  isn?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  product?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<DocTypeEnum>;
};


export type QueryGroupsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};


export type QueryLoadAgreementArgs = {
  id?: InputMaybe<Scalars['Int']>;
  isn?: InputMaybe<Scalars['String']>;
};


export type QueryRolesArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};


export type QuerySearchContragentArgs = {
  birthday?: InputMaybe<Scalars['String']>;
  firstname?: InputMaybe<Scalars['String']>;
  fullname?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  isn?: InputMaybe<Scalars['String']>;
  lastname?: InputMaybe<Scalars['String']>;
  parentname?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
};


export type QueryUsersArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  roleId?: InputMaybe<Scalars['Int']>;
};

/** Ограничение пользователя */
export type Restriction = {
  __typename?: 'Restriction';
  /** Ограниечение */
  tag?: Maybe<Scalars['String']>;
  /** Значение */
  value?: Maybe<Scalars['object']>;
};

/** Форма ограничения пользователя */
export type RestrictionInput = {
  /** Ограничение */
  tag: Scalars['String'];
  /** Значение */
  value?: InputMaybe<Scalars['object']>;
};

export type ResultDocument = {
  __typename?: 'ResultDocument';
  isn: Scalars['Int'];
  name: Scalars['String'];
  subject?: Maybe<Scalars['String']>;
  templateIsn: Scalars['Int'];
  type: PrintTypeEnum;
  warning?: Maybe<Scalars['String']>;
};

/** Риск заявки (B2B) */
export type Risk = {
  __typename?: 'Risk';
  /** Добавлен */
  added?: Maybe<Scalars['String']>;
  /** Дополнительная информация по риску */
  data?: Maybe<Scalars['object']>;
  /** ISN заявки */
  doc: Scalars['String'];
  /** Изменен */
  edited?: Maybe<Scalars['String']>;
  /** ISN объекта под риском (необязательный) */
  object?: Maybe<Scalars['String']>;
  /** ISN вида риска */
  risk: Scalars['String'];
  /** Статус (approved, deny, underwriting) */
  status?: Maybe<Scalars['String']>;
  /** Создатель */
  user?: Maybe<User>;
};


/** Риск заявки (B2B) */
export type RiskAddedArgs = {
  format?: InputMaybe<Scalars['String']>;
  relative?: InputMaybe<Scalars['Boolean']>;
  timezone?: InputMaybe<Scalars['String']>;
};


/** Риск заявки (B2B) */
export type RiskEditedArgs = {
  format?: InputMaybe<Scalars['String']>;
  relative?: InputMaybe<Scalars['Boolean']>;
  timezone?: InputMaybe<Scalars['String']>;
};

export enum RiskStatusEnum {
  /** Согласован */
  Agreed = 'AGREED',
  /** Не согласован */
  NotAgreed = 'NOT_AGREED',
  /** На согласовании */
  Underwriting = 'UNDERWRITING'
}

export type Role = {
  __typename?: 'Role';
  group?: Maybe<Group>;
  id: Scalars['Int'];
  name: Scalars['String'];
  /** Разрешения, массив id */
  permission_ids?: Maybe<Array<Scalars['Int']>>;
  /** Разрешения */
  permissions?: Maybe<Array<Maybe<Permission>>>;
  readOnly: Scalars['Boolean'];
  users_count?: Maybe<Scalars['Int']>;
};

/** Форма роли */
export type RoleInput = {
  name: Scalars['String'];
  permissions?: InputMaybe<Array<Scalars['Int']>>;
};

export type SendToSbInput = {
  remark?: InputMaybe<Scalars['String']>;
  risks?: InputMaybe<Array<Scalars['String']>>;
};

export type Status = {
  __typename?: 'Status';
  color?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type SubAgreement = {
  __typename?: 'SubAgreement';
  created_at?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  payed?: Maybe<Scalars['Boolean']>;
  premium_sum?: Maybe<Scalars['Float']>;
  readOnly: Scalars['Boolean'];
  /** Статус */
  status?: Maybe<Status>;
};

/** Титул по объекту страхования */
export type TitleObjectForm = {
  __typename?: 'TitleObjectForm';
  addressEgrn?: Maybe<Scalars['String']>;
  /** Является ли предмет залога объектом судебных разбирательтв в прошлом или в настоящее время? */
  litigation?: Maybe<Scalars['Boolean']>;
  /** Наличие несовершеннолетних членов семьи, являющихся собственниками */
  minors?: Maybe<Scalars['Boolean']>;
  /** Наличие действующих обременений объекта залога */
  objectEncumbrances?: Maybe<Scalars['String']>;
  /** Адрес */
  titleAddress?: Maybe<AddressForm>;
  /** Кадастровый номер */
  titleCadastralNumber?: Maybe<Scalars['String']>;
  /** Доля титула */
  titleShare?: Maybe<Scalars['Float']>;
  typeEncumbrances?: Maybe<Scalars['String']>;
  /** Наличие граждан, незарегистрированных в объекте залога, но имеющих право пользования */
  unregisterPersons?: Maybe<Scalars['Boolean']>;
};

/** Титул по объекту страхования */
export type TitleObjectInput = {
  addressEgrn?: InputMaybe<Scalars['String']>;
  /** Является ли предмет залога объектом судебных разбирательтв в прошлом или в настоящее время? */
  litigation?: InputMaybe<Scalars['Boolean']>;
  /** Наличие несовершеннолетних членов семьи, являющихся собственниками */
  minors?: InputMaybe<Scalars['Boolean']>;
  /** Наличие действующих обременений объекта залога */
  objectEncumbrances?: InputMaybe<Scalars['String']>;
  /** Адрес */
  titleAddress?: InputMaybe<AddressInput>;
  /** Кадастровый номер */
  titleCadastralNumber?: InputMaybe<Scalars['String']>;
  /** Доля титула */
  titleShare?: InputMaybe<Scalars['Float']>;
  typeEncumbrances?: InputMaybe<Scalars['String']>;
  /** Наличие граждан, незарегистрированных в объекте залога, но имеющих право пользования */
  unregisterPersons?: InputMaybe<Scalars['Boolean']>;
};

export type User = {
  __typename?: 'User';
  /** Банки настроены нормально */
  banksOk?: Maybe<Scalars['Boolean']>;
  crossEnabled?: Maybe<Scalars['Boolean']>;
  email?: Maybe<Scalars['String']>;
  flatEnabled?: Maybe<Scalars['Boolean']>;
  full_name: Scalars['String'];
  /** Группа */
  group?: Maybe<Group>;
  /** Группа пользователя, только id */
  group_id?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  /** Может администрировать? */
  isAdmin?: Maybe<Scalars['Boolean']>;
  /** Штатный сотрудник */
  isStaffMember?: Maybe<Scalars['Boolean']>;
  /** Суперпользователь? */
  isSuper: Scalars['Boolean'];
  is_enabled: Scalars['Boolean'];
  is_restricted: Scalars['Boolean'];
  name: Scalars['String'];
  permissions?: Maybe<Array<Scalars['String']>>;
  phone?: Maybe<Scalars['String']>;
  /** Примечание */
  remark?: Maybe<Scalars['String']>;
  /** Действующие ограничения */
  restrictions?: Maybe<Array<Maybe<Restriction>>>;
  /** Роль */
  role?: Maybe<Role>;
  show_kv: Scalars['Boolean'];
  token?: Maybe<Scalars['String']>;
  /** Тип */
  type: Scalars['String'];
  username: Scalars['String'];
};

/** Форма пользователя */
export type UserInput = {
  email?: InputMaybe<Scalars['String']>;
  full_name: Scalars['String'];
  group_id?: InputMaybe<Scalars['Int']>;
  is_enabled: Scalars['Boolean'];
  is_restricted?: InputMaybe<Scalars['Boolean']>;
  is_super: Scalars['Boolean'];
  /** Назначить лидером */
  lead?: InputMaybe<Scalars['Boolean']>;
  password?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  remake_token?: InputMaybe<Scalars['Boolean']>;
  reset_password?: InputMaybe<Scalars['Boolean']>;
  role_id?: InputMaybe<Scalars['Int']>;
  show_kv?: InputMaybe<Scalars['Boolean']>;
  username: Scalars['String'];
};

export type ViewAnketaPart = {
  __typename?: 'ViewAnketaPart';
  name: Scalars['String'];
  questions: Array<Maybe<ViewAnketaQuestion>>;
};

export type ViewAnketaQuestion = {
  __typename?: 'ViewAnketaQuestion';
  answer: Scalars['String'];
  question: Scalars['String'];
};

export type SignInMutationVariables = Exact<{
  username: Scalars['String'];
  password: Scalars['String'];
  isClient?: InputMaybe<Scalars['Boolean']>;
}>;


export type SignInMutation = { __typename?: 'Mutation', signIn?: { __typename?: 'User', id: number, isSuper: boolean, type: string, permissions?: Array<string> | null | undefined } | null | undefined };

export type PasswordMutationVariables = Exact<{
  old_password: Scalars['String'];
  new_password: Scalars['String'];
}>;


export type PasswordMutation = { __typename?: 'Mutation', password?: { __typename?: 'User', id: number } | null | undefined };

export type SignInAsMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type SignInAsMutation = { __typename?: 'Mutation', signInAs?: { __typename?: 'User', id: number, isSuper: boolean, type: string, permissions?: Array<string> | null | undefined } | null | undefined };

export type CreateUpdateRoleMutationVariables = Exact<{
  id?: InputMaybe<Scalars['Int']>;
  input?: InputMaybe<RoleInput>;
}>;


export type CreateUpdateRoleMutation = { __typename?: 'Mutation', role?: { __typename?: 'Role', id: number } | null | undefined };

export type CreateUpdateUserMutationVariables = Exact<{
  id?: InputMaybe<Scalars['Int']>;
  input?: InputMaybe<UserInput>;
}>;


export type CreateUpdateUserMutation = { __typename?: 'Mutation', user?: string | null | undefined };

export type RestrictionsMutationVariables = Exact<{
  userId?: InputMaybe<Scalars['String']>;
  groupId?: InputMaybe<Scalars['String']>;
  restrictions?: InputMaybe<Array<InputMaybe<RestrictionInput>> | InputMaybe<RestrictionInput>>;
  comment?: InputMaybe<Scalars['String']>;
}>;


export type RestrictionsMutation = { __typename?: 'Mutation', restrictions?: Array<any | null | undefined> | null | undefined };

export type CreateUpdateGroupMutationVariables = Exact<{
  id?: InputMaybe<Scalars['Int']>;
  input?: InputMaybe<GroupInput>;
}>;


export type CreateUpdateGroupMutation = { __typename?: 'Mutation', group?: { __typename?: 'Group', id: number } | null | undefined };

export type DeleteGroupMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DeleteGroupMutation = { __typename?: 'Mutation', deleteGroup?: boolean | null | undefined };

export type DeleteUserMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DeleteUserMutation = { __typename?: 'Mutation', deleteUser?: boolean | null | undefined };

export type DeleteRoleMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DeleteRoleMutation = { __typename?: 'Mutation', deleteRole?: boolean | null | undefined };

export type DeleteAgreementMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DeleteAgreementMutation = { __typename?: 'Mutation', deleteAgreement?: boolean | null | undefined };

export type AnnulAgreementMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type AnnulAgreementMutation = { __typename?: 'Mutation', annulAgreement?: boolean | null | undefined };

export type LogoutMutationVariables = Exact<{ [key: string]: never; }>;


export type LogoutMutation = { __typename?: 'Mutation', logout?: boolean | null | undefined };

export type SaveAgreementMutationVariables = Exact<{
  id?: InputMaybe<Scalars['Int']>;
  calcForm?: InputMaybe<CalcFormInput>;
  product?: InputMaybe<Scalars['Int']>;
  fromPrecalc?: InputMaybe<Scalars['Boolean']>;
}>;


export type SaveAgreementMutation = { __typename?: 'Mutation', saveAgreement?: string | null | undefined };

export type SaveFlatMutationVariables = Exact<{
  id: Scalars['Int'];
  calcForm?: InputMaybe<FlatFormInput>;
  doCalc?: InputMaybe<Scalars['Boolean']>;
  doRegister?: InputMaybe<Scalars['Boolean']>;
}>;


export type SaveFlatMutation = { __typename?: 'Mutation', saveFlat?: { __typename?: 'FlatCalcResultType', limit_sum?: number | null | undefined, premium_sum?: number | null | undefined, old_premium_sum?: number | null | undefined, isn?: string | null | undefined, number?: string | null | undefined, details?: Array<{ __typename?: 'FlatCalcResultDetailType', name?: string | null | undefined, limit_sum?: number | null | undefined, premium_sum?: number | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type RegisterAgreementMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type RegisterAgreementMutation = { __typename?: 'Mutation', registerAgreement?: number | null | undefined };

export type AgreementToDraftMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type AgreementToDraftMutation = { __typename?: 'Mutation', agreementToDraft?: number | null | undefined };

export type SignAgreementMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type SignAgreementMutation = { __typename?: 'Mutation', signAgreement?: boolean | null | undefined };

export type UnsignAgreementMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type UnsignAgreementMutation = { __typename?: 'Mutation', unsignAgreement?: boolean | null | undefined };

export type SaveAnketaMutationVariables = Exact<{
  id: Scalars['Int'];
  contragentIsn: Scalars['Int'];
  questions?: InputMaybe<Scalars['object']>;
}>;


export type SaveAnketaMutation = { __typename?: 'Mutation', saveAnketa?: { __typename?: 'ContragentForm', anketaIsn?: number | null | undefined } | null | undefined };

export type PrintExpressCalculationMutationVariables = Exact<{
  isn?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type PrintExpressCalculationMutation = { __typename?: 'Mutation', printExpressCalculation?: { __typename?: 'File', id: string, filename: string, url: string } | null | undefined };

export type SendAnketaSmsMutationVariables = Exact<{
  id: Scalars['Int'];
  contragentIsn: Scalars['Int'];
  isDeclaration?: InputMaybe<Scalars['Boolean']>;
}>;


export type SendAnketaSmsMutation = { __typename?: 'Mutation', sendAnketaSms?: string | null | undefined };

export type SignAnketaMutationVariables = Exact<{
  id: Scalars['Int'];
  contragentIsn: Scalars['Int'];
  code: Scalars['String'];
  isDeclaration?: InputMaybe<Scalars['Boolean']>;
}>;


export type SignAnketaMutation = { __typename?: 'Mutation', signAnketa?: string | null | undefined };

export type PrintMutationVariables = Exact<{
  isn: Scalars['Int'];
  type: PrintTypeEnum;
  template?: InputMaybe<PrintTemplateEnum>;
  templateIsn?: InputMaybe<Scalars['Int']>;
  email?: InputMaybe<Scalars['String']>;
  subject?: InputMaybe<Scalars['String']>;
  contragentIsn?: InputMaybe<Scalars['Int']>;
}>;


export type PrintMutation = { __typename?: 'Mutation', print?: { __typename?: 'File', id: string, filename: string, url: string } | null | undefined };

export type DownloadAllMutationVariables = Exact<{
  id?: InputMaybe<Scalars['Int']>;
}>;


export type DownloadAllMutation = { __typename?: 'Mutation', downloadAll?: { __typename?: 'File', id: string, filename: string, url: string } | null | undefined };

export type AddAgreementFilesMutationVariables = Exact<{
  agreementId: Scalars['Int'];
  files?: InputMaybe<Array<InputMaybe<Scalars['Upload']>> | InputMaybe<Scalars['Upload']>>;
  context: AgreementFileContextEnum;
}>;


export type AddAgreementFilesMutation = { __typename?: 'Mutation', addAgreementFiles?: Array<{ __typename?: 'File', id: string }> | null | undefined };

export type CalculateAgreementMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type CalculateAgreementMutation = { __typename?: 'Mutation', calculateAgreement?: number | null | undefined };

export type ChangeCalculationMutationVariables = Exact<{
  id?: InputMaybe<Scalars['Int']>;
  input?: InputMaybe<ChangeCalculationInput>;
}>;


export type ChangeCalculationMutation = { __typename?: 'Mutation', changeCalculation?: boolean | null | undefined };

export type ChangeAgreementMutationVariables = Exact<{
  id?: InputMaybe<Scalars['Int']>;
  input?: InputMaybe<ChangeAgreementInput>;
}>;


export type ChangeAgreementMutation = { __typename?: 'Mutation', changeAgreement?: boolean | null | undefined };

export type CommentMutationVariables = Exact<{
  id: Scalars['Int'];
  text: Scalars['String'];
}>;


export type CommentMutation = { __typename?: 'Mutation', comment?: { __typename?: 'Comment', id: number } | null | undefined };

export type ViewCommentMutationVariables = Exact<{
  id?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
}>;


export type ViewCommentMutation = { __typename?: 'Mutation', viewComment?: boolean | null | undefined };

export type PrepareInvoiceMutationVariables = Exact<{
  id: Scalars['Int'];
  isn?: InputMaybe<Scalars['Int']>;
}>;


export type PrepareInvoiceMutation = { __typename?: 'Mutation', prepareInvoice?: boolean | null | undefined };

export type SendPaymentLinkMutationVariables = Exact<{
  agreementIsn: Scalars['Int'];
  phone?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  isSendFinish?: InputMaybe<Scalars['Boolean']>;
  agreementNo?: InputMaybe<Scalars['String']>;
  premiumSum?: InputMaybe<Scalars['Float']>;
}>;


export type SendPaymentLinkMutation = { __typename?: 'Mutation', sendPaymentLink?: string | null | undefined };

export type SendDeclarationTextMutationVariables = Exact<{
  email: Scalars['String'];
  type?: InputMaybe<Scalars['String']>;
}>;


export type SendDeclarationTextMutation = { __typename?: 'Mutation', sendDeclarationText?: boolean | null | undefined };

export type ApplyKvMutationVariables = Exact<{
  id: Scalars['Int'];
  kv: Scalars['Float'];
}>;


export type ApplyKvMutation = { __typename?: 'Mutation', applyKv?: boolean | null | undefined };

export type DisapproveMutationVariables = Exact<{
  id: Scalars['Int'];
  risk_isns?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
}>;


export type DisapproveMutation = { __typename?: 'Mutation', disapprove?: boolean | null | undefined };

export type ProlongMutationVariables = Exact<{
  isn: Scalars['String'];
  date_sign?: InputMaybe<Scalars['String']>;
  sum?: InputMaybe<Scalars['Float']>;
  agent?: InputMaybe<LabelValueInput>;
}>;


export type ProlongMutation = { __typename?: 'Mutation', prolong?: number | null | undefined };

export type UpdateContragentFillingMutationVariables = Exact<{
  id: Scalars['Int'];
  contragentIsn: Scalars['Int'];
  fillingType?: InputMaybe<ContragentFillingTypeEnum>;
}>;


export type UpdateContragentFillingMutation = { __typename?: 'Mutation', updateContragentFilling?: boolean | null | undefined };

export type SearchAgreementMutationVariables = Exact<{
  number: Scalars['String'];
}>;


export type SearchAgreementMutation = { __typename?: 'Mutation', searchAgreement?: any | null | undefined };

export type AddendumMutationVariables = Exact<{
  id: Scalars['Int'];
  reason: AddendumReasonEnum;
  exclude?: InputMaybe<AddendumExcludeInput>;
  recalc?: InputMaybe<AddendumRecalcInput>;
}>;


export type AddendumMutation = { __typename?: 'Mutation', addendum?: boolean | null | undefined };

export type SendToSbMutationVariables = Exact<{
  id: Scalars['Int'];
  input?: InputMaybe<SendToSbInput>;
}>;


export type SendToSbMutation = { __typename?: 'Mutation', sendToSb?: boolean | null | undefined };

export type CrossMutationVariables = Exact<{
  id?: InputMaybe<Scalars['Int']>;
  isn?: InputMaybe<Scalars['Int']>;
  date_sign?: InputMaybe<Scalars['String']>;
  responsibility?: InputMaybe<Scalars['Float']>;
  interior?: InputMaybe<Scalars['Float']>;
  property?: InputMaybe<Scalars['Float']>;
  register?: InputMaybe<Scalars['Boolean']>;
}>;


export type CrossMutation = { __typename?: 'Mutation', cross?: number | null | undefined };

export type RemoveCrossMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type RemoveCrossMutation = { __typename?: 'Mutation', removeCross?: number | null | undefined };

export type AssignAgreementMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type AssignAgreementMutation = { __typename?: 'Mutation', assignAgreement?: boolean | null | undefined };

export type ContinueWithAnketaMutationVariables = Exact<{
  id: Scalars['Int'];
  anketaIsn: Scalars['Int'];
}>;


export type ContinueWithAnketaMutation = { __typename?: 'Mutation', continueWithAnketa?: number | null | undefined };

export type MockMutationVariables = Exact<{
  key: Scalars['String'];
}>;


export type MockMutation = { __typename?: 'Mutation', mock?: number | null | undefined };

export type EnterAddendumModeMutationVariables = Exact<{
  id: Scalars['Int'];
  life?: InputMaybe<Scalars['Boolean']>;
  property?: InputMaybe<Scalars['Boolean']>;
  titul?: InputMaybe<Scalars['Boolean']>;
}>;


export type EnterAddendumModeMutation = { __typename?: 'Mutation', enterAddendumMode?: number | null | undefined };

export type CopyAnketaForAgreementMutationVariables = Exact<{
  id: Scalars['Int'];
  anketaIsn: Scalars['Int'];
  forEdit?: InputMaybe<Scalars['Boolean']>;
}>;


export type CopyAnketaForAgreementMutation = { __typename?: 'Mutation', copyAnketaForAgreement?: number | null | undefined };

export type UploadFilesMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type UploadFilesMutation = { __typename?: 'Mutation', uploadFiles?: boolean | null | undefined };

export type CalculateAgreementFinishMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type CalculateAgreementFinishMutation = { __typename?: 'Mutation', calculateAgreementFinish?: number | null | undefined };

export type CreateReportMutationVariables = Exact<{
  reportType: Scalars['String'];
  dateBeg?: InputMaybe<Scalars['String']>;
  dateEnd?: InputMaybe<Scalars['String']>;
  frontNodeIsn?: InputMaybe<Scalars['Int']>;
}>;


export type CreateReportMutation = { __typename?: 'Mutation', createReport?: { __typename?: 'File', id: string, filename: string, url: string } | null | undefined };

export type MarkMessageMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type MarkMessageMutation = { __typename?: 'Mutation', markMessage?: boolean | null | undefined };

export type MeQueryVariables = Exact<{ [key: string]: never; }>;


export type MeQuery = { __typename?: 'Query', me?: { __typename?: 'MeInfoType', user?: { __typename?: 'User', id: number, type: string, full_name: string, username: string, email?: string | null | undefined, phone?: string | null | undefined, isSuper: boolean, isAdmin?: boolean | null | undefined, show_kv: boolean, permissions?: Array<string> | null | undefined, banksOk?: boolean | null | undefined, crossEnabled?: boolean | null | undefined, flatEnabled?: boolean | null | undefined, isStaffMember?: boolean | null | undefined, role?: { __typename?: 'Role', id: number } | null | undefined, group?: { __typename?: 'Group', id: number, is_filial?: boolean | null | undefined, curator?: { __typename?: 'User', email?: string | null | undefined, phone?: string | null | undefined, username: string } | null | undefined } | null | undefined, restrictions?: Array<{ __typename?: 'Restriction', tag?: string | null | undefined, value?: any | null | undefined } | null | undefined> | null | undefined } | null | undefined, adminUser?: { __typename?: 'User', id: number, username: string } | null | undefined } | null | undefined };

export type DashboardInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type DashboardInfoQuery = { __typename?: 'Query', dashboard?: { __typename?: 'DashboardSection', agreements?: Array<{ __typename?: 'DashboardType', count: number, status: string } | null | undefined> | null | undefined, contracts?: Array<{ __typename?: 'DashboardType', count: number, status: string } | null | undefined> | null | undefined } | null | undefined };

export type RolesQueryVariables = Exact<{
  ids?: InputMaybe<Array<InputMaybe<Scalars['Int']>> | InputMaybe<Scalars['Int']>>;
}>;


export type RolesQuery = { __typename?: 'Query', roles?: Array<{ __typename?: 'Role', id: number, name: string, permission_ids?: Array<number> | null | undefined, users_count?: number | null | undefined, permissions?: Array<{ __typename?: 'Permission', id: number, name: string, tag: string } | null | undefined> | null | undefined } | null | undefined> | null | undefined };

export type PermissionsQueryVariables = Exact<{ [key: string]: never; }>;


export type PermissionsQuery = { __typename?: 'Query', permissions?: Array<{ __typename?: 'Permission', id: number, name: string, tag: string } | null | undefined> | null | undefined };

export type PersonFragment = { __typename?: 'User', id: number, full_name: string, username: string, email?: string | null | undefined, phone?: string | null | undefined };

export type GroupsQueryVariables = Exact<{
  ids?: InputMaybe<Array<InputMaybe<Scalars['Int']>> | InputMaybe<Scalars['Int']>>;
}>;


export type GroupsQuery = { __typename?: 'Query', groups?: Array<{ __typename?: 'Group', id: number, parent_id?: number | null | undefined, name: string, email?: string | null | undefined, restrictions?: Array<{ __typename?: 'Restriction', tag?: string | null | undefined, value?: any | null | undefined } | null | undefined> | null | undefined, curator?: { __typename?: 'User', id: number, full_name: string, username: string, email?: string | null | undefined, phone?: string | null | undefined } | null | undefined, leader?: { __typename?: 'User', id: number, full_name: string, username: string, email?: string | null | undefined, phone?: string | null | undefined } | null | undefined } | null | undefined> | null | undefined };

export type UsersQueryVariables = Exact<{
  ids?: InputMaybe<Array<InputMaybe<Scalars['Int']>> | InputMaybe<Scalars['Int']>>;
  roleId?: InputMaybe<Scalars['Int']>;
}>;


export type UsersQuery = { __typename?: 'Query', users?: Array<{ __typename?: 'User', id: number, email?: string | null | undefined, phone?: string | null | undefined, full_name: string, username: string, type: string, isSuper: boolean, group_id?: number | null | undefined, is_enabled: boolean, show_kv: boolean, is_restricted: boolean, token?: string | null | undefined, remark?: string | null | undefined, restrictions?: Array<{ __typename?: 'Restriction', tag?: string | null | undefined, value?: any | null | undefined } | null | undefined> | null | undefined, role?: { __typename?: 'Role', id: number, name: string } | null | undefined } | null | undefined> | null | undefined };

export type DictQueryVariables = Exact<{
  key: DictKeyEnum;
}>;


export type DictQuery = { __typename?: 'Query', dict?: Array<{ __typename?: 'IsnNamePair', isn: string, name: string, extra?: any | null | undefined } | null | undefined> | null | undefined };

export type DocsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<DocTypeEnum>;
  isn?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<DocFilterInput>;
  product?: InputMaybe<Scalars['String']>;
}>;


export type DocsQuery = { __typename?: 'Query', docs?: { __typename?: 'DocPagination', total: number, data?: Array<{ __typename?: 'Doc', id: number, isn?: string | null | undefined, number?: string | null | undefined, type?: DocTypeEnum | null | undefined, creditSumm?: number | null | undefined, bankName?: string | null | undefined, insurerName?: string | null | undefined, groupPath?: Array<string | null | undefined> | null | undefined, added?: string | null | undefined, edited?: string | null | undefined, isnInvoice?: string | null | undefined, needProlongation?: boolean | null | undefined, isProlongation?: boolean | null | undefined, fillingType?: string | null | undefined, product?: number | null | undefined, flatObject?: string | null | undefined, flatRisks?: string | null | undefined, status?: { __typename?: 'Status', value?: string | null | undefined, label?: string | null | undefined, color?: string | null | undefined } | null | undefined, user?: { __typename?: 'User', id: number, full_name: string, username: string, email?: string | null | undefined, phone?: string | null | undefined } | null | undefined, editor?: { __typename?: 'User', id: number, full_name: string, username: string, email?: string | null | undefined, phone?: string | null | undefined } | null | undefined, calcForm?: { __typename?: 'CalcForm', stage?: string | null | undefined } | null | undefined, underwriters?: Array<{ __typename?: 'User', id: number, full_name: string, username: string, email?: string | null | undefined, phone?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type StatusesQueryVariables = Exact<{ [key: string]: never; }>;


export type StatusesQuery = { __typename?: 'Query', statuses?: Array<{ __typename?: 'Status', value?: string | null | undefined, label?: string | null | undefined, color?: string | null | undefined } | null | undefined> | null | undefined };

export type PrecalcMutationVariables = Exact<{
  precalcForm?: InputMaybe<PreCalcFormInput>;
}>;


export type PrecalcMutation = { __typename?: 'Mutation', precalc?: Array<{ __typename?: 'PrecalcResult', isn?: string | null | undefined, sum?: number | null | undefined, total?: number | null | undefined, isExpressDeclarationAvailable?: boolean | null | undefined, noExpressDeclarationReason?: string | null | undefined, crossId?: number | null | undefined, warning?: string | null | undefined, oldPremium?: number | null | undefined, insuranceType?: number | null | undefined, allowDiscount?: boolean | null | undefined, result_discount?: number | null | undefined, bank?: { __typename?: 'Bank', isn: string, name: string, icon?: string | null | undefined } | null | undefined, risks?: Array<{ __typename?: 'PrecalcRisk', name: string, sum: number, borrowers?: Array<{ __typename?: 'PrecalcBorrower', need_medical_checkup?: boolean | null | undefined, name: string, tariff: number, premium_sum: number } | null | undefined> | null | undefined } | null | undefined> | null | undefined } | null | undefined> | null | undefined };

export type SelectFragment = { __typename?: 'LabelValueForm', label: string, value: string };

export type AddressFragment = { __typename?: 'AddressForm', value?: string | null | undefined, unrestricted_value?: string | null | undefined, data?: any | null | undefined };

export type EmploymentFragment = { __typename?: 'EmploymentForm', isOfficeWorker?: boolean | null | undefined, isSoldier?: boolean | null | undefined, position?: string | null | undefined, whyNoJob?: string | null | undefined, jobPlace?: { __typename?: 'LabelValueForm', label: string, value: string } | null | undefined, organizationName?: { __typename?: 'AddressForm', value?: string | null | undefined, unrestricted_value?: string | null | undefined, data?: any | null | undefined } | null | undefined, jobAddress?: { __typename?: 'AddressForm', value?: string | null | undefined, unrestricted_value?: string | null | undefined, data?: any | null | undefined } | null | undefined, organizationActivity?: { __typename?: 'LabelValueForm', label: string, value: string } | null | undefined, riskGroup?: { __typename?: 'LabelValueForm', label: string, value: string } | null | undefined, profession?: { __typename?: 'LabelValueForm', label: string, value: string } | null | undefined };

export type ContragentFragment = { __typename?: 'ContragentForm', isn?: number | null | undefined, fio?: string | null | undefined, birthday?: string | null | undefined, phone?: string | null | undefined, email?: string | null | undefined, sex?: string | null | undefined, registrationAddressIsActual?: boolean | null | undefined, passportSeries?: string | null | undefined, passportNumber?: string | null | undefined, passportIssueDate?: string | null | undefined, passportDevisionCode?: string | null | undefined, passportIssuedBy?: string | null | undefined, share?: number | null | undefined, anketaIsn?: number | null | undefined, fillingType?: ContragentFillingTypeEnum | null | undefined, anketaSigned?: boolean | null | undefined, anketaFileId?: Array<string> | null | undefined, registrationAddress?: { __typename?: 'AddressForm', value?: string | null | undefined, unrestricted_value?: string | null | undefined, data?: any | null | undefined } | null | undefined, actualAddress?: { __typename?: 'AddressForm', value?: string | null | undefined, unrestricted_value?: string | null | undefined, data?: any | null | undefined } | null | undefined, passportCountry?: { __typename?: 'LabelValueForm', label: string, value: string } | null | undefined, employment?: { __typename?: 'EmploymentForm', isOfficeWorker?: boolean | null | undefined, isSoldier?: boolean | null | undefined, position?: string | null | undefined, whyNoJob?: string | null | undefined, jobPlace?: { __typename?: 'LabelValueForm', label: string, value: string } | null | undefined, organizationName?: { __typename?: 'AddressForm', value?: string | null | undefined, unrestricted_value?: string | null | undefined, data?: any | null | undefined } | null | undefined, jobAddress?: { __typename?: 'AddressForm', value?: string | null | undefined, unrestricted_value?: string | null | undefined, data?: any | null | undefined } | null | undefined, organizationActivity?: { __typename?: 'LabelValueForm', label: string, value: string } | null | undefined, riskGroup?: { __typename?: 'LabelValueForm', label: string, value: string } | null | undefined, profession?: { __typename?: 'LabelValueForm', label: string, value: string } | null | undefined } | null | undefined, anketas?: Array<{ __typename?: 'AnketaInfo', isn: number, id: string, date: string, result?: string | null | undefined, remark?: string | null | undefined } | null | undefined> | null | undefined };

export type LoadAgreementQueryVariables = Exact<{
  id?: InputMaybe<Scalars['Int']>;
}>;


export type LoadAgreementQuery = { __typename?: 'Query', loadAgreement?: { __typename?: 'Doc', id: number, steps?: Array<string> | null | undefined, showFields?: Array<string> | null | undefined, declarationAvailable?: boolean | null | undefined, createAgreementAvailable?: boolean | null | undefined, agreementDeclarationDone?: boolean | null | undefined, isExpressMode?: boolean | null | undefined, isAddendumMode?: boolean | null | undefined, isn?: string | null | undefined, product?: number | null | undefined, draftSubtitle?: string | null | undefined, calcForm?: { __typename?: 'CalcForm', stage?: string | null | undefined, riskLife?: boolean | null | undefined, riskProperty?: boolean | null | undefined, riskTitle?: boolean | null | undefined, policyholderIsBorrower?: boolean | null | undefined, precalcResult?: any | null | undefined, policyholder?: { __typename?: 'ContragentForm', isn?: number | null | undefined, fio?: string | null | undefined, birthday?: string | null | undefined, phone?: string | null | undefined, email?: string | null | undefined, sex?: string | null | undefined, registrationAddressIsActual?: boolean | null | undefined, passportSeries?: string | null | undefined, passportNumber?: string | null | undefined, passportIssueDate?: string | null | undefined, passportDevisionCode?: string | null | undefined, passportIssuedBy?: string | null | undefined, share?: number | null | undefined, anketaIsn?: number | null | undefined, fillingType?: ContragentFillingTypeEnum | null | undefined, anketaSigned?: boolean | null | undefined, anketaFileId?: Array<string> | null | undefined, registrationAddress?: { __typename?: 'AddressForm', value?: string | null | undefined, unrestricted_value?: string | null | undefined, data?: any | null | undefined } | null | undefined, actualAddress?: { __typename?: 'AddressForm', value?: string | null | undefined, unrestricted_value?: string | null | undefined, data?: any | null | undefined } | null | undefined, passportCountry?: { __typename?: 'LabelValueForm', label: string, value: string } | null | undefined, employment?: { __typename?: 'EmploymentForm', isOfficeWorker?: boolean | null | undefined, isSoldier?: boolean | null | undefined, position?: string | null | undefined, whyNoJob?: string | null | undefined, jobPlace?: { __typename?: 'LabelValueForm', label: string, value: string } | null | undefined, organizationName?: { __typename?: 'AddressForm', value?: string | null | undefined, unrestricted_value?: string | null | undefined, data?: any | null | undefined } | null | undefined, jobAddress?: { __typename?: 'AddressForm', value?: string | null | undefined, unrestricted_value?: string | null | undefined, data?: any | null | undefined } | null | undefined, organizationActivity?: { __typename?: 'LabelValueForm', label: string, value: string } | null | undefined, riskGroup?: { __typename?: 'LabelValueForm', label: string, value: string } | null | undefined, profession?: { __typename?: 'LabelValueForm', label: string, value: string } | null | undefined } | null | undefined, anketas?: Array<{ __typename?: 'AnketaInfo', isn: number, id: string, date: string, result?: string | null | undefined, remark?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined, borrower?: { __typename?: 'ContragentForm', isn?: number | null | undefined, fio?: string | null | undefined, birthday?: string | null | undefined, phone?: string | null | undefined, email?: string | null | undefined, sex?: string | null | undefined, registrationAddressIsActual?: boolean | null | undefined, passportSeries?: string | null | undefined, passportNumber?: string | null | undefined, passportIssueDate?: string | null | undefined, passportDevisionCode?: string | null | undefined, passportIssuedBy?: string | null | undefined, share?: number | null | undefined, anketaIsn?: number | null | undefined, fillingType?: ContragentFillingTypeEnum | null | undefined, anketaSigned?: boolean | null | undefined, anketaFileId?: Array<string> | null | undefined, registrationAddress?: { __typename?: 'AddressForm', value?: string | null | undefined, unrestricted_value?: string | null | undefined, data?: any | null | undefined } | null | undefined, actualAddress?: { __typename?: 'AddressForm', value?: string | null | undefined, unrestricted_value?: string | null | undefined, data?: any | null | undefined } | null | undefined, passportCountry?: { __typename?: 'LabelValueForm', label: string, value: string } | null | undefined, employment?: { __typename?: 'EmploymentForm', isOfficeWorker?: boolean | null | undefined, isSoldier?: boolean | null | undefined, position?: string | null | undefined, whyNoJob?: string | null | undefined, jobPlace?: { __typename?: 'LabelValueForm', label: string, value: string } | null | undefined, organizationName?: { __typename?: 'AddressForm', value?: string | null | undefined, unrestricted_value?: string | null | undefined, data?: any | null | undefined } | null | undefined, jobAddress?: { __typename?: 'AddressForm', value?: string | null | undefined, unrestricted_value?: string | null | undefined, data?: any | null | undefined } | null | undefined, organizationActivity?: { __typename?: 'LabelValueForm', label: string, value: string } | null | undefined, riskGroup?: { __typename?: 'LabelValueForm', label: string, value: string } | null | undefined, profession?: { __typename?: 'LabelValueForm', label: string, value: string } | null | undefined } | null | undefined, anketas?: Array<{ __typename?: 'AnketaInfo', isn: number, id: string, date: string, result?: string | null | undefined, remark?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined, credit?: { __typename?: 'CreditForm', insuranceType?: number | null | undefined, creditSum?: number | null | undefined, creditTerms?: number | null | undefined, creditRate?: number | null | undefined, creditIssueDate?: string | null | undefined, creditAgreementNumber?: string | null | undefined, dateBegin?: string | null | undefined, dateExactEnd?: string | null | undefined, periodTypeChoose?: string | null | undefined, firstPayDate?: string | null | undefined, renewReasonOther?: string | null | undefined, borrowerShare?: number | null | undefined, city?: { __typename?: 'AddressForm', value?: string | null | undefined, unrestricted_value?: string | null | undefined, data?: any | null | undefined } | null | undefined, bank?: { __typename?: 'LabelValueForm', label: string, value: string } | null | undefined, salesChannel?: { __typename?: 'LabelValueForm', label: string, value: string } | null | undefined, agent?: { __typename?: 'LabelValueForm', label: string, value: string } | null | undefined, prevSk?: { __typename?: 'LabelValueForm', label: string, value: string } | null | undefined, renewReason?: { __typename?: 'LabelValueForm', label: string, value: string } | null | undefined, birthDateMethod?: { __typename?: 'LabelValueForm', label: string, value: string } | null | undefined, marketing?: { __typename?: 'LabelValueForm', label: string, value: string } | null | undefined } | null | undefined, coBorrowers?: Array<{ __typename?: 'ContragentForm', isn?: number | null | undefined, fio?: string | null | undefined, birthday?: string | null | undefined, phone?: string | null | undefined, email?: string | null | undefined, sex?: string | null | undefined, registrationAddressIsActual?: boolean | null | undefined, passportSeries?: string | null | undefined, passportNumber?: string | null | undefined, passportIssueDate?: string | null | undefined, passportDevisionCode?: string | null | undefined, passportIssuedBy?: string | null | undefined, share?: number | null | undefined, anketaIsn?: number | null | undefined, fillingType?: ContragentFillingTypeEnum | null | undefined, anketaSigned?: boolean | null | undefined, anketaFileId?: Array<string> | null | undefined, registrationAddress?: { __typename?: 'AddressForm', value?: string | null | undefined, unrestricted_value?: string | null | undefined, data?: any | null | undefined } | null | undefined, actualAddress?: { __typename?: 'AddressForm', value?: string | null | undefined, unrestricted_value?: string | null | undefined, data?: any | null | undefined } | null | undefined, passportCountry?: { __typename?: 'LabelValueForm', label: string, value: string } | null | undefined, employment?: { __typename?: 'EmploymentForm', isOfficeWorker?: boolean | null | undefined, isSoldier?: boolean | null | undefined, position?: string | null | undefined, whyNoJob?: string | null | undefined, jobPlace?: { __typename?: 'LabelValueForm', label: string, value: string } | null | undefined, organizationName?: { __typename?: 'AddressForm', value?: string | null | undefined, unrestricted_value?: string | null | undefined, data?: any | null | undefined } | null | undefined, jobAddress?: { __typename?: 'AddressForm', value?: string | null | undefined, unrestricted_value?: string | null | undefined, data?: any | null | undefined } | null | undefined, organizationActivity?: { __typename?: 'LabelValueForm', label: string, value: string } | null | undefined, riskGroup?: { __typename?: 'LabelValueForm', label: string, value: string } | null | undefined, profession?: { __typename?: 'LabelValueForm', label: string, value: string } | null | undefined } | null | undefined, anketas?: Array<{ __typename?: 'AnketaInfo', isn: number, id: string, date: string, result?: string | null | undefined, remark?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined> | null | undefined, propertyObjects?: Array<{ __typename?: 'PropertyObjectForm', propertyAddressMatch?: boolean | null | undefined, pledgeCadastralNumber?: string | null | undefined, pledgeAddressEgrn?: string | null | undefined, propertySumInsured?: number | null | undefined, pledgeShare?: number | null | undefined, objectCost?: number | null | undefined, objectCostByContract?: number | null | undefined, agency?: string | null | undefined, nameOfAppraiser?: string | null | undefined, area?: number | null | undefined, roomsCount?: number | null | undefined, floor?: number | null | undefined, floorCount?: number | null | undefined, buildYear?: number | null | undefined, yearOfCapitalRepair?: number | null | undefined, woodInConstruction?: boolean | null | undefined, alarmInfo?: string | null | undefined, openFireInfo?: string | null | undefined, additionalRisksInfo?: string | null | undefined, objectOfUnfinishedConstruction?: boolean | null | undefined, repairPlanning?: boolean | null | undefined, repairIntervalFrom?: string | null | undefined, repairIntervalTo?: string | null | undefined, riskCoefficient?: number | null | undefined, basementOrAttic?: boolean | null | undefined, interiorDecoration?: boolean | null | undefined, replanPlanning?: boolean | null | undefined, replanIntervalFrom?: string | null | undefined, replanIntervalTo?: string | null | undefined, rent?: boolean | null | undefined, damage?: boolean | null | undefined, propertyPledge?: { __typename?: 'LabelValueForm', label: string, value: string } | null | undefined, propertyPledgeAddress?: { __typename?: 'AddressForm', value?: string | null | undefined, unrestricted_value?: string | null | undefined, data?: any | null | undefined } | null | undefined, wallMaterial?: { __typename?: 'LabelValueForm', label: string, value: string } | null | undefined, floorMaterial?: { __typename?: 'LabelValueForm', label: string, value: string } | null | undefined, alarm?: { __typename?: 'LabelValueForm', label: string, value: string } | null | undefined, openFire?: { __typename?: 'LabelValueForm', label: string, value: string } | null | undefined, additionalRisks?: { __typename?: 'LabelValueForm', label: string, value: string } | null | undefined, purpose?: { __typename?: 'LabelValueForm', label: string, value: string } | null | undefined } | null | undefined> | null | undefined, titleObjects?: Array<{ __typename?: 'TitleObjectForm', titleCadastralNumber?: string | null | undefined, titleShare?: number | null | undefined, objectEncumbrances?: string | null | undefined, minors?: boolean | null | undefined, unregisterPersons?: boolean | null | undefined, litigation?: boolean | null | undefined, addressEgrn?: string | null | undefined, typeEncumbrances?: string | null | undefined, titleAddress?: { __typename?: 'AddressForm', value?: string | null | undefined, unrestricted_value?: string | null | undefined, data?: any | null | undefined } | null | undefined } | null | undefined> | null | undefined, flat?: { __typename?: 'FlatFormForm', date_begin?: string | null | undefined, structural_elements?: number | null | undefined, finishing?: number | null | undefined, movable_property?: number | null | undefined, civil_responsibility?: number | null | undefined, lease?: boolean | null | undefined, renovation?: boolean | null | undefined, alarm_security?: boolean | null | undefined, alarm_fire?: boolean | null | undefined, leakage_protection?: boolean | null | undefined, seller_discount_due_kv?: number | null | undefined, promo_code?: string | null | undefined, build_year?: number | null | undefined, address_match?: boolean | null | undefined, area?: number | null | undefined, rooms_count?: number | null | undefined, premium_sum?: number | null | undefined, old_premium_sum?: number | null | undefined, address?: { __typename?: 'AddressForm', value?: string | null | undefined, unrestricted_value?: string | null | undefined, data?: any | null | undefined } | null | undefined, policy_holder?: { __typename?: 'ContragentForm', isn?: number | null | undefined, fio?: string | null | undefined, birthday?: string | null | undefined, phone?: string | null | undefined, email?: string | null | undefined, sex?: string | null | undefined, registrationAddressIsActual?: boolean | null | undefined, passportSeries?: string | null | undefined, passportNumber?: string | null | undefined, passportIssueDate?: string | null | undefined, passportDevisionCode?: string | null | undefined, passportIssuedBy?: string | null | undefined, share?: number | null | undefined, anketaIsn?: number | null | undefined, fillingType?: ContragentFillingTypeEnum | null | undefined, anketaSigned?: boolean | null | undefined, anketaFileId?: Array<string> | null | undefined, registrationAddress?: { __typename?: 'AddressForm', value?: string | null | undefined, unrestricted_value?: string | null | undefined, data?: any | null | undefined } | null | undefined, actualAddress?: { __typename?: 'AddressForm', value?: string | null | undefined, unrestricted_value?: string | null | undefined, data?: any | null | undefined } | null | undefined, passportCountry?: { __typename?: 'LabelValueForm', label: string, value: string } | null | undefined, employment?: { __typename?: 'EmploymentForm', isOfficeWorker?: boolean | null | undefined, isSoldier?: boolean | null | undefined, position?: string | null | undefined, whyNoJob?: string | null | undefined, jobPlace?: { __typename?: 'LabelValueForm', label: string, value: string } | null | undefined, organizationName?: { __typename?: 'AddressForm', value?: string | null | undefined, unrestricted_value?: string | null | undefined, data?: any | null | undefined } | null | undefined, jobAddress?: { __typename?: 'AddressForm', value?: string | null | undefined, unrestricted_value?: string | null | undefined, data?: any | null | undefined } | null | undefined, organizationActivity?: { __typename?: 'LabelValueForm', label: string, value: string } | null | undefined, riskGroup?: { __typename?: 'LabelValueForm', label: string, value: string } | null | undefined, profession?: { __typename?: 'LabelValueForm', label: string, value: string } | null | undefined } | null | undefined, anketas?: Array<{ __typename?: 'AnketaInfo', isn: number, id: string, date: string, result?: string | null | undefined, remark?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined } | null | undefined } | null | undefined, files?: Array<{ __typename?: 'File', id: string, filename: string, url: string } | null | undefined> | null | undefined } | null | undefined };

export type LoadAgreementUnderwritingQueryVariables = Exact<{
  id?: InputMaybe<Scalars['Int']>;
}>;


export type LoadAgreementUnderwritingQuery = { __typename?: 'Query', loadAgreement?: { __typename?: 'Doc', id: number, number?: string | null | undefined, added?: string | null | undefined, relatedAgreementId?: number | null | undefined, fillingTypeText?: string | null | undefined, status?: { __typename?: 'Status', label?: string | null | undefined, value?: string | null | undefined, color?: string | null | undefined } | null | undefined, user?: { __typename?: 'User', id: number, isSuper: boolean, username: string, group?: { __typename?: 'Group', id: number, name: string } | null | undefined } | null | undefined, calcForm?: { __typename?: 'CalcForm', riskLife?: boolean | null | undefined, riskProperty?: boolean | null | undefined, riskTitle?: boolean | null | undefined } | null | undefined, calculation?: { __typename?: 'Calculation', policyholder_fio?: string | null | undefined, policyholder_birthday?: string | null | undefined, policyholder_email?: string | null | undefined, beneficiary?: string | null | undefined, credit_terms?: number | null | undefined, premium_sum?: number | null | undefined, premium_sum_with_kv?: number | null | undefined, discount_kv?: number | null | undefined, seller_discount_due_kv?: number | null | undefined, discount_kv_sum?: number | null | undefined, agent?: string | null | undefined, bank_kv?: string | null | undefined, is_editable_tariff?: boolean | null | undefined, tariff_group?: { __typename?: 'LabelValueForm', label: string, value: string } | null | undefined, program?: { __typename?: 'LabelValueForm', label: string, value: string } | null | undefined, life_risks?: Array<{ __typename?: 'CalculationRisk', isn?: number | null | undefined, fio?: string | null | undefined, birthday?: string | null | undefined, type?: string | null | undefined, address?: string | null | undefined, property_cost?: number | null | undefined, status?: RiskStatusEnum | null | undefined, limit_sum?: number | null | undefined, base_tariff?: number | null | undefined, base_premium_sum?: number | null | undefined, raising_factor?: number | null | undefined, discount?: number | null | undefined, tariff?: number | null | undefined, premium_sum?: number | null | undefined, high_tariff_height?: number | null | undefined, high_tariff_press?: number | null | undefined, share?: number | null | undefined, remark?: string | null | undefined, autoscoring?: boolean | null | undefined, underwriting_allowed?: boolean | null | undefined } | null | undefined> | null | undefined, property_risks?: Array<{ __typename?: 'CalculationRisk', isn?: number | null | undefined, fio?: string | null | undefined, birthday?: string | null | undefined, type?: string | null | undefined, address?: string | null | undefined, property_cost?: number | null | undefined, status?: RiskStatusEnum | null | undefined, limit_sum?: number | null | undefined, base_tariff?: number | null | undefined, base_premium_sum?: number | null | undefined, raising_factor?: number | null | undefined, discount?: number | null | undefined, tariff?: number | null | undefined, premium_sum?: number | null | undefined, high_tariff_height?: number | null | undefined, high_tariff_press?: number | null | undefined, share?: number | null | undefined, autoscoring?: boolean | null | undefined, underwriting_allowed?: boolean | null | undefined, wood_in_construction?: boolean | null | undefined } | null | undefined> | null | undefined, titul_risks?: Array<{ __typename?: 'CalculationRisk', isn?: number | null | undefined, fio?: string | null | undefined, birthday?: string | null | undefined, type?: string | null | undefined, address?: string | null | undefined, property_cost?: number | null | undefined, status?: RiskStatusEnum | null | undefined, limit_sum?: number | null | undefined, base_tariff?: number | null | undefined, base_premium_sum?: number | null | undefined, raising_factor?: number | null | undefined, discount?: number | null | undefined, tariff?: number | null | undefined, premium_sum?: number | null | undefined, high_tariff_height?: number | null | undefined, high_tariff_press?: number | null | undefined, share?: number | null | undefined, autoscoring?: boolean | null | undefined, underwriting_allowed?: boolean | null | undefined } | null | undefined> | null | undefined, cross_risks?: Array<{ __typename?: 'CalculationRisk', isn?: number | null | undefined, fio?: string | null | undefined, birthday?: string | null | undefined, type?: string | null | undefined, address?: string | null | undefined, property_cost?: number | null | undefined, status?: RiskStatusEnum | null | undefined, limit_sum?: number | null | undefined, base_tariff?: number | null | undefined, base_premium_sum?: number | null | undefined, raising_factor?: number | null | undefined, discount?: number | null | undefined, tariff?: number | null | undefined, premium_sum?: number | null | undefined, high_tariff_height?: number | null | undefined, high_tariff_press?: number | null | undefined, share?: number | null | undefined, autoscoring?: boolean | null | undefined, underwriting_allowed?: boolean | null | undefined } | null | undefined> | null | undefined } | null | undefined, resultDocuments: Array<{ __typename?: 'ResultDocument', name: string, type: PrintTypeEnum, isn: number, templateIsn: number, subject?: string | null | undefined, warning?: string | null | undefined }>, underwriters?: Array<{ __typename?: 'User', id: number, username: string } | null | undefined> | null | undefined } | null | undefined };

export type LoadContractQueryVariables = Exact<{
  id?: InputMaybe<Scalars['Int']>;
}>;


export type LoadContractQuery = { __typename?: 'Query', loadAgreement?: { __typename?: 'Doc', id: number, number?: string | null | undefined, isn?: string | null | undefined, added?: string | null | undefined, relatedCalculationId?: number | null | undefined, readyToSign?: boolean | null | undefined, needProlongation?: boolean | null | undefined, nextInvoiceAllowed?: boolean | null | undefined, isCurrentPeriodPayed?: boolean | null | undefined, nextInvoiceSum?: number | null | undefined, isProlongation?: boolean | null | undefined, prevAgreementIsn?: string | null | undefined, prevAgreementId?: number | null | undefined, nextAgreementIsn?: string | null | undefined, agreementDeclarationDone?: boolean | null | undefined, isExpressMode?: boolean | null | undefined, prevAgreementAnketaIsn?: number | null | undefined, agreementAnketaIsn?: number | null | undefined, agreementAnketaEdit?: boolean | null | undefined, product?: number | null | undefined, status?: { __typename?: 'Status', label?: string | null | undefined, value?: string | null | undefined, color?: string | null | undefined } | null | undefined, user?: { __typename?: 'User', id: number, isSuper: boolean, username: string, group?: { __typename?: 'Group', id: number, name: string } | null | undefined } | null | undefined, calculation?: { __typename?: 'Calculation', premium_sum?: number | null | undefined, premium_sum_with_kv?: number | null | undefined, discount_kv?: number | null | undefined } | null | undefined, agreement?: { __typename?: 'Agreement', premium_sum?: number | null | undefined, premium_sum_with_kv?: number | null | undefined, discount_kv?: number | null | undefined, seller_discount_due_kv?: number | null | undefined, agreement_no?: string | null | undefined, credit_months?: number | null | undefined, credit_rate?: number | null | undefined, currency?: string | null | undefined, date_sign?: string | null | undefined, date_begin?: string | null | undefined, date_end?: string | null | undefined, credit_bank_text?: string | null | undefined, credit_bank_isn?: number | null | undefined, bank_isn?: number | null | undefined, credit_agreement_number?: string | null | undefined, credit_agreement_date?: string | null | undefined, credit_sum?: number | null | undefined, credit_annuitet_sum?: number | null | undefined, is_payed?: boolean | null | undefined, has_cross_sale: boolean, is_declaration: boolean, agent_kv_sum?: number | null | undefined, policyholder?: { __typename?: 'ContragentForm', isn?: number | null | undefined, fio?: string | null | undefined, birthday?: string | null | undefined, phone?: string | null | undefined, email?: string | null | undefined, sex?: string | null | undefined, registrationAddressIsActual?: boolean | null | undefined, passportSeries?: string | null | undefined, passportNumber?: string | null | undefined, passportIssueDate?: string | null | undefined, passportDevisionCode?: string | null | undefined, passportIssuedBy?: string | null | undefined, share?: number | null | undefined, anketaIsn?: number | null | undefined, fillingType?: ContragentFillingTypeEnum | null | undefined, anketaSigned?: boolean | null | undefined, anketaFileId?: Array<string> | null | undefined, registrationAddress?: { __typename?: 'AddressForm', value?: string | null | undefined, unrestricted_value?: string | null | undefined, data?: any | null | undefined } | null | undefined, actualAddress?: { __typename?: 'AddressForm', value?: string | null | undefined, unrestricted_value?: string | null | undefined, data?: any | null | undefined } | null | undefined, passportCountry?: { __typename?: 'LabelValueForm', label: string, value: string } | null | undefined, employment?: { __typename?: 'EmploymentForm', isOfficeWorker?: boolean | null | undefined, isSoldier?: boolean | null | undefined, position?: string | null | undefined, whyNoJob?: string | null | undefined, jobPlace?: { __typename?: 'LabelValueForm', label: string, value: string } | null | undefined, organizationName?: { __typename?: 'AddressForm', value?: string | null | undefined, unrestricted_value?: string | null | undefined, data?: any | null | undefined } | null | undefined, jobAddress?: { __typename?: 'AddressForm', value?: string | null | undefined, unrestricted_value?: string | null | undefined, data?: any | null | undefined } | null | undefined, organizationActivity?: { __typename?: 'LabelValueForm', label: string, value: string } | null | undefined, riskGroup?: { __typename?: 'LabelValueForm', label: string, value: string } | null | undefined, profession?: { __typename?: 'LabelValueForm', label: string, value: string } | null | undefined } | null | undefined, anketas?: Array<{ __typename?: 'AnketaInfo', isn: number, id: string, date: string, result?: string | null | undefined, remark?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined, ins_purpose?: { __typename?: 'LabelValueForm', label: string, value: string } | null | undefined, ins_previous?: { __typename?: 'LabelValueForm', label: string, value: string } | null | undefined, sale_channel?: { __typename?: 'LabelValueForm', label: string, value: string } | null | undefined, agr_role?: Array<{ __typename?: 'AgrRole', role: string, participant: string, date_beg: string, date_end: string } | null | undefined> | null | undefined, life_risks?: Array<{ __typename?: 'CalculationRisk', isn?: number | null | undefined, fio?: string | null | undefined, birthday?: string | null | undefined, type?: string | null | undefined, address?: string | null | undefined, property_cost?: number | null | undefined, status?: RiskStatusEnum | null | undefined, limit_sum?: number | null | undefined, base_tariff?: number | null | undefined, base_premium_sum?: number | null | undefined, raising_factor?: number | null | undefined, discount?: number | null | undefined, tariff?: number | null | undefined, premium_sum?: number | null | undefined, high_tariff_height?: number | null | undefined, high_tariff_press?: number | null | undefined, share?: number | null | undefined, remark?: string | null | undefined, autoscoring?: boolean | null | undefined, underwriting_allowed?: boolean | null | undefined } | null | undefined> | null | undefined, property_risks?: Array<{ __typename?: 'CalculationRisk', isn?: number | null | undefined, fio?: string | null | undefined, birthday?: string | null | undefined, type?: string | null | undefined, address?: string | null | undefined, property_cost?: number | null | undefined, status?: RiskStatusEnum | null | undefined, limit_sum?: number | null | undefined, base_tariff?: number | null | undefined, base_premium_sum?: number | null | undefined, raising_factor?: number | null | undefined, discount?: number | null | undefined, tariff?: number | null | undefined, premium_sum?: number | null | undefined, high_tariff_height?: number | null | undefined, high_tariff_press?: number | null | undefined, share?: number | null | undefined, remark?: string | null | undefined, permanent_sum?: boolean | null | undefined, one_time_pay?: boolean | null | undefined, autoscoring?: boolean | null | undefined, underwriting_allowed?: boolean | null | undefined, wood_in_construction?: boolean | null | undefined } | null | undefined> | null | undefined, titul_risks?: Array<{ __typename?: 'CalculationRisk', isn?: number | null | undefined, fio?: string | null | undefined, birthday?: string | null | undefined, type?: string | null | undefined, address?: string | null | undefined, property_cost?: number | null | undefined, status?: RiskStatusEnum | null | undefined, limit_sum?: number | null | undefined, base_tariff?: number | null | undefined, base_premium_sum?: number | null | undefined, raising_factor?: number | null | undefined, discount?: number | null | undefined, tariff?: number | null | undefined, premium_sum?: number | null | undefined, high_tariff_height?: number | null | undefined, high_tariff_press?: number | null | undefined, share?: number | null | undefined, remark?: string | null | undefined, permanent_sum?: boolean | null | undefined, one_time_pay?: boolean | null | undefined, date_end?: string | null | undefined, autoscoring?: boolean | null | undefined, underwriting_allowed?: boolean | null | undefined } | null | undefined> | null | undefined } | null | undefined, invoices: Array<{ __typename?: 'Invoice', invoiceIsn?: number | null | undefined, invoiceNo?: string | null | undefined, invoiceSum?: number | null | undefined, summName?: string | null | undefined, invoiceCaption?: string | null | undefined, agreementIsn?: number | null | undefined, agreementNo?: string | null | undefined, isAlreadyPayed?: boolean | null | undefined, types: Array<{ __typename?: 'IsnNamePair', isn: string, name: string }> }>, resultDocuments: Array<{ __typename?: 'ResultDocument', name: string, isn: number, type: PrintTypeEnum, templateIsn: number, subject?: string | null | undefined, warning?: string | null | undefined }>, subAgreements?: Array<{ __typename?: 'SubAgreement', name: string, payed?: boolean | null | undefined, created_at?: string | null | undefined, premium_sum?: number | null | undefined, status?: { __typename?: 'Status', label?: string | null | undefined, value?: string | null | undefined, color?: string | null | undefined } | null | undefined } | null | undefined> | null | undefined, crossSale?: { __typename?: 'CrossSale', number?: string | null | undefined, sign?: string | null | undefined, begin?: string | null | undefined, end?: string | null | undefined, premium_sum?: number | null | undefined } | null | undefined } | null | undefined };

export type LoadFlatContractQueryVariables = Exact<{
  id?: InputMaybe<Scalars['Int']>;
}>;


export type LoadFlatContractQuery = { __typename?: 'Query', loadAgreement?: { __typename?: 'Doc', id: number, number?: string | null | undefined, isn?: string | null | undefined, added?: string | null | undefined, relatedCalculationId?: number | null | undefined, flatPremiumSum?: number | null | undefined, status?: { __typename?: 'Status', label?: string | null | undefined, value?: string | null | undefined, color?: string | null | undefined } | null | undefined, user?: { __typename?: 'User', id: number, isSuper: boolean, username: string, group?: { __typename?: 'Group', id: number, name: string } | null | undefined } | null | undefined, calcForm?: { __typename?: 'CalcForm', policyholder?: { __typename?: 'ContragentForm', isn?: number | null | undefined, fio?: string | null | undefined, birthday?: string | null | undefined, phone?: string | null | undefined, email?: string | null | undefined, sex?: string | null | undefined, registrationAddressIsActual?: boolean | null | undefined, passportSeries?: string | null | undefined, passportNumber?: string | null | undefined, passportIssueDate?: string | null | undefined, passportDevisionCode?: string | null | undefined, passportIssuedBy?: string | null | undefined, share?: number | null | undefined, anketaIsn?: number | null | undefined, fillingType?: ContragentFillingTypeEnum | null | undefined, anketaSigned?: boolean | null | undefined, anketaFileId?: Array<string> | null | undefined, registrationAddress?: { __typename?: 'AddressForm', value?: string | null | undefined, unrestricted_value?: string | null | undefined, data?: any | null | undefined } | null | undefined, actualAddress?: { __typename?: 'AddressForm', value?: string | null | undefined, unrestricted_value?: string | null | undefined, data?: any | null | undefined } | null | undefined, passportCountry?: { __typename?: 'LabelValueForm', label: string, value: string } | null | undefined, employment?: { __typename?: 'EmploymentForm', isOfficeWorker?: boolean | null | undefined, isSoldier?: boolean | null | undefined, position?: string | null | undefined, whyNoJob?: string | null | undefined, jobPlace?: { __typename?: 'LabelValueForm', label: string, value: string } | null | undefined, organizationName?: { __typename?: 'AddressForm', value?: string | null | undefined, unrestricted_value?: string | null | undefined, data?: any | null | undefined } | null | undefined, jobAddress?: { __typename?: 'AddressForm', value?: string | null | undefined, unrestricted_value?: string | null | undefined, data?: any | null | undefined } | null | undefined, organizationActivity?: { __typename?: 'LabelValueForm', label: string, value: string } | null | undefined, riskGroup?: { __typename?: 'LabelValueForm', label: string, value: string } | null | undefined, profession?: { __typename?: 'LabelValueForm', label: string, value: string } | null | undefined } | null | undefined, anketas?: Array<{ __typename?: 'AnketaInfo', isn: number, id: string, date: string, result?: string | null | undefined, remark?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined, flat?: { __typename?: 'FlatFormForm', date_begin?: string | null | undefined, structural_elements?: number | null | undefined, finishing?: number | null | undefined, movable_property?: number | null | undefined, civil_responsibility?: number | null | undefined, lease?: boolean | null | undefined, renovation?: boolean | null | undefined, alarm_security?: boolean | null | undefined, alarm_fire?: boolean | null | undefined, leakage_protection?: boolean | null | undefined, seller_discount_due_kv?: number | null | undefined, promo_code?: string | null | undefined, build_year?: number | null | undefined, address_match?: boolean | null | undefined, area?: number | null | undefined, rooms_count?: number | null | undefined, address?: { __typename?: 'AddressForm', value?: string | null | undefined, unrestricted_value?: string | null | undefined, data?: any | null | undefined } | null | undefined } | null | undefined } | null | undefined, agreement?: { __typename?: 'Agreement', is_payed?: boolean | null | undefined } | null | undefined } | null | undefined };

export type LoadCrossContractQueryVariables = Exact<{
  id?: InputMaybe<Scalars['Int']>;
}>;


export type LoadCrossContractQuery = { __typename?: 'Query', loadAgreement?: { __typename?: 'Doc', id: number, number?: string | null | undefined, isn?: string | null | undefined, added?: string | null | undefined, product?: number | null | undefined, status?: { __typename?: 'Status', label?: string | null | undefined, value?: string | null | undefined, color?: string | null | undefined } | null | undefined, user?: { __typename?: 'User', id: number, isSuper: boolean, username: string, group?: { __typename?: 'Group', id: number, name: string } | null | undefined } | null | undefined, agreement?: { __typename?: 'Agreement', premium_sum?: number | null | undefined, premium_sum_with_kv?: number | null | undefined, discount_kv?: number | null | undefined, seller_discount_due_kv?: number | null | undefined, agreement_no?: string | null | undefined, credit_months?: number | null | undefined, credit_rate?: number | null | undefined, currency?: string | null | undefined, date_sign?: string | null | undefined, date_begin?: string | null | undefined, date_end?: string | null | undefined, credit_bank_text?: string | null | undefined, credit_bank_isn?: number | null | undefined, credit_agreement_number?: string | null | undefined, credit_agreement_date?: string | null | undefined, credit_sum?: number | null | undefined, credit_annuitet_sum?: number | null | undefined, is_payed?: boolean | null | undefined, agent_kv_sum?: number | null | undefined, policyholder?: { __typename?: 'ContragentForm', isn?: number | null | undefined, fio?: string | null | undefined, birthday?: string | null | undefined, phone?: string | null | undefined, email?: string | null | undefined, sex?: string | null | undefined, registrationAddressIsActual?: boolean | null | undefined, passportSeries?: string | null | undefined, passportNumber?: string | null | undefined, passportIssueDate?: string | null | undefined, passportDevisionCode?: string | null | undefined, passportIssuedBy?: string | null | undefined, share?: number | null | undefined, anketaIsn?: number | null | undefined, fillingType?: ContragentFillingTypeEnum | null | undefined, anketaSigned?: boolean | null | undefined, anketaFileId?: Array<string> | null | undefined, registrationAddress?: { __typename?: 'AddressForm', value?: string | null | undefined, unrestricted_value?: string | null | undefined, data?: any | null | undefined } | null | undefined, actualAddress?: { __typename?: 'AddressForm', value?: string | null | undefined, unrestricted_value?: string | null | undefined, data?: any | null | undefined } | null | undefined, passportCountry?: { __typename?: 'LabelValueForm', label: string, value: string } | null | undefined, employment?: { __typename?: 'EmploymentForm', isOfficeWorker?: boolean | null | undefined, isSoldier?: boolean | null | undefined, position?: string | null | undefined, whyNoJob?: string | null | undefined, jobPlace?: { __typename?: 'LabelValueForm', label: string, value: string } | null | undefined, organizationName?: { __typename?: 'AddressForm', value?: string | null | undefined, unrestricted_value?: string | null | undefined, data?: any | null | undefined } | null | undefined, jobAddress?: { __typename?: 'AddressForm', value?: string | null | undefined, unrestricted_value?: string | null | undefined, data?: any | null | undefined } | null | undefined, organizationActivity?: { __typename?: 'LabelValueForm', label: string, value: string } | null | undefined, riskGroup?: { __typename?: 'LabelValueForm', label: string, value: string } | null | undefined, profession?: { __typename?: 'LabelValueForm', label: string, value: string } | null | undefined } | null | undefined, anketas?: Array<{ __typename?: 'AnketaInfo', isn: number, id: string, date: string, result?: string | null | undefined, remark?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined, ins_purpose?: { __typename?: 'LabelValueForm', label: string, value: string } | null | undefined, ins_previous?: { __typename?: 'LabelValueForm', label: string, value: string } | null | undefined, sale_channel?: { __typename?: 'LabelValueForm', label: string, value: string } | null | undefined, agr_role?: Array<{ __typename?: 'AgrRole', role: string, participant: string, date_beg: string, date_end: string } | null | undefined> | null | undefined } | null | undefined, invoices: Array<{ __typename?: 'Invoice', invoiceIsn?: number | null | undefined, invoiceNo?: string | null | undefined, invoiceSum?: number | null | undefined, summName?: string | null | undefined, invoiceCaption?: string | null | undefined, agreementIsn?: number | null | undefined, agreementNo?: string | null | undefined, isAlreadyPayed?: boolean | null | undefined, types: Array<{ __typename?: 'IsnNamePair', isn: string, name: string }> }>, resultDocuments: Array<{ __typename?: 'ResultDocument', name: string, isn: number, type: PrintTypeEnum, templateIsn: number, subject?: string | null | undefined, warning?: string | null | undefined }>, crossDetails?: { __typename?: 'CrossDetails', address?: string | null | undefined, sum?: number | null | undefined, interior?: number | null | undefined, responsibility?: number | null | undefined, property?: number | null | undefined } | null | undefined } | null | undefined };

export type SearchContragentQueryVariables = Exact<{
  id?: InputMaybe<Scalars['Int']>;
  fullname?: InputMaybe<Scalars['String']>;
  birthday?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  isn?: InputMaybe<Scalars['String']>;
}>;


export type SearchContragentQuery = { __typename?: 'Query', searchContragent?: { __typename?: 'ContragentForm', isn?: number | null | undefined, fio?: string | null | undefined, birthday?: string | null | undefined, phone?: string | null | undefined, email?: string | null | undefined, sex?: string | null | undefined, registrationAddressIsActual?: boolean | null | undefined, passportSeries?: string | null | undefined, passportNumber?: string | null | undefined, passportIssueDate?: string | null | undefined, passportDevisionCode?: string | null | undefined, passportIssuedBy?: string | null | undefined, share?: number | null | undefined, anketaIsn?: number | null | undefined, fillingType?: ContragentFillingTypeEnum | null | undefined, anketaSigned?: boolean | null | undefined, anketaFileId?: Array<string> | null | undefined, registrationAddress?: { __typename?: 'AddressForm', value?: string | null | undefined, unrestricted_value?: string | null | undefined, data?: any | null | undefined } | null | undefined, actualAddress?: { __typename?: 'AddressForm', value?: string | null | undefined, unrestricted_value?: string | null | undefined, data?: any | null | undefined } | null | undefined, passportCountry?: { __typename?: 'LabelValueForm', label: string, value: string } | null | undefined, employment?: { __typename?: 'EmploymentForm', isOfficeWorker?: boolean | null | undefined, isSoldier?: boolean | null | undefined, position?: string | null | undefined, whyNoJob?: string | null | undefined, jobPlace?: { __typename?: 'LabelValueForm', label: string, value: string } | null | undefined, organizationName?: { __typename?: 'AddressForm', value?: string | null | undefined, unrestricted_value?: string | null | undefined, data?: any | null | undefined } | null | undefined, jobAddress?: { __typename?: 'AddressForm', value?: string | null | undefined, unrestricted_value?: string | null | undefined, data?: any | null | undefined } | null | undefined, organizationActivity?: { __typename?: 'LabelValueForm', label: string, value: string } | null | undefined, riskGroup?: { __typename?: 'LabelValueForm', label: string, value: string } | null | undefined, profession?: { __typename?: 'LabelValueForm', label: string, value: string } | null | undefined } | null | undefined, anketas?: Array<{ __typename?: 'AnketaInfo', isn: number, id: string, date: string, result?: string | null | undefined, remark?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type LoadMessagesQueryVariables = Exact<{
  id?: InputMaybe<Scalars['Int']>;
}>;


export type LoadMessagesQuery = { __typename?: 'Query', loadAgreement?: { __typename?: 'Doc', id: number, comments?: Array<{ __typename?: 'Comment', id: number, text?: string | null | undefined, date?: string | null | undefined, isNew?: boolean | null | undefined, user?: { __typename?: 'User', id: number, full_name: string } | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type LoadChangeLogQueryVariables = Exact<{
  id?: InputMaybe<Scalars['Int']>;
}>;


export type LoadChangeLogQuery = { __typename?: 'Query', loadAgreement?: { __typename?: 'Doc', id: number, activity_log?: Array<{ __typename?: 'Activity', added?: string | null | undefined, event?: string | null | undefined, eventName?: string | null | undefined, description?: string | null | undefined, user?: { __typename?: 'User', id: number, username: string } | null | undefined, adminUser?: { __typename?: 'User', id: number, username: string } | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type LoadFilesQueryVariables = Exact<{
  id?: InputMaybe<Scalars['Int']>;
}>;


export type LoadFilesQuery = { __typename?: 'Query', loadAgreement?: { __typename?: 'Doc', id: number, calcForm?: { __typename?: 'CalcForm', riskLife?: boolean | null | undefined, riskProperty?: boolean | null | undefined, riskTitle?: boolean | null | undefined } | null | undefined, files?: Array<{ __typename?: 'File', id: string, filename: string, url: string } | null | undefined> | null | undefined } | null | undefined };

export type LoadAnketaQueryVariables = Exact<{
  id?: InputMaybe<Scalars['Int']>;
}>;


export type LoadAnketaQuery = { __typename?: 'Query', loadAgreement?: { __typename?: 'Doc', id: number, anketa?: Array<{ __typename?: 'ViewAnketaPart', name: string, questions: Array<{ __typename?: 'ViewAnketaQuestion', question: string, answer: string } | null | undefined> } | null | undefined> | null | undefined } | null | undefined };

export type AnketaQueryVariables = Exact<{
  id: Scalars['Int'];
  contragentIsn: Scalars['Int'];
}>;


export type AnketaQuery = { __typename?: 'Query', anketa?: Array<{ __typename?: 'AnketaPart', key?: string | null | undefined, text?: string | null | undefined, questions?: Array<{ __typename?: 'AnketaQuestion', isn?: number | null | undefined, type?: string | null | undefined, text?: string | null | undefined, value?: string | null | undefined, remark?: string | null | undefined, dicti?: Array<{ __typename?: 'IsnNamePair', isn: string, name: string } | null | undefined> | null | undefined } | null | undefined> | null | undefined } | null | undefined> | null | undefined };

export type ChangeLogQueryVariables = Exact<{
  model?: InputMaybe<ChangeLogTableEnum>;
  id: Scalars['Int'];
}>;


export type ChangeLogQuery = { __typename?: 'Query', changeLog?: Array<{ __typename?: 'ChangeEventType', createdAt?: string | null | undefined, comment?: string | null | undefined, user?: { __typename?: 'User', id: number, name: string } | null | undefined, fields?: Array<{ __typename?: 'ChangeFieldType', field?: string | null | undefined, label?: string | null | undefined, oldValue?: string | null | undefined, newValue?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined> | null | undefined };

export type AdminMessageQueryVariables = Exact<{ [key: string]: never; }>;


export type AdminMessageQuery = { __typename?: 'Query', adminMessage?: string | null | undefined };

export type MessagesQueryVariables = Exact<{ [key: string]: never; }>;


export type MessagesQuery = { __typename?: 'Query', messages?: Array<{ __typename?: 'Message', id: number, text: string }> | null | undefined };

export const PersonFragmentDoc = gql`
    fragment Person on User {
  id
  full_name
  username
  email
  phone
}
    `;
export const AddressFragmentDoc = gql`
    fragment Address on AddressForm {
  value
  unrestricted_value
  data
}
    `;
export const SelectFragmentDoc = gql`
    fragment Select on LabelValueForm {
  label
  value
}
    `;
export const EmploymentFragmentDoc = gql`
    fragment Employment on EmploymentForm {
  jobPlace {
    ...Select
  }
  organizationName {
    ...Address
  }
  jobAddress {
    ...Address
  }
  isOfficeWorker
  isSoldier
  position
  organizationActivity {
    ...Select
  }
  riskGroup {
    ...Select
  }
  profession {
    ...Select
  }
  whyNoJob
}
    ${SelectFragmentDoc}
${AddressFragmentDoc}`;
export const ContragentFragmentDoc = gql`
    fragment Contragent on ContragentForm {
  isn
  fio
  birthday
  phone
  email
  sex
  registrationAddress {
    ...Address
  }
  actualAddress {
    ...Address
  }
  registrationAddressIsActual
  passportCountry {
    ...Select
  }
  passportSeries
  passportNumber
  passportIssueDate
  passportDevisionCode
  passportIssuedBy
  share
  employment {
    ...Employment
  }
  anketaIsn
  fillingType
  anketaSigned
  anketaFileId
  anketas {
    isn
    id
    date
    result
    remark
  }
}
    ${AddressFragmentDoc}
${SelectFragmentDoc}
${EmploymentFragmentDoc}`;
export const SignInDocument = gql`
    mutation signIn($username: String!, $password: String!, $isClient: Boolean) {
  signIn(username: $username, password: $password, isClient: $isClient) {
    id
    isSuper
    type
    permissions
  }
}
    `;
export type SignInMutationFn = Apollo.MutationFunction<SignInMutation, SignInMutationVariables>;

/**
 * __useSignInMutation__
 *
 * To run a mutation, you first call `useSignInMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignInMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signInMutation, { data, loading, error }] = useSignInMutation({
 *   variables: {
 *      username: // value for 'username'
 *      password: // value for 'password'
 *      isClient: // value for 'isClient'
 *   },
 * });
 */
export function useSignInMutation(baseOptions?: Apollo.MutationHookOptions<SignInMutation, SignInMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SignInMutation, SignInMutationVariables>(SignInDocument, options);
      }
export type SignInMutationHookResult = ReturnType<typeof useSignInMutation>;
export type SignInMutationResult = Apollo.MutationResult<SignInMutation>;
export type SignInMutationOptions = Apollo.BaseMutationOptions<SignInMutation, SignInMutationVariables>;
export const PasswordDocument = gql`
    mutation password($old_password: String!, $new_password: String!) {
  password(old_password: $old_password, new_password: $new_password) {
    id
  }
}
    `;
export type PasswordMutationFn = Apollo.MutationFunction<PasswordMutation, PasswordMutationVariables>;

/**
 * __usePasswordMutation__
 *
 * To run a mutation, you first call `usePasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [passwordMutation, { data, loading, error }] = usePasswordMutation({
 *   variables: {
 *      old_password: // value for 'old_password'
 *      new_password: // value for 'new_password'
 *   },
 * });
 */
export function usePasswordMutation(baseOptions?: Apollo.MutationHookOptions<PasswordMutation, PasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PasswordMutation, PasswordMutationVariables>(PasswordDocument, options);
      }
export type PasswordMutationHookResult = ReturnType<typeof usePasswordMutation>;
export type PasswordMutationResult = Apollo.MutationResult<PasswordMutation>;
export type PasswordMutationOptions = Apollo.BaseMutationOptions<PasswordMutation, PasswordMutationVariables>;
export const SignInAsDocument = gql`
    mutation signInAs($id: Int!) {
  signInAs(id: $id) {
    id
    isSuper
    type
    permissions
  }
}
    `;
export type SignInAsMutationFn = Apollo.MutationFunction<SignInAsMutation, SignInAsMutationVariables>;

/**
 * __useSignInAsMutation__
 *
 * To run a mutation, you first call `useSignInAsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignInAsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signInAsMutation, { data, loading, error }] = useSignInAsMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSignInAsMutation(baseOptions?: Apollo.MutationHookOptions<SignInAsMutation, SignInAsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SignInAsMutation, SignInAsMutationVariables>(SignInAsDocument, options);
      }
export type SignInAsMutationHookResult = ReturnType<typeof useSignInAsMutation>;
export type SignInAsMutationResult = Apollo.MutationResult<SignInAsMutation>;
export type SignInAsMutationOptions = Apollo.BaseMutationOptions<SignInAsMutation, SignInAsMutationVariables>;
export const CreateUpdateRoleDocument = gql`
    mutation createUpdateRole($id: Int, $input: RoleInput) {
  role(id: $id, input: $input) {
    id
  }
}
    `;
export type CreateUpdateRoleMutationFn = Apollo.MutationFunction<CreateUpdateRoleMutation, CreateUpdateRoleMutationVariables>;

/**
 * __useCreateUpdateRoleMutation__
 *
 * To run a mutation, you first call `useCreateUpdateRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUpdateRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUpdateRoleMutation, { data, loading, error }] = useCreateUpdateRoleMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateUpdateRoleMutation(baseOptions?: Apollo.MutationHookOptions<CreateUpdateRoleMutation, CreateUpdateRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUpdateRoleMutation, CreateUpdateRoleMutationVariables>(CreateUpdateRoleDocument, options);
      }
export type CreateUpdateRoleMutationHookResult = ReturnType<typeof useCreateUpdateRoleMutation>;
export type CreateUpdateRoleMutationResult = Apollo.MutationResult<CreateUpdateRoleMutation>;
export type CreateUpdateRoleMutationOptions = Apollo.BaseMutationOptions<CreateUpdateRoleMutation, CreateUpdateRoleMutationVariables>;
export const CreateUpdateUserDocument = gql`
    mutation createUpdateUser($id: Int, $input: UserInput) {
  user(id: $id, input: $input)
}
    `;
export type CreateUpdateUserMutationFn = Apollo.MutationFunction<CreateUpdateUserMutation, CreateUpdateUserMutationVariables>;

/**
 * __useCreateUpdateUserMutation__
 *
 * To run a mutation, you first call `useCreateUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUpdateUserMutation, { data, loading, error }] = useCreateUpdateUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateUpdateUserMutation(baseOptions?: Apollo.MutationHookOptions<CreateUpdateUserMutation, CreateUpdateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUpdateUserMutation, CreateUpdateUserMutationVariables>(CreateUpdateUserDocument, options);
      }
export type CreateUpdateUserMutationHookResult = ReturnType<typeof useCreateUpdateUserMutation>;
export type CreateUpdateUserMutationResult = Apollo.MutationResult<CreateUpdateUserMutation>;
export type CreateUpdateUserMutationOptions = Apollo.BaseMutationOptions<CreateUpdateUserMutation, CreateUpdateUserMutationVariables>;
export const RestrictionsDocument = gql`
    mutation restrictions($userId: String, $groupId: String, $restrictions: [RestrictionInput], $comment: String) {
  restrictions(
    user_id: $userId
    group_id: $groupId
    restrictions: $restrictions
    comment: $comment
  )
}
    `;
export type RestrictionsMutationFn = Apollo.MutationFunction<RestrictionsMutation, RestrictionsMutationVariables>;

/**
 * __useRestrictionsMutation__
 *
 * To run a mutation, you first call `useRestrictionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestrictionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restrictionsMutation, { data, loading, error }] = useRestrictionsMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      groupId: // value for 'groupId'
 *      restrictions: // value for 'restrictions'
 *      comment: // value for 'comment'
 *   },
 * });
 */
export function useRestrictionsMutation(baseOptions?: Apollo.MutationHookOptions<RestrictionsMutation, RestrictionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RestrictionsMutation, RestrictionsMutationVariables>(RestrictionsDocument, options);
      }
export type RestrictionsMutationHookResult = ReturnType<typeof useRestrictionsMutation>;
export type RestrictionsMutationResult = Apollo.MutationResult<RestrictionsMutation>;
export type RestrictionsMutationOptions = Apollo.BaseMutationOptions<RestrictionsMutation, RestrictionsMutationVariables>;
export const CreateUpdateGroupDocument = gql`
    mutation createUpdateGroup($id: Int, $input: GroupInput) {
  group(id: $id, input: $input) {
    id
  }
}
    `;
export type CreateUpdateGroupMutationFn = Apollo.MutationFunction<CreateUpdateGroupMutation, CreateUpdateGroupMutationVariables>;

/**
 * __useCreateUpdateGroupMutation__
 *
 * To run a mutation, you first call `useCreateUpdateGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUpdateGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUpdateGroupMutation, { data, loading, error }] = useCreateUpdateGroupMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateUpdateGroupMutation(baseOptions?: Apollo.MutationHookOptions<CreateUpdateGroupMutation, CreateUpdateGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUpdateGroupMutation, CreateUpdateGroupMutationVariables>(CreateUpdateGroupDocument, options);
      }
export type CreateUpdateGroupMutationHookResult = ReturnType<typeof useCreateUpdateGroupMutation>;
export type CreateUpdateGroupMutationResult = Apollo.MutationResult<CreateUpdateGroupMutation>;
export type CreateUpdateGroupMutationOptions = Apollo.BaseMutationOptions<CreateUpdateGroupMutation, CreateUpdateGroupMutationVariables>;
export const DeleteGroupDocument = gql`
    mutation deleteGroup($id: Int!) {
  deleteGroup(id: $id)
}
    `;
export type DeleteGroupMutationFn = Apollo.MutationFunction<DeleteGroupMutation, DeleteGroupMutationVariables>;

/**
 * __useDeleteGroupMutation__
 *
 * To run a mutation, you first call `useDeleteGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteGroupMutation, { data, loading, error }] = useDeleteGroupMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteGroupMutation(baseOptions?: Apollo.MutationHookOptions<DeleteGroupMutation, DeleteGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteGroupMutation, DeleteGroupMutationVariables>(DeleteGroupDocument, options);
      }
export type DeleteGroupMutationHookResult = ReturnType<typeof useDeleteGroupMutation>;
export type DeleteGroupMutationResult = Apollo.MutationResult<DeleteGroupMutation>;
export type DeleteGroupMutationOptions = Apollo.BaseMutationOptions<DeleteGroupMutation, DeleteGroupMutationVariables>;
export const DeleteUserDocument = gql`
    mutation deleteUser($id: Int!) {
  deleteUser(id: $id)
}
    `;
export type DeleteUserMutationFn = Apollo.MutationFunction<DeleteUserMutation, DeleteUserMutationVariables>;

/**
 * __useDeleteUserMutation__
 *
 * To run a mutation, you first call `useDeleteUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserMutation, { data, loading, error }] = useDeleteUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteUserMutation(baseOptions?: Apollo.MutationHookOptions<DeleteUserMutation, DeleteUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteUserMutation, DeleteUserMutationVariables>(DeleteUserDocument, options);
      }
export type DeleteUserMutationHookResult = ReturnType<typeof useDeleteUserMutation>;
export type DeleteUserMutationResult = Apollo.MutationResult<DeleteUserMutation>;
export type DeleteUserMutationOptions = Apollo.BaseMutationOptions<DeleteUserMutation, DeleteUserMutationVariables>;
export const DeleteRoleDocument = gql`
    mutation deleteRole($id: Int!) {
  deleteRole(id: $id)
}
    `;
export type DeleteRoleMutationFn = Apollo.MutationFunction<DeleteRoleMutation, DeleteRoleMutationVariables>;

/**
 * __useDeleteRoleMutation__
 *
 * To run a mutation, you first call `useDeleteRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRoleMutation, { data, loading, error }] = useDeleteRoleMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteRoleMutation(baseOptions?: Apollo.MutationHookOptions<DeleteRoleMutation, DeleteRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteRoleMutation, DeleteRoleMutationVariables>(DeleteRoleDocument, options);
      }
export type DeleteRoleMutationHookResult = ReturnType<typeof useDeleteRoleMutation>;
export type DeleteRoleMutationResult = Apollo.MutationResult<DeleteRoleMutation>;
export type DeleteRoleMutationOptions = Apollo.BaseMutationOptions<DeleteRoleMutation, DeleteRoleMutationVariables>;
export const DeleteAgreementDocument = gql`
    mutation deleteAgreement($id: Int!) {
  deleteAgreement(id: $id)
}
    `;
export type DeleteAgreementMutationFn = Apollo.MutationFunction<DeleteAgreementMutation, DeleteAgreementMutationVariables>;

/**
 * __useDeleteAgreementMutation__
 *
 * To run a mutation, you first call `useDeleteAgreementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAgreementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAgreementMutation, { data, loading, error }] = useDeleteAgreementMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteAgreementMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAgreementMutation, DeleteAgreementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAgreementMutation, DeleteAgreementMutationVariables>(DeleteAgreementDocument, options);
      }
export type DeleteAgreementMutationHookResult = ReturnType<typeof useDeleteAgreementMutation>;
export type DeleteAgreementMutationResult = Apollo.MutationResult<DeleteAgreementMutation>;
export type DeleteAgreementMutationOptions = Apollo.BaseMutationOptions<DeleteAgreementMutation, DeleteAgreementMutationVariables>;
export const AnnulAgreementDocument = gql`
    mutation annulAgreement($id: Int!) {
  annulAgreement(id: $id)
}
    `;
export type AnnulAgreementMutationFn = Apollo.MutationFunction<AnnulAgreementMutation, AnnulAgreementMutationVariables>;

/**
 * __useAnnulAgreementMutation__
 *
 * To run a mutation, you first call `useAnnulAgreementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAnnulAgreementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [annulAgreementMutation, { data, loading, error }] = useAnnulAgreementMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAnnulAgreementMutation(baseOptions?: Apollo.MutationHookOptions<AnnulAgreementMutation, AnnulAgreementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AnnulAgreementMutation, AnnulAgreementMutationVariables>(AnnulAgreementDocument, options);
      }
export type AnnulAgreementMutationHookResult = ReturnType<typeof useAnnulAgreementMutation>;
export type AnnulAgreementMutationResult = Apollo.MutationResult<AnnulAgreementMutation>;
export type AnnulAgreementMutationOptions = Apollo.BaseMutationOptions<AnnulAgreementMutation, AnnulAgreementMutationVariables>;
export const LogoutDocument = gql`
    mutation logout {
  logout
}
    `;
export type LogoutMutationFn = Apollo.MutationFunction<LogoutMutation, LogoutMutationVariables>;

/**
 * __useLogoutMutation__
 *
 * To run a mutation, you first call `useLogoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLogoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [logoutMutation, { data, loading, error }] = useLogoutMutation({
 *   variables: {
 *   },
 * });
 */
export function useLogoutMutation(baseOptions?: Apollo.MutationHookOptions<LogoutMutation, LogoutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LogoutMutation, LogoutMutationVariables>(LogoutDocument, options);
      }
export type LogoutMutationHookResult = ReturnType<typeof useLogoutMutation>;
export type LogoutMutationResult = Apollo.MutationResult<LogoutMutation>;
export type LogoutMutationOptions = Apollo.BaseMutationOptions<LogoutMutation, LogoutMutationVariables>;
export const SaveAgreementDocument = gql`
    mutation saveAgreement($id: Int, $calcForm: CalcFormInput, $product: Int, $fromPrecalc: Boolean) {
  saveAgreement(
    id: $id
    calcForm: $calcForm
    product: $product
    fromPrecalc: $fromPrecalc
  )
}
    `;
export type SaveAgreementMutationFn = Apollo.MutationFunction<SaveAgreementMutation, SaveAgreementMutationVariables>;

/**
 * __useSaveAgreementMutation__
 *
 * To run a mutation, you first call `useSaveAgreementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveAgreementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveAgreementMutation, { data, loading, error }] = useSaveAgreementMutation({
 *   variables: {
 *      id: // value for 'id'
 *      calcForm: // value for 'calcForm'
 *      product: // value for 'product'
 *      fromPrecalc: // value for 'fromPrecalc'
 *   },
 * });
 */
export function useSaveAgreementMutation(baseOptions?: Apollo.MutationHookOptions<SaveAgreementMutation, SaveAgreementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveAgreementMutation, SaveAgreementMutationVariables>(SaveAgreementDocument, options);
      }
export type SaveAgreementMutationHookResult = ReturnType<typeof useSaveAgreementMutation>;
export type SaveAgreementMutationResult = Apollo.MutationResult<SaveAgreementMutation>;
export type SaveAgreementMutationOptions = Apollo.BaseMutationOptions<SaveAgreementMutation, SaveAgreementMutationVariables>;
export const SaveFlatDocument = gql`
    mutation saveFlat($id: Int!, $calcForm: FlatFormInput, $doCalc: Boolean, $doRegister: Boolean) {
  saveFlat(id: $id, calcForm: $calcForm, doCalc: $doCalc, doRegister: $doRegister) {
    limit_sum
    premium_sum
    old_premium_sum
    isn
    number
    details {
      name
      limit_sum
      premium_sum
    }
  }
}
    `;
export type SaveFlatMutationFn = Apollo.MutationFunction<SaveFlatMutation, SaveFlatMutationVariables>;

/**
 * __useSaveFlatMutation__
 *
 * To run a mutation, you first call `useSaveFlatMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveFlatMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveFlatMutation, { data, loading, error }] = useSaveFlatMutation({
 *   variables: {
 *      id: // value for 'id'
 *      calcForm: // value for 'calcForm'
 *      doCalc: // value for 'doCalc'
 *      doRegister: // value for 'doRegister'
 *   },
 * });
 */
export function useSaveFlatMutation(baseOptions?: Apollo.MutationHookOptions<SaveFlatMutation, SaveFlatMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveFlatMutation, SaveFlatMutationVariables>(SaveFlatDocument, options);
      }
export type SaveFlatMutationHookResult = ReturnType<typeof useSaveFlatMutation>;
export type SaveFlatMutationResult = Apollo.MutationResult<SaveFlatMutation>;
export type SaveFlatMutationOptions = Apollo.BaseMutationOptions<SaveFlatMutation, SaveFlatMutationVariables>;
export const RegisterAgreementDocument = gql`
    mutation registerAgreement($id: Int!) {
  registerAgreement(id: $id)
}
    `;
export type RegisterAgreementMutationFn = Apollo.MutationFunction<RegisterAgreementMutation, RegisterAgreementMutationVariables>;

/**
 * __useRegisterAgreementMutation__
 *
 * To run a mutation, you first call `useRegisterAgreementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterAgreementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerAgreementMutation, { data, loading, error }] = useRegisterAgreementMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRegisterAgreementMutation(baseOptions?: Apollo.MutationHookOptions<RegisterAgreementMutation, RegisterAgreementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegisterAgreementMutation, RegisterAgreementMutationVariables>(RegisterAgreementDocument, options);
      }
export type RegisterAgreementMutationHookResult = ReturnType<typeof useRegisterAgreementMutation>;
export type RegisterAgreementMutationResult = Apollo.MutationResult<RegisterAgreementMutation>;
export type RegisterAgreementMutationOptions = Apollo.BaseMutationOptions<RegisterAgreementMutation, RegisterAgreementMutationVariables>;
export const AgreementToDraftDocument = gql`
    mutation agreementToDraft($id: Int!) {
  agreementToDraft(id: $id)
}
    `;
export type AgreementToDraftMutationFn = Apollo.MutationFunction<AgreementToDraftMutation, AgreementToDraftMutationVariables>;

/**
 * __useAgreementToDraftMutation__
 *
 * To run a mutation, you first call `useAgreementToDraftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAgreementToDraftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [agreementToDraftMutation, { data, loading, error }] = useAgreementToDraftMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAgreementToDraftMutation(baseOptions?: Apollo.MutationHookOptions<AgreementToDraftMutation, AgreementToDraftMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AgreementToDraftMutation, AgreementToDraftMutationVariables>(AgreementToDraftDocument, options);
      }
export type AgreementToDraftMutationHookResult = ReturnType<typeof useAgreementToDraftMutation>;
export type AgreementToDraftMutationResult = Apollo.MutationResult<AgreementToDraftMutation>;
export type AgreementToDraftMutationOptions = Apollo.BaseMutationOptions<AgreementToDraftMutation, AgreementToDraftMutationVariables>;
export const SignAgreementDocument = gql`
    mutation signAgreement($id: Int!) {
  signAgreement(id: $id)
}
    `;
export type SignAgreementMutationFn = Apollo.MutationFunction<SignAgreementMutation, SignAgreementMutationVariables>;

/**
 * __useSignAgreementMutation__
 *
 * To run a mutation, you first call `useSignAgreementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignAgreementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signAgreementMutation, { data, loading, error }] = useSignAgreementMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSignAgreementMutation(baseOptions?: Apollo.MutationHookOptions<SignAgreementMutation, SignAgreementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SignAgreementMutation, SignAgreementMutationVariables>(SignAgreementDocument, options);
      }
export type SignAgreementMutationHookResult = ReturnType<typeof useSignAgreementMutation>;
export type SignAgreementMutationResult = Apollo.MutationResult<SignAgreementMutation>;
export type SignAgreementMutationOptions = Apollo.BaseMutationOptions<SignAgreementMutation, SignAgreementMutationVariables>;
export const UnsignAgreementDocument = gql`
    mutation unsignAgreement($id: Int!) {
  unsignAgreement(id: $id)
}
    `;
export type UnsignAgreementMutationFn = Apollo.MutationFunction<UnsignAgreementMutation, UnsignAgreementMutationVariables>;

/**
 * __useUnsignAgreementMutation__
 *
 * To run a mutation, you first call `useUnsignAgreementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnsignAgreementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unsignAgreementMutation, { data, loading, error }] = useUnsignAgreementMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUnsignAgreementMutation(baseOptions?: Apollo.MutationHookOptions<UnsignAgreementMutation, UnsignAgreementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnsignAgreementMutation, UnsignAgreementMutationVariables>(UnsignAgreementDocument, options);
      }
export type UnsignAgreementMutationHookResult = ReturnType<typeof useUnsignAgreementMutation>;
export type UnsignAgreementMutationResult = Apollo.MutationResult<UnsignAgreementMutation>;
export type UnsignAgreementMutationOptions = Apollo.BaseMutationOptions<UnsignAgreementMutation, UnsignAgreementMutationVariables>;
export const SaveAnketaDocument = gql`
    mutation saveAnketa($id: Int!, $contragentIsn: Int!, $questions: object) {
  saveAnketa(id: $id, contragentIsn: $contragentIsn, questions: $questions) {
    anketaIsn
  }
}
    `;
export type SaveAnketaMutationFn = Apollo.MutationFunction<SaveAnketaMutation, SaveAnketaMutationVariables>;

/**
 * __useSaveAnketaMutation__
 *
 * To run a mutation, you first call `useSaveAnketaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveAnketaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveAnketaMutation, { data, loading, error }] = useSaveAnketaMutation({
 *   variables: {
 *      id: // value for 'id'
 *      contragentIsn: // value for 'contragentIsn'
 *      questions: // value for 'questions'
 *   },
 * });
 */
export function useSaveAnketaMutation(baseOptions?: Apollo.MutationHookOptions<SaveAnketaMutation, SaveAnketaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveAnketaMutation, SaveAnketaMutationVariables>(SaveAnketaDocument, options);
      }
export type SaveAnketaMutationHookResult = ReturnType<typeof useSaveAnketaMutation>;
export type SaveAnketaMutationResult = Apollo.MutationResult<SaveAnketaMutation>;
export type SaveAnketaMutationOptions = Apollo.BaseMutationOptions<SaveAnketaMutation, SaveAnketaMutationVariables>;
export const PrintExpressCalculationDocument = gql`
    mutation printExpressCalculation($isn: [String!]) {
  printExpressCalculation(isn: $isn) {
    id
    filename
    url
  }
}
    `;
export type PrintExpressCalculationMutationFn = Apollo.MutationFunction<PrintExpressCalculationMutation, PrintExpressCalculationMutationVariables>;

/**
 * __usePrintExpressCalculationMutation__
 *
 * To run a mutation, you first call `usePrintExpressCalculationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePrintExpressCalculationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [printExpressCalculationMutation, { data, loading, error }] = usePrintExpressCalculationMutation({
 *   variables: {
 *      isn: // value for 'isn'
 *   },
 * });
 */
export function usePrintExpressCalculationMutation(baseOptions?: Apollo.MutationHookOptions<PrintExpressCalculationMutation, PrintExpressCalculationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PrintExpressCalculationMutation, PrintExpressCalculationMutationVariables>(PrintExpressCalculationDocument, options);
      }
export type PrintExpressCalculationMutationHookResult = ReturnType<typeof usePrintExpressCalculationMutation>;
export type PrintExpressCalculationMutationResult = Apollo.MutationResult<PrintExpressCalculationMutation>;
export type PrintExpressCalculationMutationOptions = Apollo.BaseMutationOptions<PrintExpressCalculationMutation, PrintExpressCalculationMutationVariables>;
export const SendAnketaSmsDocument = gql`
    mutation sendAnketaSms($id: Int!, $contragentIsn: Int!, $isDeclaration: Boolean) {
  sendAnketaSms(
    id: $id
    contragentIsn: $contragentIsn
    isDeclaration: $isDeclaration
  )
}
    `;
export type SendAnketaSmsMutationFn = Apollo.MutationFunction<SendAnketaSmsMutation, SendAnketaSmsMutationVariables>;

/**
 * __useSendAnketaSmsMutation__
 *
 * To run a mutation, you first call `useSendAnketaSmsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendAnketaSmsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendAnketaSmsMutation, { data, loading, error }] = useSendAnketaSmsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      contragentIsn: // value for 'contragentIsn'
 *      isDeclaration: // value for 'isDeclaration'
 *   },
 * });
 */
export function useSendAnketaSmsMutation(baseOptions?: Apollo.MutationHookOptions<SendAnketaSmsMutation, SendAnketaSmsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendAnketaSmsMutation, SendAnketaSmsMutationVariables>(SendAnketaSmsDocument, options);
      }
export type SendAnketaSmsMutationHookResult = ReturnType<typeof useSendAnketaSmsMutation>;
export type SendAnketaSmsMutationResult = Apollo.MutationResult<SendAnketaSmsMutation>;
export type SendAnketaSmsMutationOptions = Apollo.BaseMutationOptions<SendAnketaSmsMutation, SendAnketaSmsMutationVariables>;
export const SignAnketaDocument = gql`
    mutation signAnketa($id: Int!, $contragentIsn: Int!, $code: String!, $isDeclaration: Boolean) {
  signAnketa(
    id: $id
    contragentIsn: $contragentIsn
    code: $code
    isDeclaration: $isDeclaration
  )
}
    `;
export type SignAnketaMutationFn = Apollo.MutationFunction<SignAnketaMutation, SignAnketaMutationVariables>;

/**
 * __useSignAnketaMutation__
 *
 * To run a mutation, you first call `useSignAnketaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignAnketaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signAnketaMutation, { data, loading, error }] = useSignAnketaMutation({
 *   variables: {
 *      id: // value for 'id'
 *      contragentIsn: // value for 'contragentIsn'
 *      code: // value for 'code'
 *      isDeclaration: // value for 'isDeclaration'
 *   },
 * });
 */
export function useSignAnketaMutation(baseOptions?: Apollo.MutationHookOptions<SignAnketaMutation, SignAnketaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SignAnketaMutation, SignAnketaMutationVariables>(SignAnketaDocument, options);
      }
export type SignAnketaMutationHookResult = ReturnType<typeof useSignAnketaMutation>;
export type SignAnketaMutationResult = Apollo.MutationResult<SignAnketaMutation>;
export type SignAnketaMutationOptions = Apollo.BaseMutationOptions<SignAnketaMutation, SignAnketaMutationVariables>;
export const PrintDocument = gql`
    mutation print($isn: Int!, $type: PrintTypeEnum!, $template: PrintTemplateEnum, $templateIsn: Int, $email: String, $subject: String, $contragentIsn: Int) {
  print(
    isn: $isn
    type: $type
    template: $template
    templateIsn: $templateIsn
    email: $email
    subject: $subject
    contragentIsn: $contragentIsn
  ) {
    id
    filename
    url
  }
}
    `;
export type PrintMutationFn = Apollo.MutationFunction<PrintMutation, PrintMutationVariables>;

/**
 * __usePrintMutation__
 *
 * To run a mutation, you first call `usePrintMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePrintMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [printMutation, { data, loading, error }] = usePrintMutation({
 *   variables: {
 *      isn: // value for 'isn'
 *      type: // value for 'type'
 *      template: // value for 'template'
 *      templateIsn: // value for 'templateIsn'
 *      email: // value for 'email'
 *      subject: // value for 'subject'
 *      contragentIsn: // value for 'contragentIsn'
 *   },
 * });
 */
export function usePrintMutation(baseOptions?: Apollo.MutationHookOptions<PrintMutation, PrintMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PrintMutation, PrintMutationVariables>(PrintDocument, options);
      }
export type PrintMutationHookResult = ReturnType<typeof usePrintMutation>;
export type PrintMutationResult = Apollo.MutationResult<PrintMutation>;
export type PrintMutationOptions = Apollo.BaseMutationOptions<PrintMutation, PrintMutationVariables>;
export const DownloadAllDocument = gql`
    mutation downloadAll($id: Int) {
  downloadAll(id: $id) {
    id
    filename
    url
  }
}
    `;
export type DownloadAllMutationFn = Apollo.MutationFunction<DownloadAllMutation, DownloadAllMutationVariables>;

/**
 * __useDownloadAllMutation__
 *
 * To run a mutation, you first call `useDownloadAllMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDownloadAllMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [downloadAllMutation, { data, loading, error }] = useDownloadAllMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDownloadAllMutation(baseOptions?: Apollo.MutationHookOptions<DownloadAllMutation, DownloadAllMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DownloadAllMutation, DownloadAllMutationVariables>(DownloadAllDocument, options);
      }
export type DownloadAllMutationHookResult = ReturnType<typeof useDownloadAllMutation>;
export type DownloadAllMutationResult = Apollo.MutationResult<DownloadAllMutation>;
export type DownloadAllMutationOptions = Apollo.BaseMutationOptions<DownloadAllMutation, DownloadAllMutationVariables>;
export const AddAgreementFilesDocument = gql`
    mutation addAgreementFiles($agreementId: Int!, $files: [Upload], $context: AgreementFileContextEnum!) {
  addAgreementFiles(agreement_id: $agreementId, files: $files, context: $context) {
    id
  }
}
    `;
export type AddAgreementFilesMutationFn = Apollo.MutationFunction<AddAgreementFilesMutation, AddAgreementFilesMutationVariables>;

/**
 * __useAddAgreementFilesMutation__
 *
 * To run a mutation, you first call `useAddAgreementFilesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddAgreementFilesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addAgreementFilesMutation, { data, loading, error }] = useAddAgreementFilesMutation({
 *   variables: {
 *      agreementId: // value for 'agreementId'
 *      files: // value for 'files'
 *      context: // value for 'context'
 *   },
 * });
 */
export function useAddAgreementFilesMutation(baseOptions?: Apollo.MutationHookOptions<AddAgreementFilesMutation, AddAgreementFilesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddAgreementFilesMutation, AddAgreementFilesMutationVariables>(AddAgreementFilesDocument, options);
      }
export type AddAgreementFilesMutationHookResult = ReturnType<typeof useAddAgreementFilesMutation>;
export type AddAgreementFilesMutationResult = Apollo.MutationResult<AddAgreementFilesMutation>;
export type AddAgreementFilesMutationOptions = Apollo.BaseMutationOptions<AddAgreementFilesMutation, AddAgreementFilesMutationVariables>;
export const CalculateAgreementDocument = gql`
    mutation calculateAgreement($id: Int!) {
  calculateAgreement(id: $id)
}
    `;
export type CalculateAgreementMutationFn = Apollo.MutationFunction<CalculateAgreementMutation, CalculateAgreementMutationVariables>;

/**
 * __useCalculateAgreementMutation__
 *
 * To run a mutation, you first call `useCalculateAgreementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCalculateAgreementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [calculateAgreementMutation, { data, loading, error }] = useCalculateAgreementMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCalculateAgreementMutation(baseOptions?: Apollo.MutationHookOptions<CalculateAgreementMutation, CalculateAgreementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CalculateAgreementMutation, CalculateAgreementMutationVariables>(CalculateAgreementDocument, options);
      }
export type CalculateAgreementMutationHookResult = ReturnType<typeof useCalculateAgreementMutation>;
export type CalculateAgreementMutationResult = Apollo.MutationResult<CalculateAgreementMutation>;
export type CalculateAgreementMutationOptions = Apollo.BaseMutationOptions<CalculateAgreementMutation, CalculateAgreementMutationVariables>;
export const ChangeCalculationDocument = gql`
    mutation changeCalculation($id: Int, $input: ChangeCalculationInput) {
  changeCalculation(id: $id, input: $input)
}
    `;
export type ChangeCalculationMutationFn = Apollo.MutationFunction<ChangeCalculationMutation, ChangeCalculationMutationVariables>;

/**
 * __useChangeCalculationMutation__
 *
 * To run a mutation, you first call `useChangeCalculationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeCalculationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeCalculationMutation, { data, loading, error }] = useChangeCalculationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useChangeCalculationMutation(baseOptions?: Apollo.MutationHookOptions<ChangeCalculationMutation, ChangeCalculationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeCalculationMutation, ChangeCalculationMutationVariables>(ChangeCalculationDocument, options);
      }
export type ChangeCalculationMutationHookResult = ReturnType<typeof useChangeCalculationMutation>;
export type ChangeCalculationMutationResult = Apollo.MutationResult<ChangeCalculationMutation>;
export type ChangeCalculationMutationOptions = Apollo.BaseMutationOptions<ChangeCalculationMutation, ChangeCalculationMutationVariables>;
export const ChangeAgreementDocument = gql`
    mutation changeAgreement($id: Int, $input: ChangeAgreementInput) {
  changeAgreement(id: $id, input: $input)
}
    `;
export type ChangeAgreementMutationFn = Apollo.MutationFunction<ChangeAgreementMutation, ChangeAgreementMutationVariables>;

/**
 * __useChangeAgreementMutation__
 *
 * To run a mutation, you first call `useChangeAgreementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeAgreementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeAgreementMutation, { data, loading, error }] = useChangeAgreementMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useChangeAgreementMutation(baseOptions?: Apollo.MutationHookOptions<ChangeAgreementMutation, ChangeAgreementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeAgreementMutation, ChangeAgreementMutationVariables>(ChangeAgreementDocument, options);
      }
export type ChangeAgreementMutationHookResult = ReturnType<typeof useChangeAgreementMutation>;
export type ChangeAgreementMutationResult = Apollo.MutationResult<ChangeAgreementMutation>;
export type ChangeAgreementMutationOptions = Apollo.BaseMutationOptions<ChangeAgreementMutation, ChangeAgreementMutationVariables>;
export const CommentDocument = gql`
    mutation comment($id: Int!, $text: String!) {
  comment(id: $id, text: $text) {
    id
  }
}
    `;
export type CommentMutationFn = Apollo.MutationFunction<CommentMutation, CommentMutationVariables>;

/**
 * __useCommentMutation__
 *
 * To run a mutation, you first call `useCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [commentMutation, { data, loading, error }] = useCommentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      text: // value for 'text'
 *   },
 * });
 */
export function useCommentMutation(baseOptions?: Apollo.MutationHookOptions<CommentMutation, CommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CommentMutation, CommentMutationVariables>(CommentDocument, options);
      }
export type CommentMutationHookResult = ReturnType<typeof useCommentMutation>;
export type CommentMutationResult = Apollo.MutationResult<CommentMutation>;
export type CommentMutationOptions = Apollo.BaseMutationOptions<CommentMutation, CommentMutationVariables>;
export const ViewCommentDocument = gql`
    mutation viewComment($id: [Int!]) {
  viewComment(id: $id)
}
    `;
export type ViewCommentMutationFn = Apollo.MutationFunction<ViewCommentMutation, ViewCommentMutationVariables>;

/**
 * __useViewCommentMutation__
 *
 * To run a mutation, you first call `useViewCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useViewCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [viewCommentMutation, { data, loading, error }] = useViewCommentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useViewCommentMutation(baseOptions?: Apollo.MutationHookOptions<ViewCommentMutation, ViewCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ViewCommentMutation, ViewCommentMutationVariables>(ViewCommentDocument, options);
      }
export type ViewCommentMutationHookResult = ReturnType<typeof useViewCommentMutation>;
export type ViewCommentMutationResult = Apollo.MutationResult<ViewCommentMutation>;
export type ViewCommentMutationOptions = Apollo.BaseMutationOptions<ViewCommentMutation, ViewCommentMutationVariables>;
export const PrepareInvoiceDocument = gql`
    mutation prepareInvoice($id: Int!, $isn: Int) {
  prepareInvoice(id: $id, isn: $isn)
}
    `;
export type PrepareInvoiceMutationFn = Apollo.MutationFunction<PrepareInvoiceMutation, PrepareInvoiceMutationVariables>;

/**
 * __usePrepareInvoiceMutation__
 *
 * To run a mutation, you first call `usePrepareInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePrepareInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [prepareInvoiceMutation, { data, loading, error }] = usePrepareInvoiceMutation({
 *   variables: {
 *      id: // value for 'id'
 *      isn: // value for 'isn'
 *   },
 * });
 */
export function usePrepareInvoiceMutation(baseOptions?: Apollo.MutationHookOptions<PrepareInvoiceMutation, PrepareInvoiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PrepareInvoiceMutation, PrepareInvoiceMutationVariables>(PrepareInvoiceDocument, options);
      }
export type PrepareInvoiceMutationHookResult = ReturnType<typeof usePrepareInvoiceMutation>;
export type PrepareInvoiceMutationResult = Apollo.MutationResult<PrepareInvoiceMutation>;
export type PrepareInvoiceMutationOptions = Apollo.BaseMutationOptions<PrepareInvoiceMutation, PrepareInvoiceMutationVariables>;
export const SendPaymentLinkDocument = gql`
    mutation sendPaymentLink($agreementIsn: Int!, $phone: String, $email: String, $isSendFinish: Boolean, $agreementNo: String, $premiumSum: Float) {
  sendPaymentLink(
    agreementIsn: $agreementIsn
    phone: $phone
    email: $email
    isSendFinish: $isSendFinish
    agreementNo: $agreementNo
    premiumSum: $premiumSum
  )
}
    `;
export type SendPaymentLinkMutationFn = Apollo.MutationFunction<SendPaymentLinkMutation, SendPaymentLinkMutationVariables>;

/**
 * __useSendPaymentLinkMutation__
 *
 * To run a mutation, you first call `useSendPaymentLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendPaymentLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendPaymentLinkMutation, { data, loading, error }] = useSendPaymentLinkMutation({
 *   variables: {
 *      agreementIsn: // value for 'agreementIsn'
 *      phone: // value for 'phone'
 *      email: // value for 'email'
 *      isSendFinish: // value for 'isSendFinish'
 *      agreementNo: // value for 'agreementNo'
 *      premiumSum: // value for 'premiumSum'
 *   },
 * });
 */
export function useSendPaymentLinkMutation(baseOptions?: Apollo.MutationHookOptions<SendPaymentLinkMutation, SendPaymentLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendPaymentLinkMutation, SendPaymentLinkMutationVariables>(SendPaymentLinkDocument, options);
      }
export type SendPaymentLinkMutationHookResult = ReturnType<typeof useSendPaymentLinkMutation>;
export type SendPaymentLinkMutationResult = Apollo.MutationResult<SendPaymentLinkMutation>;
export type SendPaymentLinkMutationOptions = Apollo.BaseMutationOptions<SendPaymentLinkMutation, SendPaymentLinkMutationVariables>;
export const SendDeclarationTextDocument = gql`
    mutation sendDeclarationText($email: String!, $type: String) {
  sendDeclarationText(email: $email, type: $type)
}
    `;
export type SendDeclarationTextMutationFn = Apollo.MutationFunction<SendDeclarationTextMutation, SendDeclarationTextMutationVariables>;

/**
 * __useSendDeclarationTextMutation__
 *
 * To run a mutation, you first call `useSendDeclarationTextMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendDeclarationTextMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendDeclarationTextMutation, { data, loading, error }] = useSendDeclarationTextMutation({
 *   variables: {
 *      email: // value for 'email'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useSendDeclarationTextMutation(baseOptions?: Apollo.MutationHookOptions<SendDeclarationTextMutation, SendDeclarationTextMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendDeclarationTextMutation, SendDeclarationTextMutationVariables>(SendDeclarationTextDocument, options);
      }
export type SendDeclarationTextMutationHookResult = ReturnType<typeof useSendDeclarationTextMutation>;
export type SendDeclarationTextMutationResult = Apollo.MutationResult<SendDeclarationTextMutation>;
export type SendDeclarationTextMutationOptions = Apollo.BaseMutationOptions<SendDeclarationTextMutation, SendDeclarationTextMutationVariables>;
export const ApplyKvDocument = gql`
    mutation applyKv($id: Int!, $kv: Float!) {
  applyKv(id: $id, kv: $kv)
}
    `;
export type ApplyKvMutationFn = Apollo.MutationFunction<ApplyKvMutation, ApplyKvMutationVariables>;

/**
 * __useApplyKvMutation__
 *
 * To run a mutation, you first call `useApplyKvMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApplyKvMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [applyKvMutation, { data, loading, error }] = useApplyKvMutation({
 *   variables: {
 *      id: // value for 'id'
 *      kv: // value for 'kv'
 *   },
 * });
 */
export function useApplyKvMutation(baseOptions?: Apollo.MutationHookOptions<ApplyKvMutation, ApplyKvMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApplyKvMutation, ApplyKvMutationVariables>(ApplyKvDocument, options);
      }
export type ApplyKvMutationHookResult = ReturnType<typeof useApplyKvMutation>;
export type ApplyKvMutationResult = Apollo.MutationResult<ApplyKvMutation>;
export type ApplyKvMutationOptions = Apollo.BaseMutationOptions<ApplyKvMutation, ApplyKvMutationVariables>;
export const DisapproveDocument = gql`
    mutation disapprove($id: Int!, $risk_isns: [Int!]) {
  disapprove(id: $id, risk_isns: $risk_isns)
}
    `;
export type DisapproveMutationFn = Apollo.MutationFunction<DisapproveMutation, DisapproveMutationVariables>;

/**
 * __useDisapproveMutation__
 *
 * To run a mutation, you first call `useDisapproveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisapproveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disapproveMutation, { data, loading, error }] = useDisapproveMutation({
 *   variables: {
 *      id: // value for 'id'
 *      risk_isns: // value for 'risk_isns'
 *   },
 * });
 */
export function useDisapproveMutation(baseOptions?: Apollo.MutationHookOptions<DisapproveMutation, DisapproveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DisapproveMutation, DisapproveMutationVariables>(DisapproveDocument, options);
      }
export type DisapproveMutationHookResult = ReturnType<typeof useDisapproveMutation>;
export type DisapproveMutationResult = Apollo.MutationResult<DisapproveMutation>;
export type DisapproveMutationOptions = Apollo.BaseMutationOptions<DisapproveMutation, DisapproveMutationVariables>;
export const ProlongDocument = gql`
    mutation prolong($isn: String!, $date_sign: String, $sum: Float, $agent: LabelValueInput) {
  prolong(isn: $isn, date_sign: $date_sign, sum: $sum, agent: $agent)
}
    `;
export type ProlongMutationFn = Apollo.MutationFunction<ProlongMutation, ProlongMutationVariables>;

/**
 * __useProlongMutation__
 *
 * To run a mutation, you first call `useProlongMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProlongMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [prolongMutation, { data, loading, error }] = useProlongMutation({
 *   variables: {
 *      isn: // value for 'isn'
 *      date_sign: // value for 'date_sign'
 *      sum: // value for 'sum'
 *      agent: // value for 'agent'
 *   },
 * });
 */
export function useProlongMutation(baseOptions?: Apollo.MutationHookOptions<ProlongMutation, ProlongMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProlongMutation, ProlongMutationVariables>(ProlongDocument, options);
      }
export type ProlongMutationHookResult = ReturnType<typeof useProlongMutation>;
export type ProlongMutationResult = Apollo.MutationResult<ProlongMutation>;
export type ProlongMutationOptions = Apollo.BaseMutationOptions<ProlongMutation, ProlongMutationVariables>;
export const UpdateContragentFillingDocument = gql`
    mutation updateContragentFilling($id: Int!, $contragentIsn: Int!, $fillingType: ContragentFillingTypeEnum) {
  updateContragentFilling(
    id: $id
    contragentIsn: $contragentIsn
    fillingType: $fillingType
  )
}
    `;
export type UpdateContragentFillingMutationFn = Apollo.MutationFunction<UpdateContragentFillingMutation, UpdateContragentFillingMutationVariables>;

/**
 * __useUpdateContragentFillingMutation__
 *
 * To run a mutation, you first call `useUpdateContragentFillingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateContragentFillingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateContragentFillingMutation, { data, loading, error }] = useUpdateContragentFillingMutation({
 *   variables: {
 *      id: // value for 'id'
 *      contragentIsn: // value for 'contragentIsn'
 *      fillingType: // value for 'fillingType'
 *   },
 * });
 */
export function useUpdateContragentFillingMutation(baseOptions?: Apollo.MutationHookOptions<UpdateContragentFillingMutation, UpdateContragentFillingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateContragentFillingMutation, UpdateContragentFillingMutationVariables>(UpdateContragentFillingDocument, options);
      }
export type UpdateContragentFillingMutationHookResult = ReturnType<typeof useUpdateContragentFillingMutation>;
export type UpdateContragentFillingMutationResult = Apollo.MutationResult<UpdateContragentFillingMutation>;
export type UpdateContragentFillingMutationOptions = Apollo.BaseMutationOptions<UpdateContragentFillingMutation, UpdateContragentFillingMutationVariables>;
export const SearchAgreementDocument = gql`
    mutation searchAgreement($number: String!) {
  searchAgreement(number: $number)
}
    `;
export type SearchAgreementMutationFn = Apollo.MutationFunction<SearchAgreementMutation, SearchAgreementMutationVariables>;

/**
 * __useSearchAgreementMutation__
 *
 * To run a mutation, you first call `useSearchAgreementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSearchAgreementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [searchAgreementMutation, { data, loading, error }] = useSearchAgreementMutation({
 *   variables: {
 *      number: // value for 'number'
 *   },
 * });
 */
export function useSearchAgreementMutation(baseOptions?: Apollo.MutationHookOptions<SearchAgreementMutation, SearchAgreementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SearchAgreementMutation, SearchAgreementMutationVariables>(SearchAgreementDocument, options);
      }
export type SearchAgreementMutationHookResult = ReturnType<typeof useSearchAgreementMutation>;
export type SearchAgreementMutationResult = Apollo.MutationResult<SearchAgreementMutation>;
export type SearchAgreementMutationOptions = Apollo.BaseMutationOptions<SearchAgreementMutation, SearchAgreementMutationVariables>;
export const AddendumDocument = gql`
    mutation addendum($id: Int!, $reason: AddendumReasonEnum!, $exclude: AddendumExcludeInput, $recalc: AddendumRecalcInput) {
  addendum(id: $id, reason: $reason, exclude: $exclude, recalc: $recalc)
}
    `;
export type AddendumMutationFn = Apollo.MutationFunction<AddendumMutation, AddendumMutationVariables>;

/**
 * __useAddendumMutation__
 *
 * To run a mutation, you first call `useAddendumMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddendumMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addendumMutation, { data, loading, error }] = useAddendumMutation({
 *   variables: {
 *      id: // value for 'id'
 *      reason: // value for 'reason'
 *      exclude: // value for 'exclude'
 *      recalc: // value for 'recalc'
 *   },
 * });
 */
export function useAddendumMutation(baseOptions?: Apollo.MutationHookOptions<AddendumMutation, AddendumMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddendumMutation, AddendumMutationVariables>(AddendumDocument, options);
      }
export type AddendumMutationHookResult = ReturnType<typeof useAddendumMutation>;
export type AddendumMutationResult = Apollo.MutationResult<AddendumMutation>;
export type AddendumMutationOptions = Apollo.BaseMutationOptions<AddendumMutation, AddendumMutationVariables>;
export const SendToSbDocument = gql`
    mutation sendToSb($id: Int!, $input: SendToSbInput) {
  sendToSb(id: $id, input: $input)
}
    `;
export type SendToSbMutationFn = Apollo.MutationFunction<SendToSbMutation, SendToSbMutationVariables>;

/**
 * __useSendToSbMutation__
 *
 * To run a mutation, you first call `useSendToSbMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendToSbMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendToSbMutation, { data, loading, error }] = useSendToSbMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendToSbMutation(baseOptions?: Apollo.MutationHookOptions<SendToSbMutation, SendToSbMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendToSbMutation, SendToSbMutationVariables>(SendToSbDocument, options);
      }
export type SendToSbMutationHookResult = ReturnType<typeof useSendToSbMutation>;
export type SendToSbMutationResult = Apollo.MutationResult<SendToSbMutation>;
export type SendToSbMutationOptions = Apollo.BaseMutationOptions<SendToSbMutation, SendToSbMutationVariables>;
export const CrossDocument = gql`
    mutation cross($id: Int, $isn: Int, $date_sign: String, $responsibility: Float, $interior: Float, $property: Float, $register: Boolean) {
  cross(
    id: $id
    isn: $isn
    date_sign: $date_sign
    responsibility: $responsibility
    interior: $interior
    property: $property
    register: $register
  )
}
    `;
export type CrossMutationFn = Apollo.MutationFunction<CrossMutation, CrossMutationVariables>;

/**
 * __useCrossMutation__
 *
 * To run a mutation, you first call `useCrossMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCrossMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [crossMutation, { data, loading, error }] = useCrossMutation({
 *   variables: {
 *      id: // value for 'id'
 *      isn: // value for 'isn'
 *      date_sign: // value for 'date_sign'
 *      responsibility: // value for 'responsibility'
 *      interior: // value for 'interior'
 *      property: // value for 'property'
 *      register: // value for 'register'
 *   },
 * });
 */
export function useCrossMutation(baseOptions?: Apollo.MutationHookOptions<CrossMutation, CrossMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CrossMutation, CrossMutationVariables>(CrossDocument, options);
      }
export type CrossMutationHookResult = ReturnType<typeof useCrossMutation>;
export type CrossMutationResult = Apollo.MutationResult<CrossMutation>;
export type CrossMutationOptions = Apollo.BaseMutationOptions<CrossMutation, CrossMutationVariables>;
export const RemoveCrossDocument = gql`
    mutation removeCross($id: Int!) {
  removeCross(id: $id)
}
    `;
export type RemoveCrossMutationFn = Apollo.MutationFunction<RemoveCrossMutation, RemoveCrossMutationVariables>;

/**
 * __useRemoveCrossMutation__
 *
 * To run a mutation, you first call `useRemoveCrossMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveCrossMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeCrossMutation, { data, loading, error }] = useRemoveCrossMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveCrossMutation(baseOptions?: Apollo.MutationHookOptions<RemoveCrossMutation, RemoveCrossMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveCrossMutation, RemoveCrossMutationVariables>(RemoveCrossDocument, options);
      }
export type RemoveCrossMutationHookResult = ReturnType<typeof useRemoveCrossMutation>;
export type RemoveCrossMutationResult = Apollo.MutationResult<RemoveCrossMutation>;
export type RemoveCrossMutationOptions = Apollo.BaseMutationOptions<RemoveCrossMutation, RemoveCrossMutationVariables>;
export const AssignAgreementDocument = gql`
    mutation assignAgreement($id: Int!) {
  assignAgreement(id: $id)
}
    `;
export type AssignAgreementMutationFn = Apollo.MutationFunction<AssignAgreementMutation, AssignAgreementMutationVariables>;

/**
 * __useAssignAgreementMutation__
 *
 * To run a mutation, you first call `useAssignAgreementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignAgreementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignAgreementMutation, { data, loading, error }] = useAssignAgreementMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAssignAgreementMutation(baseOptions?: Apollo.MutationHookOptions<AssignAgreementMutation, AssignAgreementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssignAgreementMutation, AssignAgreementMutationVariables>(AssignAgreementDocument, options);
      }
export type AssignAgreementMutationHookResult = ReturnType<typeof useAssignAgreementMutation>;
export type AssignAgreementMutationResult = Apollo.MutationResult<AssignAgreementMutation>;
export type AssignAgreementMutationOptions = Apollo.BaseMutationOptions<AssignAgreementMutation, AssignAgreementMutationVariables>;
export const ContinueWithAnketaDocument = gql`
    mutation continueWithAnketa($id: Int!, $anketaIsn: Int!) {
  continueWithAnketa(id: $id, anketaIsn: $anketaIsn)
}
    `;
export type ContinueWithAnketaMutationFn = Apollo.MutationFunction<ContinueWithAnketaMutation, ContinueWithAnketaMutationVariables>;

/**
 * __useContinueWithAnketaMutation__
 *
 * To run a mutation, you first call `useContinueWithAnketaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContinueWithAnketaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [continueWithAnketaMutation, { data, loading, error }] = useContinueWithAnketaMutation({
 *   variables: {
 *      id: // value for 'id'
 *      anketaIsn: // value for 'anketaIsn'
 *   },
 * });
 */
export function useContinueWithAnketaMutation(baseOptions?: Apollo.MutationHookOptions<ContinueWithAnketaMutation, ContinueWithAnketaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ContinueWithAnketaMutation, ContinueWithAnketaMutationVariables>(ContinueWithAnketaDocument, options);
      }
export type ContinueWithAnketaMutationHookResult = ReturnType<typeof useContinueWithAnketaMutation>;
export type ContinueWithAnketaMutationResult = Apollo.MutationResult<ContinueWithAnketaMutation>;
export type ContinueWithAnketaMutationOptions = Apollo.BaseMutationOptions<ContinueWithAnketaMutation, ContinueWithAnketaMutationVariables>;
export const MockDocument = gql`
    mutation mock($key: String!) {
  mock(key: $key)
}
    `;
export type MockMutationFn = Apollo.MutationFunction<MockMutation, MockMutationVariables>;

/**
 * __useMockMutation__
 *
 * To run a mutation, you first call `useMockMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMockMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mockMutation, { data, loading, error }] = useMockMutation({
 *   variables: {
 *      key: // value for 'key'
 *   },
 * });
 */
export function useMockMutation(baseOptions?: Apollo.MutationHookOptions<MockMutation, MockMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MockMutation, MockMutationVariables>(MockDocument, options);
      }
export type MockMutationHookResult = ReturnType<typeof useMockMutation>;
export type MockMutationResult = Apollo.MutationResult<MockMutation>;
export type MockMutationOptions = Apollo.BaseMutationOptions<MockMutation, MockMutationVariables>;
export const EnterAddendumModeDocument = gql`
    mutation enterAddendumMode($id: Int!, $life: Boolean, $property: Boolean, $titul: Boolean) {
  enterAddendumMode(id: $id, life: $life, property: $property, titul: $titul)
}
    `;
export type EnterAddendumModeMutationFn = Apollo.MutationFunction<EnterAddendumModeMutation, EnterAddendumModeMutationVariables>;

/**
 * __useEnterAddendumModeMutation__
 *
 * To run a mutation, you first call `useEnterAddendumModeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnterAddendumModeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [enterAddendumModeMutation, { data, loading, error }] = useEnterAddendumModeMutation({
 *   variables: {
 *      id: // value for 'id'
 *      life: // value for 'life'
 *      property: // value for 'property'
 *      titul: // value for 'titul'
 *   },
 * });
 */
export function useEnterAddendumModeMutation(baseOptions?: Apollo.MutationHookOptions<EnterAddendumModeMutation, EnterAddendumModeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EnterAddendumModeMutation, EnterAddendumModeMutationVariables>(EnterAddendumModeDocument, options);
      }
export type EnterAddendumModeMutationHookResult = ReturnType<typeof useEnterAddendumModeMutation>;
export type EnterAddendumModeMutationResult = Apollo.MutationResult<EnterAddendumModeMutation>;
export type EnterAddendumModeMutationOptions = Apollo.BaseMutationOptions<EnterAddendumModeMutation, EnterAddendumModeMutationVariables>;
export const CopyAnketaForAgreementDocument = gql`
    mutation copyAnketaForAgreement($id: Int!, $anketaIsn: Int!, $forEdit: Boolean) {
  copyAnketaForAgreement(id: $id, anketaIsn: $anketaIsn, forEdit: $forEdit)
}
    `;
export type CopyAnketaForAgreementMutationFn = Apollo.MutationFunction<CopyAnketaForAgreementMutation, CopyAnketaForAgreementMutationVariables>;

/**
 * __useCopyAnketaForAgreementMutation__
 *
 * To run a mutation, you first call `useCopyAnketaForAgreementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCopyAnketaForAgreementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [copyAnketaForAgreementMutation, { data, loading, error }] = useCopyAnketaForAgreementMutation({
 *   variables: {
 *      id: // value for 'id'
 *      anketaIsn: // value for 'anketaIsn'
 *      forEdit: // value for 'forEdit'
 *   },
 * });
 */
export function useCopyAnketaForAgreementMutation(baseOptions?: Apollo.MutationHookOptions<CopyAnketaForAgreementMutation, CopyAnketaForAgreementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CopyAnketaForAgreementMutation, CopyAnketaForAgreementMutationVariables>(CopyAnketaForAgreementDocument, options);
      }
export type CopyAnketaForAgreementMutationHookResult = ReturnType<typeof useCopyAnketaForAgreementMutation>;
export type CopyAnketaForAgreementMutationResult = Apollo.MutationResult<CopyAnketaForAgreementMutation>;
export type CopyAnketaForAgreementMutationOptions = Apollo.BaseMutationOptions<CopyAnketaForAgreementMutation, CopyAnketaForAgreementMutationVariables>;
export const UploadFilesDocument = gql`
    mutation uploadFiles($id: Int!) {
  uploadFiles(id: $id)
}
    `;
export type UploadFilesMutationFn = Apollo.MutationFunction<UploadFilesMutation, UploadFilesMutationVariables>;

/**
 * __useUploadFilesMutation__
 *
 * To run a mutation, you first call `useUploadFilesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadFilesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadFilesMutation, { data, loading, error }] = useUploadFilesMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUploadFilesMutation(baseOptions?: Apollo.MutationHookOptions<UploadFilesMutation, UploadFilesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadFilesMutation, UploadFilesMutationVariables>(UploadFilesDocument, options);
      }
export type UploadFilesMutationHookResult = ReturnType<typeof useUploadFilesMutation>;
export type UploadFilesMutationResult = Apollo.MutationResult<UploadFilesMutation>;
export type UploadFilesMutationOptions = Apollo.BaseMutationOptions<UploadFilesMutation, UploadFilesMutationVariables>;
export const CalculateAgreementFinishDocument = gql`
    mutation calculateAgreementFinish($id: Int!) {
  calculateAgreementFinish(id: $id)
}
    `;
export type CalculateAgreementFinishMutationFn = Apollo.MutationFunction<CalculateAgreementFinishMutation, CalculateAgreementFinishMutationVariables>;

/**
 * __useCalculateAgreementFinishMutation__
 *
 * To run a mutation, you first call `useCalculateAgreementFinishMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCalculateAgreementFinishMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [calculateAgreementFinishMutation, { data, loading, error }] = useCalculateAgreementFinishMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCalculateAgreementFinishMutation(baseOptions?: Apollo.MutationHookOptions<CalculateAgreementFinishMutation, CalculateAgreementFinishMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CalculateAgreementFinishMutation, CalculateAgreementFinishMutationVariables>(CalculateAgreementFinishDocument, options);
      }
export type CalculateAgreementFinishMutationHookResult = ReturnType<typeof useCalculateAgreementFinishMutation>;
export type CalculateAgreementFinishMutationResult = Apollo.MutationResult<CalculateAgreementFinishMutation>;
export type CalculateAgreementFinishMutationOptions = Apollo.BaseMutationOptions<CalculateAgreementFinishMutation, CalculateAgreementFinishMutationVariables>;
export const CreateReportDocument = gql`
    mutation createReport($reportType: String!, $dateBeg: String, $dateEnd: String, $frontNodeIsn: Int) {
  createReport(
    reportType: $reportType
    dateBeg: $dateBeg
    dateEnd: $dateEnd
    frontNodeIsn: $frontNodeIsn
  ) {
    id
    filename
    url
  }
}
    `;
export type CreateReportMutationFn = Apollo.MutationFunction<CreateReportMutation, CreateReportMutationVariables>;

/**
 * __useCreateReportMutation__
 *
 * To run a mutation, you first call `useCreateReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createReportMutation, { data, loading, error }] = useCreateReportMutation({
 *   variables: {
 *      reportType: // value for 'reportType'
 *      dateBeg: // value for 'dateBeg'
 *      dateEnd: // value for 'dateEnd'
 *      frontNodeIsn: // value for 'frontNodeIsn'
 *   },
 * });
 */
export function useCreateReportMutation(baseOptions?: Apollo.MutationHookOptions<CreateReportMutation, CreateReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateReportMutation, CreateReportMutationVariables>(CreateReportDocument, options);
      }
export type CreateReportMutationHookResult = ReturnType<typeof useCreateReportMutation>;
export type CreateReportMutationResult = Apollo.MutationResult<CreateReportMutation>;
export type CreateReportMutationOptions = Apollo.BaseMutationOptions<CreateReportMutation, CreateReportMutationVariables>;
export const MarkMessageDocument = gql`
    mutation markMessage($id: Int!) {
  markMessage(id: $id)
}
    `;
export type MarkMessageMutationFn = Apollo.MutationFunction<MarkMessageMutation, MarkMessageMutationVariables>;

/**
 * __useMarkMessageMutation__
 *
 * To run a mutation, you first call `useMarkMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markMessageMutation, { data, loading, error }] = useMarkMessageMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMarkMessageMutation(baseOptions?: Apollo.MutationHookOptions<MarkMessageMutation, MarkMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkMessageMutation, MarkMessageMutationVariables>(MarkMessageDocument, options);
      }
export type MarkMessageMutationHookResult = ReturnType<typeof useMarkMessageMutation>;
export type MarkMessageMutationResult = Apollo.MutationResult<MarkMessageMutation>;
export type MarkMessageMutationOptions = Apollo.BaseMutationOptions<MarkMessageMutation, MarkMessageMutationVariables>;
export const MeDocument = gql`
    query me {
  me {
    user {
      id
      type
      full_name
      username
      email
      phone
      email
      isSuper
      isAdmin
      show_kv
      role {
        id
      }
      group {
        id
        curator {
          email
          phone
          username
        }
        is_filial
      }
      permissions
      restrictions {
        tag
        value
      }
      banksOk
      crossEnabled
      flatEnabled
      isStaffMember
    }
    adminUser {
      id
      username
    }
  }
}
    `;

/**
 * __useMeQuery__
 *
 * To run a query within a React component, call `useMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeQuery({
 *   variables: {
 *   },
 * });
 */
export function useMeQuery(baseOptions?: Apollo.QueryHookOptions<MeQuery, MeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MeQuery, MeQueryVariables>(MeDocument, options);
      }
export function useMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MeQuery, MeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MeQuery, MeQueryVariables>(MeDocument, options);
        }
export type MeQueryHookResult = ReturnType<typeof useMeQuery>;
export type MeLazyQueryHookResult = ReturnType<typeof useMeLazyQuery>;
export type MeQueryResult = Apollo.QueryResult<MeQuery, MeQueryVariables>;
export const DashboardInfoDocument = gql`
    query dashboardInfo {
  dashboard {
    agreements {
      count
      status
    }
    contracts {
      count
      status
    }
  }
}
    `;

/**
 * __useDashboardInfoQuery__
 *
 * To run a query within a React component, call `useDashboardInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useDashboardInfoQuery(baseOptions?: Apollo.QueryHookOptions<DashboardInfoQuery, DashboardInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DashboardInfoQuery, DashboardInfoQueryVariables>(DashboardInfoDocument, options);
      }
export function useDashboardInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DashboardInfoQuery, DashboardInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DashboardInfoQuery, DashboardInfoQueryVariables>(DashboardInfoDocument, options);
        }
export type DashboardInfoQueryHookResult = ReturnType<typeof useDashboardInfoQuery>;
export type DashboardInfoLazyQueryHookResult = ReturnType<typeof useDashboardInfoLazyQuery>;
export type DashboardInfoQueryResult = Apollo.QueryResult<DashboardInfoQuery, DashboardInfoQueryVariables>;
export const RolesDocument = gql`
    query roles($ids: [Int]) {
  roles(ids: $ids) {
    id
    name
    permissions {
      id
      name
      tag
    }
    permission_ids
    users_count
  }
}
    `;

/**
 * __useRolesQuery__
 *
 * To run a query within a React component, call `useRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRolesQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useRolesQuery(baseOptions?: Apollo.QueryHookOptions<RolesQuery, RolesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RolesQuery, RolesQueryVariables>(RolesDocument, options);
      }
export function useRolesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RolesQuery, RolesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RolesQuery, RolesQueryVariables>(RolesDocument, options);
        }
export type RolesQueryHookResult = ReturnType<typeof useRolesQuery>;
export type RolesLazyQueryHookResult = ReturnType<typeof useRolesLazyQuery>;
export type RolesQueryResult = Apollo.QueryResult<RolesQuery, RolesQueryVariables>;
export const PermissionsDocument = gql`
    query permissions {
  permissions {
    id
    name
    tag
  }
}
    `;

/**
 * __usePermissionsQuery__
 *
 * To run a query within a React component, call `usePermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePermissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePermissionsQuery({
 *   variables: {
 *   },
 * });
 */
export function usePermissionsQuery(baseOptions?: Apollo.QueryHookOptions<PermissionsQuery, PermissionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PermissionsQuery, PermissionsQueryVariables>(PermissionsDocument, options);
      }
export function usePermissionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PermissionsQuery, PermissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PermissionsQuery, PermissionsQueryVariables>(PermissionsDocument, options);
        }
export type PermissionsQueryHookResult = ReturnType<typeof usePermissionsQuery>;
export type PermissionsLazyQueryHookResult = ReturnType<typeof usePermissionsLazyQuery>;
export type PermissionsQueryResult = Apollo.QueryResult<PermissionsQuery, PermissionsQueryVariables>;
export const GroupsDocument = gql`
    query groups($ids: [Int]) {
  groups(ids: $ids) {
    id
    parent_id
    name
    email
    restrictions {
      tag
      value
    }
    curator {
      ...Person
    }
    leader {
      ...Person
    }
  }
}
    ${PersonFragmentDoc}`;

/**
 * __useGroupsQuery__
 *
 * To run a query within a React component, call `useGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGroupsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useGroupsQuery(baseOptions?: Apollo.QueryHookOptions<GroupsQuery, GroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GroupsQuery, GroupsQueryVariables>(GroupsDocument, options);
      }
export function useGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GroupsQuery, GroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GroupsQuery, GroupsQueryVariables>(GroupsDocument, options);
        }
export type GroupsQueryHookResult = ReturnType<typeof useGroupsQuery>;
export type GroupsLazyQueryHookResult = ReturnType<typeof useGroupsLazyQuery>;
export type GroupsQueryResult = Apollo.QueryResult<GroupsQuery, GroupsQueryVariables>;
export const UsersDocument = gql`
    query users($ids: [Int], $roleId: Int) {
  users(ids: $ids, roleId: $roleId) {
    id
    email
    phone
    full_name
    username
    type
    isSuper
    group_id
    is_enabled
    restrictions {
      tag
      value
    }
    show_kv
    is_restricted
    role {
      id
      name
    }
    token
    remark
  }
}
    `;

/**
 * __useUsersQuery__
 *
 * To run a query within a React component, call `useUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUsersQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *      roleId: // value for 'roleId'
 *   },
 * });
 */
export function useUsersQuery(baseOptions?: Apollo.QueryHookOptions<UsersQuery, UsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UsersQuery, UsersQueryVariables>(UsersDocument, options);
      }
export function useUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UsersQuery, UsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UsersQuery, UsersQueryVariables>(UsersDocument, options);
        }
export type UsersQueryHookResult = ReturnType<typeof useUsersQuery>;
export type UsersLazyQueryHookResult = ReturnType<typeof useUsersLazyQuery>;
export type UsersQueryResult = Apollo.QueryResult<UsersQuery, UsersQueryVariables>;
export const DictDocument = gql`
    query dict($key: DictKeyEnum!) {
  dict(key: $key) {
    isn
    name
    extra
  }
}
    `;

/**
 * __useDictQuery__
 *
 * To run a query within a React component, call `useDictQuery` and pass it any options that fit your needs.
 * When your component renders, `useDictQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDictQuery({
 *   variables: {
 *      key: // value for 'key'
 *   },
 * });
 */
export function useDictQuery(baseOptions: Apollo.QueryHookOptions<DictQuery, DictQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DictQuery, DictQueryVariables>(DictDocument, options);
      }
export function useDictLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DictQuery, DictQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DictQuery, DictQueryVariables>(DictDocument, options);
        }
export type DictQueryHookResult = ReturnType<typeof useDictQuery>;
export type DictLazyQueryHookResult = ReturnType<typeof useDictLazyQuery>;
export type DictQueryResult = Apollo.QueryResult<DictQuery, DictQueryVariables>;
export const DocsDocument = gql`
    query docs($limit: Int, $page: Int, $type: DocTypeEnum, $isn: String, $filter: DocFilterInput, $product: String) {
  docs(
    limit: $limit
    page: $page
    type: $type
    isn: $isn
    filter: $filter
    product: $product
  ) {
    data {
      id
      isn
      number
      type
      creditSumm
      bankName
      insurerName
      status {
        value
        label
        color
      }
      user {
        ...Person
      }
      groupPath
      added
      edited
      editor {
        ...Person
      }
      isnInvoice
      needProlongation
      isProlongation
      calcForm {
        stage
      }
      underwriters {
        ...Person
      }
      fillingType
      product
      flatObject
      flatRisks
    }
    total
  }
}
    ${PersonFragmentDoc}`;

/**
 * __useDocsQuery__
 *
 * To run a query within a React component, call `useDocsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDocsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDocsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      page: // value for 'page'
 *      type: // value for 'type'
 *      isn: // value for 'isn'
 *      filter: // value for 'filter'
 *      product: // value for 'product'
 *   },
 * });
 */
export function useDocsQuery(baseOptions?: Apollo.QueryHookOptions<DocsQuery, DocsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DocsQuery, DocsQueryVariables>(DocsDocument, options);
      }
export function useDocsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DocsQuery, DocsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DocsQuery, DocsQueryVariables>(DocsDocument, options);
        }
export type DocsQueryHookResult = ReturnType<typeof useDocsQuery>;
export type DocsLazyQueryHookResult = ReturnType<typeof useDocsLazyQuery>;
export type DocsQueryResult = Apollo.QueryResult<DocsQuery, DocsQueryVariables>;
export const StatusesDocument = gql`
    query statuses {
  statuses {
    value
    label
    color
  }
}
    `;

/**
 * __useStatusesQuery__
 *
 * To run a query within a React component, call `useStatusesQuery` and pass it any options that fit your needs.
 * When your component renders, `useStatusesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStatusesQuery({
 *   variables: {
 *   },
 * });
 */
export function useStatusesQuery(baseOptions?: Apollo.QueryHookOptions<StatusesQuery, StatusesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StatusesQuery, StatusesQueryVariables>(StatusesDocument, options);
      }
export function useStatusesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StatusesQuery, StatusesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StatusesQuery, StatusesQueryVariables>(StatusesDocument, options);
        }
export type StatusesQueryHookResult = ReturnType<typeof useStatusesQuery>;
export type StatusesLazyQueryHookResult = ReturnType<typeof useStatusesLazyQuery>;
export type StatusesQueryResult = Apollo.QueryResult<StatusesQuery, StatusesQueryVariables>;
export const PrecalcDocument = gql`
    mutation precalc($precalcForm: PreCalcFormInput) {
  precalc(precalcForm: $precalcForm) {
    isn
    sum
    total
    bank {
      isn
      name
      icon
    }
    risks {
      name
      borrowers {
        need_medical_checkup
        name
        tariff
        premium_sum
      }
      sum
    }
    isExpressDeclarationAvailable
    noExpressDeclarationReason
    crossId
    warning
    oldPremium
    insuranceType
    allowDiscount
    result_discount
  }
}
    `;
export type PrecalcMutationFn = Apollo.MutationFunction<PrecalcMutation, PrecalcMutationVariables>;

/**
 * __usePrecalcMutation__
 *
 * To run a mutation, you first call `usePrecalcMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePrecalcMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [precalcMutation, { data, loading, error }] = usePrecalcMutation({
 *   variables: {
 *      precalcForm: // value for 'precalcForm'
 *   },
 * });
 */
export function usePrecalcMutation(baseOptions?: Apollo.MutationHookOptions<PrecalcMutation, PrecalcMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PrecalcMutation, PrecalcMutationVariables>(PrecalcDocument, options);
      }
export type PrecalcMutationHookResult = ReturnType<typeof usePrecalcMutation>;
export type PrecalcMutationResult = Apollo.MutationResult<PrecalcMutation>;
export type PrecalcMutationOptions = Apollo.BaseMutationOptions<PrecalcMutation, PrecalcMutationVariables>;
export const LoadAgreementDocument = gql`
    query loadAgreement($id: Int) {
  loadAgreement(id: $id) {
    id
    steps
    showFields
    calcForm {
      stage
      riskLife
      riskProperty
      riskTitle
      policyholder {
        ...Contragent
      }
      policyholderIsBorrower
      borrower {
        ...Contragent
      }
      credit {
        insuranceType
        city {
          ...Address
        }
        bank {
          ...Select
        }
        creditSum
        creditTerms
        creditRate
        creditIssueDate
        creditAgreementNumber
        dateBegin
        dateExactEnd
        periodTypeChoose
        firstPayDate
        salesChannel {
          ...Select
        }
        agent {
          ...Select
        }
        prevSk {
          ...Select
        }
        renewReason {
          ...Select
        }
        renewReasonOther
        borrowerShare
        birthDateMethod {
          ...Select
        }
        marketing {
          ...Select
        }
      }
      coBorrowers {
        ...Contragent
      }
      propertyObjects {
        propertyPledge {
          ...Select
        }
        propertyAddressMatch
        propertyPledgeAddress {
          ...Address
        }
        pledgeCadastralNumber
        pledgeAddressEgrn
        propertySumInsured
        pledgeShare
        objectCost
        objectCostByContract
        agency
        nameOfAppraiser
        area
        roomsCount
        floor
        floorCount
        buildYear
        yearOfCapitalRepair
        wallMaterial {
          ...Select
        }
        floorMaterial {
          ...Select
        }
        woodInConstruction
        alarm {
          ...Select
        }
        alarmInfo
        openFire {
          ...Select
        }
        openFireInfo
        additionalRisks {
          ...Select
        }
        purpose {
          ...Select
        }
        additionalRisksInfo
        objectOfUnfinishedConstruction
        repairPlanning
        repairIntervalFrom
        repairIntervalTo
        riskCoefficient
        basementOrAttic
        interiorDecoration
        replanPlanning
        replanIntervalFrom
        replanIntervalTo
        rent
        damage
      }
      titleObjects {
        titleAddress {
          ...Address
        }
        titleCadastralNumber
        titleShare
        objectEncumbrances
        minors
        unregisterPersons
        litigation
        addressEgrn
        typeEncumbrances
      }
      flat {
        date_begin
        structural_elements
        finishing
        movable_property
        civil_responsibility
        lease
        renovation
        alarm_security
        alarm_fire
        leakage_protection
        seller_discount_due_kv
        promo_code
        build_year
        address {
          ...Address
        }
        address_match
        area
        rooms_count
        policy_holder {
          ...Contragent
        }
        premium_sum
        old_premium_sum
      }
      precalcResult
    }
    declarationAvailable
    createAgreementAvailable
    agreementDeclarationDone
    isExpressMode
    isAddendumMode
    files {
      id
      filename
      url
    }
    isn
    product
    draftSubtitle
  }
}
    ${ContragentFragmentDoc}
${AddressFragmentDoc}
${SelectFragmentDoc}`;

/**
 * __useLoadAgreementQuery__
 *
 * To run a query within a React component, call `useLoadAgreementQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoadAgreementQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoadAgreementQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLoadAgreementQuery(baseOptions?: Apollo.QueryHookOptions<LoadAgreementQuery, LoadAgreementQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LoadAgreementQuery, LoadAgreementQueryVariables>(LoadAgreementDocument, options);
      }
export function useLoadAgreementLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LoadAgreementQuery, LoadAgreementQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LoadAgreementQuery, LoadAgreementQueryVariables>(LoadAgreementDocument, options);
        }
export type LoadAgreementQueryHookResult = ReturnType<typeof useLoadAgreementQuery>;
export type LoadAgreementLazyQueryHookResult = ReturnType<typeof useLoadAgreementLazyQuery>;
export type LoadAgreementQueryResult = Apollo.QueryResult<LoadAgreementQuery, LoadAgreementQueryVariables>;
export const LoadAgreementUnderwritingDocument = gql`
    query loadAgreementUnderwriting($id: Int) {
  loadAgreement(id: $id) {
    id
    number
    added
    relatedAgreementId
    status {
      label
      value
      color
    }
    user {
      id
      isSuper
      username
      group {
        id
        name
      }
    }
    calcForm {
      riskLife
      riskProperty
      riskTitle
    }
    calculation {
      policyholder_fio
      policyholder_birthday
      policyholder_email
      beneficiary
      credit_terms
      premium_sum
      premium_sum_with_kv
      discount_kv
      seller_discount_due_kv
      discount_kv_sum
      agent
      bank_kv
      tariff_group {
        label
        value
      }
      program {
        label
        value
      }
      life_risks {
        isn
        fio
        birthday
        type
        address
        property_cost
        status
        limit_sum
        base_tariff
        base_premium_sum
        raising_factor
        discount
        tariff
        premium_sum
        high_tariff_height
        high_tariff_press
        share
        remark
        autoscoring
        underwriting_allowed
      }
      property_risks {
        isn
        fio
        birthday
        type
        address
        property_cost
        status
        limit_sum
        base_tariff
        base_premium_sum
        raising_factor
        discount
        tariff
        premium_sum
        high_tariff_height
        high_tariff_press
        share
        autoscoring
        underwriting_allowed
        wood_in_construction
      }
      titul_risks {
        isn
        fio
        birthday
        type
        address
        property_cost
        status
        limit_sum
        base_tariff
        base_premium_sum
        raising_factor
        discount
        tariff
        premium_sum
        high_tariff_height
        high_tariff_press
        share
        autoscoring
        underwriting_allowed
      }
      cross_risks {
        isn
        fio
        birthday
        type
        address
        property_cost
        status
        limit_sum
        base_tariff
        base_premium_sum
        raising_factor
        discount
        tariff
        premium_sum
        high_tariff_height
        high_tariff_press
        share
        autoscoring
        underwriting_allowed
      }
      is_editable_tariff
    }
    resultDocuments {
      name
      type
      isn
      templateIsn
      subject
      warning
    }
    underwriters {
      id
      username
    }
    fillingTypeText
  }
}
    `;

/**
 * __useLoadAgreementUnderwritingQuery__
 *
 * To run a query within a React component, call `useLoadAgreementUnderwritingQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoadAgreementUnderwritingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoadAgreementUnderwritingQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLoadAgreementUnderwritingQuery(baseOptions?: Apollo.QueryHookOptions<LoadAgreementUnderwritingQuery, LoadAgreementUnderwritingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LoadAgreementUnderwritingQuery, LoadAgreementUnderwritingQueryVariables>(LoadAgreementUnderwritingDocument, options);
      }
export function useLoadAgreementUnderwritingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LoadAgreementUnderwritingQuery, LoadAgreementUnderwritingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LoadAgreementUnderwritingQuery, LoadAgreementUnderwritingQueryVariables>(LoadAgreementUnderwritingDocument, options);
        }
export type LoadAgreementUnderwritingQueryHookResult = ReturnType<typeof useLoadAgreementUnderwritingQuery>;
export type LoadAgreementUnderwritingLazyQueryHookResult = ReturnType<typeof useLoadAgreementUnderwritingLazyQuery>;
export type LoadAgreementUnderwritingQueryResult = Apollo.QueryResult<LoadAgreementUnderwritingQuery, LoadAgreementUnderwritingQueryVariables>;
export const LoadContractDocument = gql`
    query loadContract($id: Int) {
  loadAgreement(id: $id) {
    id
    number
    isn
    added
    relatedCalculationId
    status {
      label
      value
      color
    }
    user {
      id
      isSuper
      username
      group {
        id
        name
      }
    }
    calculation {
      premium_sum
      premium_sum_with_kv
      discount_kv
    }
    agreement {
      premium_sum
      premium_sum_with_kv
      discount_kv
      seller_discount_due_kv
      agreement_no
      credit_months
      credit_rate
      currency
      date_sign
      date_begin
      date_end
      policyholder {
        ...Contragent
      }
      ins_purpose {
        label
        value
      }
      credit_bank_text
      credit_bank_isn
      bank_isn
      credit_agreement_number
      credit_agreement_date
      credit_sum
      credit_annuitet_sum
      ins_previous {
        label
        value
      }
      sale_channel {
        label
        value
      }
      agr_role {
        role
        participant
        date_beg
        date_end
      }
      life_risks {
        isn
        fio
        birthday
        type
        address
        property_cost
        status
        limit_sum
        base_tariff
        base_premium_sum
        raising_factor
        discount
        tariff
        premium_sum
        high_tariff_height
        high_tariff_press
        share
        remark
        autoscoring
        underwriting_allowed
      }
      property_risks {
        isn
        fio
        birthday
        type
        address
        property_cost
        status
        limit_sum
        base_tariff
        base_premium_sum
        raising_factor
        discount
        tariff
        premium_sum
        high_tariff_height
        high_tariff_press
        share
        remark
        permanent_sum
        one_time_pay
        autoscoring
        underwriting_allowed
        wood_in_construction
      }
      titul_risks {
        isn
        fio
        birthday
        type
        address
        property_cost
        status
        limit_sum
        base_tariff
        base_premium_sum
        raising_factor
        discount
        tariff
        premium_sum
        high_tariff_height
        high_tariff_press
        share
        remark
        permanent_sum
        one_time_pay
        date_end
        autoscoring
        underwriting_allowed
      }
      is_payed
      has_cross_sale
      is_declaration
      agent_kv_sum
    }
    invoices {
      invoiceIsn
      invoiceNo
      invoiceSum
      summName
      invoiceCaption
      agreementIsn
      agreementNo
      isAlreadyPayed
      types {
        isn
        name
      }
    }
    resultDocuments {
      name
      isn
      type
      templateIsn
      subject
      warning
    }
    readyToSign
    needProlongation
    nextInvoiceAllowed
    isCurrentPeriodPayed
    nextInvoiceSum
    isProlongation
    prevAgreementIsn
    prevAgreementId
    nextAgreementIsn
    agreementDeclarationDone
    isExpressMode
    prevAgreementAnketaIsn
    agreementAnketaIsn
    agreementAnketaEdit
    subAgreements {
      name
      status {
        label
        value
        color
      }
      payed
      created_at
      premium_sum
    }
    crossSale {
      number
      sign
      begin
      end
      premium_sum
    }
    product
  }
}
    ${ContragentFragmentDoc}`;

/**
 * __useLoadContractQuery__
 *
 * To run a query within a React component, call `useLoadContractQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoadContractQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoadContractQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLoadContractQuery(baseOptions?: Apollo.QueryHookOptions<LoadContractQuery, LoadContractQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LoadContractQuery, LoadContractQueryVariables>(LoadContractDocument, options);
      }
export function useLoadContractLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LoadContractQuery, LoadContractQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LoadContractQuery, LoadContractQueryVariables>(LoadContractDocument, options);
        }
export type LoadContractQueryHookResult = ReturnType<typeof useLoadContractQuery>;
export type LoadContractLazyQueryHookResult = ReturnType<typeof useLoadContractLazyQuery>;
export type LoadContractQueryResult = Apollo.QueryResult<LoadContractQuery, LoadContractQueryVariables>;
export const LoadFlatContractDocument = gql`
    query loadFlatContract($id: Int) {
  loadAgreement(id: $id) {
    id
    number
    isn
    added
    relatedCalculationId
    status {
      label
      value
      color
    }
    user {
      id
      isSuper
      username
      group {
        id
        name
      }
    }
    calcForm {
      policyholder {
        ...Contragent
      }
      flat {
        date_begin
        structural_elements
        finishing
        movable_property
        civil_responsibility
        lease
        renovation
        alarm_security
        alarm_fire
        leakage_protection
        seller_discount_due_kv
        promo_code
        build_year
        address {
          ...Address
        }
        address_match
        area
        rooms_count
      }
    }
    flatPremiumSum
    agreement {
      is_payed
    }
  }
}
    ${ContragentFragmentDoc}
${AddressFragmentDoc}`;

/**
 * __useLoadFlatContractQuery__
 *
 * To run a query within a React component, call `useLoadFlatContractQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoadFlatContractQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoadFlatContractQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLoadFlatContractQuery(baseOptions?: Apollo.QueryHookOptions<LoadFlatContractQuery, LoadFlatContractQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LoadFlatContractQuery, LoadFlatContractQueryVariables>(LoadFlatContractDocument, options);
      }
export function useLoadFlatContractLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LoadFlatContractQuery, LoadFlatContractQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LoadFlatContractQuery, LoadFlatContractQueryVariables>(LoadFlatContractDocument, options);
        }
export type LoadFlatContractQueryHookResult = ReturnType<typeof useLoadFlatContractQuery>;
export type LoadFlatContractLazyQueryHookResult = ReturnType<typeof useLoadFlatContractLazyQuery>;
export type LoadFlatContractQueryResult = Apollo.QueryResult<LoadFlatContractQuery, LoadFlatContractQueryVariables>;
export const LoadCrossContractDocument = gql`
    query loadCrossContract($id: Int) {
  loadAgreement(id: $id) {
    id
    number
    isn
    added
    status {
      label
      value
      color
    }
    user {
      id
      isSuper
      username
      group {
        id
        name
      }
    }
    agreement {
      premium_sum
      premium_sum_with_kv
      discount_kv
      seller_discount_due_kv
      agreement_no
      credit_months
      credit_rate
      currency
      date_sign
      date_begin
      date_end
      policyholder {
        ...Contragent
      }
      ins_purpose {
        label
        value
      }
      credit_bank_text
      credit_bank_isn
      credit_agreement_number
      credit_agreement_date
      credit_sum
      credit_annuitet_sum
      ins_previous {
        label
        value
      }
      sale_channel {
        label
        value
      }
      agr_role {
        role
        participant
        date_beg
        date_end
      }
      is_payed
      agent_kv_sum
    }
    invoices {
      invoiceIsn
      invoiceNo
      invoiceSum
      summName
      invoiceCaption
      agreementIsn
      agreementNo
      isAlreadyPayed
      types {
        isn
        name
      }
    }
    resultDocuments {
      name
      isn
      type
      templateIsn
      subject
      warning
    }
    product
    crossDetails {
      address
      sum
      interior
      responsibility
      property
    }
  }
}
    ${ContragentFragmentDoc}`;

/**
 * __useLoadCrossContractQuery__
 *
 * To run a query within a React component, call `useLoadCrossContractQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoadCrossContractQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoadCrossContractQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLoadCrossContractQuery(baseOptions?: Apollo.QueryHookOptions<LoadCrossContractQuery, LoadCrossContractQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LoadCrossContractQuery, LoadCrossContractQueryVariables>(LoadCrossContractDocument, options);
      }
export function useLoadCrossContractLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LoadCrossContractQuery, LoadCrossContractQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LoadCrossContractQuery, LoadCrossContractQueryVariables>(LoadCrossContractDocument, options);
        }
export type LoadCrossContractQueryHookResult = ReturnType<typeof useLoadCrossContractQuery>;
export type LoadCrossContractLazyQueryHookResult = ReturnType<typeof useLoadCrossContractLazyQuery>;
export type LoadCrossContractQueryResult = Apollo.QueryResult<LoadCrossContractQuery, LoadCrossContractQueryVariables>;
export const SearchContragentDocument = gql`
    query searchContragent($id: Int, $fullname: String, $birthday: String, $phone: String, $isn: String) {
  searchContragent(
    id: $id
    fullname: $fullname
    birthday: $birthday
    phone: $phone
    isn: $isn
  ) {
    ...Contragent
  }
}
    ${ContragentFragmentDoc}`;

/**
 * __useSearchContragentQuery__
 *
 * To run a query within a React component, call `useSearchContragentQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchContragentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchContragentQuery({
 *   variables: {
 *      id: // value for 'id'
 *      fullname: // value for 'fullname'
 *      birthday: // value for 'birthday'
 *      phone: // value for 'phone'
 *      isn: // value for 'isn'
 *   },
 * });
 */
export function useSearchContragentQuery(baseOptions?: Apollo.QueryHookOptions<SearchContragentQuery, SearchContragentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchContragentQuery, SearchContragentQueryVariables>(SearchContragentDocument, options);
      }
export function useSearchContragentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchContragentQuery, SearchContragentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchContragentQuery, SearchContragentQueryVariables>(SearchContragentDocument, options);
        }
export type SearchContragentQueryHookResult = ReturnType<typeof useSearchContragentQuery>;
export type SearchContragentLazyQueryHookResult = ReturnType<typeof useSearchContragentLazyQuery>;
export type SearchContragentQueryResult = Apollo.QueryResult<SearchContragentQuery, SearchContragentQueryVariables>;
export const LoadMessagesDocument = gql`
    query loadMessages($id: Int) {
  loadAgreement(id: $id) {
    id
    comments {
      id
      text
      date
      user {
        id
        full_name
      }
      isNew
    }
  }
}
    `;

/**
 * __useLoadMessagesQuery__
 *
 * To run a query within a React component, call `useLoadMessagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoadMessagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoadMessagesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLoadMessagesQuery(baseOptions?: Apollo.QueryHookOptions<LoadMessagesQuery, LoadMessagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LoadMessagesQuery, LoadMessagesQueryVariables>(LoadMessagesDocument, options);
      }
export function useLoadMessagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LoadMessagesQuery, LoadMessagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LoadMessagesQuery, LoadMessagesQueryVariables>(LoadMessagesDocument, options);
        }
export type LoadMessagesQueryHookResult = ReturnType<typeof useLoadMessagesQuery>;
export type LoadMessagesLazyQueryHookResult = ReturnType<typeof useLoadMessagesLazyQuery>;
export type LoadMessagesQueryResult = Apollo.QueryResult<LoadMessagesQuery, LoadMessagesQueryVariables>;
export const LoadChangeLogDocument = gql`
    query loadChangeLog($id: Int) {
  loadAgreement(id: $id) {
    id
    activity_log {
      added
      user {
        id
        username
      }
      adminUser {
        id
        username
      }
      event
      eventName
      description
    }
  }
}
    `;

/**
 * __useLoadChangeLogQuery__
 *
 * To run a query within a React component, call `useLoadChangeLogQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoadChangeLogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoadChangeLogQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLoadChangeLogQuery(baseOptions?: Apollo.QueryHookOptions<LoadChangeLogQuery, LoadChangeLogQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LoadChangeLogQuery, LoadChangeLogQueryVariables>(LoadChangeLogDocument, options);
      }
export function useLoadChangeLogLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LoadChangeLogQuery, LoadChangeLogQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LoadChangeLogQuery, LoadChangeLogQueryVariables>(LoadChangeLogDocument, options);
        }
export type LoadChangeLogQueryHookResult = ReturnType<typeof useLoadChangeLogQuery>;
export type LoadChangeLogLazyQueryHookResult = ReturnType<typeof useLoadChangeLogLazyQuery>;
export type LoadChangeLogQueryResult = Apollo.QueryResult<LoadChangeLogQuery, LoadChangeLogQueryVariables>;
export const LoadFilesDocument = gql`
    query loadFiles($id: Int) {
  loadAgreement(id: $id) {
    id
    calcForm {
      riskLife
      riskProperty
      riskTitle
    }
    files {
      id
      filename
      url
    }
  }
}
    `;

/**
 * __useLoadFilesQuery__
 *
 * To run a query within a React component, call `useLoadFilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoadFilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoadFilesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLoadFilesQuery(baseOptions?: Apollo.QueryHookOptions<LoadFilesQuery, LoadFilesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LoadFilesQuery, LoadFilesQueryVariables>(LoadFilesDocument, options);
      }
export function useLoadFilesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LoadFilesQuery, LoadFilesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LoadFilesQuery, LoadFilesQueryVariables>(LoadFilesDocument, options);
        }
export type LoadFilesQueryHookResult = ReturnType<typeof useLoadFilesQuery>;
export type LoadFilesLazyQueryHookResult = ReturnType<typeof useLoadFilesLazyQuery>;
export type LoadFilesQueryResult = Apollo.QueryResult<LoadFilesQuery, LoadFilesQueryVariables>;
export const LoadAnketaDocument = gql`
    query loadAnketa($id: Int) {
  loadAgreement(id: $id) {
    id
    anketa {
      name
      questions {
        question
        answer
      }
    }
  }
}
    `;

/**
 * __useLoadAnketaQuery__
 *
 * To run a query within a React component, call `useLoadAnketaQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoadAnketaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoadAnketaQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLoadAnketaQuery(baseOptions?: Apollo.QueryHookOptions<LoadAnketaQuery, LoadAnketaQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LoadAnketaQuery, LoadAnketaQueryVariables>(LoadAnketaDocument, options);
      }
export function useLoadAnketaLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LoadAnketaQuery, LoadAnketaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LoadAnketaQuery, LoadAnketaQueryVariables>(LoadAnketaDocument, options);
        }
export type LoadAnketaQueryHookResult = ReturnType<typeof useLoadAnketaQuery>;
export type LoadAnketaLazyQueryHookResult = ReturnType<typeof useLoadAnketaLazyQuery>;
export type LoadAnketaQueryResult = Apollo.QueryResult<LoadAnketaQuery, LoadAnketaQueryVariables>;
export const AnketaDocument = gql`
    query anketa($id: Int!, $contragentIsn: Int!) {
  anketa(id: $id, contragentIsn: $contragentIsn) {
    key
    text
    questions {
      isn
      type
      text
      dicti {
        isn
        name
      }
      value
      remark
    }
  }
}
    `;

/**
 * __useAnketaQuery__
 *
 * To run a query within a React component, call `useAnketaQuery` and pass it any options that fit your needs.
 * When your component renders, `useAnketaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAnketaQuery({
 *   variables: {
 *      id: // value for 'id'
 *      contragentIsn: // value for 'contragentIsn'
 *   },
 * });
 */
export function useAnketaQuery(baseOptions: Apollo.QueryHookOptions<AnketaQuery, AnketaQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AnketaQuery, AnketaQueryVariables>(AnketaDocument, options);
      }
export function useAnketaLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AnketaQuery, AnketaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AnketaQuery, AnketaQueryVariables>(AnketaDocument, options);
        }
export type AnketaQueryHookResult = ReturnType<typeof useAnketaQuery>;
export type AnketaLazyQueryHookResult = ReturnType<typeof useAnketaLazyQuery>;
export type AnketaQueryResult = Apollo.QueryResult<AnketaQuery, AnketaQueryVariables>;
export const ChangeLogDocument = gql`
    query changeLog($model: ChangeLogTableEnum, $id: Int!) {
  changeLog(model: $model, id: $id) {
    createdAt
    user {
      id
      name
    }
    fields {
      field
      label
      oldValue
      newValue
    }
    comment
  }
}
    `;

/**
 * __useChangeLogQuery__
 *
 * To run a query within a React component, call `useChangeLogQuery` and pass it any options that fit your needs.
 * When your component renders, `useChangeLogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChangeLogQuery({
 *   variables: {
 *      model: // value for 'model'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useChangeLogQuery(baseOptions: Apollo.QueryHookOptions<ChangeLogQuery, ChangeLogQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ChangeLogQuery, ChangeLogQueryVariables>(ChangeLogDocument, options);
      }
export function useChangeLogLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ChangeLogQuery, ChangeLogQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ChangeLogQuery, ChangeLogQueryVariables>(ChangeLogDocument, options);
        }
export type ChangeLogQueryHookResult = ReturnType<typeof useChangeLogQuery>;
export type ChangeLogLazyQueryHookResult = ReturnType<typeof useChangeLogLazyQuery>;
export type ChangeLogQueryResult = Apollo.QueryResult<ChangeLogQuery, ChangeLogQueryVariables>;
export const AdminMessageDocument = gql`
    query adminMessage {
  adminMessage
}
    `;

/**
 * __useAdminMessageQuery__
 *
 * To run a query within a React component, call `useAdminMessageQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminMessageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminMessageQuery({
 *   variables: {
 *   },
 * });
 */
export function useAdminMessageQuery(baseOptions?: Apollo.QueryHookOptions<AdminMessageQuery, AdminMessageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminMessageQuery, AdminMessageQueryVariables>(AdminMessageDocument, options);
      }
export function useAdminMessageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminMessageQuery, AdminMessageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminMessageQuery, AdminMessageQueryVariables>(AdminMessageDocument, options);
        }
export type AdminMessageQueryHookResult = ReturnType<typeof useAdminMessageQuery>;
export type AdminMessageLazyQueryHookResult = ReturnType<typeof useAdminMessageLazyQuery>;
export type AdminMessageQueryResult = Apollo.QueryResult<AdminMessageQuery, AdminMessageQueryVariables>;
export const MessagesDocument = gql`
    query messages {
  messages {
    id
    text
  }
}
    `;

/**
 * __useMessagesQuery__
 *
 * To run a query within a React component, call `useMessagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMessagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMessagesQuery({
 *   variables: {
 *   },
 * });
 */
export function useMessagesQuery(baseOptions?: Apollo.QueryHookOptions<MessagesQuery, MessagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MessagesQuery, MessagesQueryVariables>(MessagesDocument, options);
      }
export function useMessagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MessagesQuery, MessagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MessagesQuery, MessagesQueryVariables>(MessagesDocument, options);
        }
export type MessagesQueryHookResult = ReturnType<typeof useMessagesQuery>;
export type MessagesLazyQueryHookResult = ReturnType<typeof useMessagesLazyQuery>;
export type MessagesQueryResult = Apollo.QueryResult<MessagesQuery, MessagesQueryVariables>;